/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Import API
 * OpenAPI spec version: All
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Activity,
  AuctionCreate,
  AuctionDetail,
  AuctionManage,
  AuctionStageDelete,
  AuctionStageDetailRvi,
  AuctionStageDetailSupplier,
  AuctionStageOfferCreate,
  AuctionStageOfferSelection,
  AuctionStageOfferUpdate,
  AuctionStageStop,
  AuctionSupplierProgramTemplate,
  AuctionSupplierProgramTemplateCreateUpdate,
  AuctionUpdate,
  BananaOffer,
  BananaOfferList,
  BananaProductList,
  Comment,
  CommentList,
  ContractorCreate,
  ContractorList,
  ContractorManage,
  ContractorUpdate,
  DataForExternalCalculator,
  DeliveryPoint,
  DeliveryPointItem,
  DeliveryPointItemForExtCalc,
  DeliveryPointVolume,
  DeliveryPointVolumeKMTS,
  ErrorDetail,
  EventAtObjectManage,
  EventFilterEventTypes,
  EventManage,
  EventManageResponse,
  ExtCalcReferenceValues,
  FeatureToggles,
  FilterValues,
  GeoCustomsEntryPoint,
  GetAuctionsFiltersFilterNameParams,
  GetAuctionsParams,
  GetAuctionsSupplierFiltersFilterNameParams,
  GetAuctionsSupplierParams,
  GetAuctionsSupplierProgramTemplatesParams,
  GetCommentsParams,
  GetCommentsUnseenCountersParams,
  GetCoreCustomsEntryPointsParams,
  GetCoreOffersExcelParams,
  GetCoreOffersExportExcelCalcParams,
  GetCoreOffersForExtCalcIdParams,
  GetCoreOffersForExtCalcParams,
  GetCoreOffersNewFiltersFilterNameParams,
  GetCoreOffersNewParams,
  GetCoreOffersParams,
  GetCorePointToPointPricesParams,
  GetCoreProgramOffersFiltersFilterNameParams,
  GetCoreProgramOffersParams,
  GetCoreTemplatesParams,
  GetCoreWeekActivitiesParams,
  GetEventsParams,
  GetGuidesOfferSizesParams,
  GetGuidesOfferSortsParams,
  GetMixParams,
  GetOrderParams,
  GetOrderStatusesParams,
  GetProductsCustomDutiesExportImportParams,
  GetProductsCustomDutiesParams,
  GetProductsForExtCalcParams,
  GetProductsGroupsParams,
  GetProductsIdAvailableDeliveryPointsParams,
  GetProductsIdOffersParams,
  GetProductsIdVolumesParams,
  GetProductsParams,
  GetProgramsFiltersFilterNameParams,
  GetProgramsParams,
  GetQaProductsParams,
  GetQaSuppliersParams,
  GetQaUsersParams,
  GetRegularDemandsFiltersFilterNameParams,
  GetRegularDemandsParams,
  GetReportsParams,
  GetSupplierFiltersFilterNameParams,
  GetSupplierIdAvailableProductsParams,
  GetSupplierPaginatedParams,
  GetSupplierParams,
  GetUserContractorsFiltersFilterNameParams,
  GetUserContractorsPaginatedParams,
  GetUserContractorsParams,
  GetUserFilterPresetsParams,
  GetVolumesDeliveryPointVolumeParams,
  GetVolumesParams,
  LoadPricesFromExcelTask,
  LoadPricesFromExcelTaskSimple,
  LogosOrderStatusList,
  LogosOrderUpdate,
  LogosOrdersBulk,
  LogosOrdersExportResponse,
  ManageActionResult,
  MixCreate,
  MixDetailMeta,
  MixManage,
  MixOrder,
  MixUpdateMeta,
  OTPVerify,
  Offer,
  OfferCalculatedPrices,
  OfferCreate,
  OfferForProductList,
  OfferMixOrderChoice,
  OfferReferenceValues,
  OfferSendKMTS,
  OfferSizeList,
  OfferSortSizeList,
  OfferStatus,
  OfferStatusApprove,
  OfferStatusApproveBusi,
  OfferStatusDelete,
  OfferStatusRefuse,
  OfferStatusRefuseBusi,
  OfferStatusTrading,
  OfferTemplate,
  OfferTemplateCreate,
  OfferTemplateList,
  OfferTemplateUpdate,
  OfferToExcel,
  PaginatedAuctionRviListList,
  PaginatedAuctionSupplierListList,
  PaginatedContractorListList,
  PaginatedEventList,
  PaginatedLogosOrderListList,
  PaginatedMixItemList,
  PaginatedOfferNewList,
  PaginatedProductCustomDutyList,
  PaginatedProgramOfferNewList,
  PaginatedRegularDemandList,
  PaginatedReportList,
  PaginatedSupplierPaginatedListList,
  PaginatedSupplyProgramListMetaList,
  PaginatedTestingProductList,
  PasswordReset,
  PasswordResetToken,
  PasswordResetUsername,
  PatchedAuctionStageOfferSelection,
  PatchedLogosOrderUpdate,
  PatchedMixOrder,
  PatchedOfferSendKMTS,
  PatchedOfferTemplateUpdate,
  PatchedOfferUpdateMeta,
  PatchedProductManage,
  PatchedProductUpdate,
  PatchedSupplyProgramTableUpdate,
  PatchedTestingAuction,
  PatchedTestingOfferStatus,
  PatchedTestingUserProducts,
  PatchedTestingUserUpdate,
  PatchedUser,
  PatchedUserFilterPreset,
  PointInlineWithPriceFlag,
  PointToPointPrice,
  PostProductsCustomDutiesExportImportParams,
  Product,
  ProductBase,
  ProductCreate,
  ProductDataForExternalCalculator,
  ProductListAPI,
  ProductUpdate,
  ProductVolume,
  ProductVolumes,
  ProductsGroup,
  Region,
  RegularDemandUpload,
  Result,
  Supplier,
  SupplierCreateUpdate,
  SupplierList,
  SupplierManage,
  SupplierProductsList,
  SupplierSimple,
  SupplierUpdateUsersProducts,
  SupplyProgramCreateUpdate,
  SupplyProgramDetail,
  SupplyProgramDetailMeta,
  SupplyProgramManage,
  SupplyProgramTableUpdate,
  SupplyProgramTsApprove,
  SystemInfo,
  TestingAuction,
  TestingOfferStatus,
  TestingProduct,
  TestingSize,
  TestingSort,
  TestingSupplier,
  TestingUser,
  TestingUserToken,
  TestingUserUpdate,
  TradingRange,
  UnseenCommentsCounters,
  User,
  UserBase,
  UserFilterPreset,
  UserLogin,
  UserLoginResponse
} from './types';

import getAuctionsMutator from '../axios';
import type { ErrorType as GetAuctionsErrorType } from '../axios';
import postAuctionsMutator from '../axios';
import type { ErrorType as PostAuctionsErrorType } from '../axios';
import getAuctionsAuctionPkStagesIdMutator from '../axios';
import type { ErrorType as GetAuctionsAuctionPkStagesIdErrorType } from '../axios';
import postAuctionsAuctionPkStagesIdDeleteMutator from '../axios';
import type { ErrorType as PostAuctionsAuctionPkStagesIdDeleteErrorType } from '../axios';
import postAuctionsAuctionPkStagesIdRestartMutator from '../axios';
import type { ErrorType as PostAuctionsAuctionPkStagesIdRestartErrorType } from '../axios';
import postAuctionsAuctionPkStagesIdStopMutator from '../axios';
import type { ErrorType as PostAuctionsAuctionPkStagesIdStopErrorType } from '../axios';
import getAuctionsAuctionPkSupplierStagesIdMutator from '../axios';
import type { ErrorType as GetAuctionsAuctionPkSupplierStagesIdErrorType } from '../axios';
import postAuctionsAuctionPkSupplierStagesIdOfferMutator from '../axios';
import type { ErrorType as PostAuctionsAuctionPkSupplierStagesIdOfferErrorType } from '../axios';
import putAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutator from '../axios';
import type { ErrorType as PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdErrorType } from '../axios';
import getAuctionsIdMutator from '../axios';
import type { ErrorType as GetAuctionsIdErrorType } from '../axios';
import putAuctionsIdMutator from '../axios';
import type { ErrorType as PutAuctionsIdErrorType } from '../axios';
import deleteAuctionsIdMutator from '../axios';
import type { ErrorType as DeleteAuctionsIdErrorType } from '../axios';
import postAuctionsIdCancelMutator from '../axios';
import type { ErrorType as PostAuctionsIdCancelErrorType } from '../axios';
import postAuctionsIdCompleteMutator from '../axios';
import type { ErrorType as PostAuctionsIdCompleteErrorType } from '../axios';
import postAuctionsIdStartMutator from '../axios';
import type { ErrorType as PostAuctionsIdStartErrorType } from '../axios';
import getAuctionsFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetAuctionsFiltersFilterNameErrorType } from '../axios';
import patchAuctionsStageOffersIdMutator from '../axios';
import type { ErrorType as PatchAuctionsStageOffersIdErrorType } from '../axios';
import getAuctionsSupplierMutator from '../axios';
import type { ErrorType as GetAuctionsSupplierErrorType } from '../axios';
import getAuctionsSupplierProgramTemplatesMutator from '../axios';
import type { ErrorType as GetAuctionsSupplierProgramTemplatesErrorType } from '../axios';
import postAuctionsSupplierProgramTemplatesMutator from '../axios';
import type { ErrorType as PostAuctionsSupplierProgramTemplatesErrorType } from '../axios';
import getAuctionsSupplierProgramTemplatesIdMutator from '../axios';
import type { ErrorType as GetAuctionsSupplierProgramTemplatesIdErrorType } from '../axios';
import putAuctionsSupplierProgramTemplatesIdMutator from '../axios';
import type { ErrorType as PutAuctionsSupplierProgramTemplatesIdErrorType } from '../axios';
import deleteAuctionsSupplierProgramTemplatesIdMutator from '../axios';
import type { ErrorType as DeleteAuctionsSupplierProgramTemplatesIdErrorType } from '../axios';
import getAuctionsSupplierFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetAuctionsSupplierFiltersFilterNameErrorType } from '../axios';
import getBananasMutator from '../axios';
import type { ErrorType as GetBananasErrorType } from '../axios';
import postBananasMutator from '../axios';
import type { ErrorType as PostBananasErrorType } from '../axios';
import getBananasIdMutator from '../axios';
import type { ErrorType as GetBananasIdErrorType } from '../axios';
import putBananasIdMutator from '../axios';
import type { ErrorType as PutBananasIdErrorType } from '../axios';
import getBananasExportReportMutator from '../axios';
import type { ErrorType as GetBananasExportReportErrorType } from '../axios';
import getBananasExportExcelMutator from '../axios';
import type { ErrorType as GetBananasExportExcelErrorType } from '../axios';
import getBananasProductsMutator from '../axios';
import type { ErrorType as GetBananasProductsErrorType } from '../axios';
import getBananasProductsIdMutator from '../axios';
import type { ErrorType as GetBananasProductsIdErrorType } from '../axios';
import getCommentsMutator from '../axios';
import type { ErrorType as GetCommentsErrorType } from '../axios';
import postCommentsCreateMutator from '../axios';
import type { ErrorType as PostCommentsCreateErrorType } from '../axios';
import postCommentsCreateMultipleMutator from '../axios';
import type { ErrorType as PostCommentsCreateMultipleErrorType } from '../axios';
import getCommentsUnseenCountersMutator from '../axios';
import type { ErrorType as GetCommentsUnseenCountersErrorType } from '../axios';
import getCoreCountryCountryPkRegionsMutator from '../axios';
import type { ErrorType as GetCoreCountryCountryPkRegionsErrorType } from '../axios';
import getCoreCustomsEntryPointsMutator from '../axios';
import type { ErrorType as GetCoreCustomsEntryPointsErrorType } from '../axios';
import getCoreDeliveryPointsMutator from '../axios';
import type { ErrorType as GetCoreDeliveryPointsErrorType } from '../axios';
import getCoreDeliveryPointsAvailableForOfferOfferIdMutator from '../axios';
import type { ErrorType as GetCoreDeliveryPointsAvailableForOfferOfferIdErrorType } from '../axios';
import getCoreDeliveryPointsForExtCalcMutator from '../axios';
import type { ErrorType as GetCoreDeliveryPointsForExtCalcErrorType } from '../axios';
import getCoreFeatureTogglesMutator from '../axios';
import type { ErrorType as GetCoreFeatureTogglesErrorType } from '../axios';
import getCoreMixOrdersMutator from '../axios';
import type { ErrorType as GetCoreMixOrdersErrorType } from '../axios';
import postCoreMixOrdersMutator from '../axios';
import type { ErrorType as PostCoreMixOrdersErrorType } from '../axios';
import getCoreMixOrdersIdMutator from '../axios';
import type { ErrorType as GetCoreMixOrdersIdErrorType } from '../axios';
import putCoreMixOrdersIdMutator from '../axios';
import type { ErrorType as PutCoreMixOrdersIdErrorType } from '../axios';
import patchCoreMixOrdersIdMutator from '../axios';
import type { ErrorType as PatchCoreMixOrdersIdErrorType } from '../axios';
import getCoreOfferIdMutator from '../axios';
import type { ErrorType as GetCoreOfferIdErrorType } from '../axios';
import getCoreOfferIdActivityMutator from '../axios';
import type { ErrorType as GetCoreOfferIdActivityErrorType } from '../axios';
import getCoreOfferIdCalculatePricesMutator from '../axios';
import type { ErrorType as GetCoreOfferIdCalculatePricesErrorType } from '../axios';
import getCoreOfferIdChoicesForMixordersMutator from '../axios';
import type { ErrorType as GetCoreOfferIdChoicesForMixordersErrorType } from '../axios';
import postCoreOfferCreateMutator from '../axios';
import type { ErrorType as PostCoreOfferCreateErrorType } from '../axios';
import getCoreOfferDownloadLogosReportMutator from '../axios';
import type { ErrorType as GetCoreOfferDownloadLogosReportErrorType } from '../axios';
import getCoreOfferDownloadOffersForRegionsReportMutator from '../axios';
import type { ErrorType as GetCoreOfferDownloadOffersForRegionsReportErrorType } from '../axios';
import getCoreOfferReferenceValuesMutator from '../axios';
import type { ErrorType as GetCoreOfferReferenceValuesErrorType } from '../axios';
import patchCoreOfferUpdateIdMutator from '../axios';
import type { ErrorType as PatchCoreOfferUpdateIdErrorType } from '../axios';
import getCoreOffersMutator from '../axios';
import type { ErrorType as GetCoreOffersErrorType } from '../axios';
import getCoreOffersForExtCalcMutator from '../axios';
import type { ErrorType as GetCoreOffersForExtCalcErrorType } from '../axios';
import getCoreOffersForExtCalcIdMutator from '../axios';
import type { ErrorType as GetCoreOffersForExtCalcIdErrorType } from '../axios';
import getCoreOffersNewMutator from '../axios';
import type { ErrorType as GetCoreOffersNewErrorType } from '../axios';
import getCoreOffersNewFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetCoreOffersNewFiltersFilterNameErrorType } from '../axios';
import getCoreOffersExcelMutator from '../axios';
import type { ErrorType as GetCoreOffersExcelErrorType } from '../axios';
import getCoreOffersExportExcelCalcMutator from '../axios';
import type { ErrorType as GetCoreOffersExportExcelCalcErrorType } from '../axios';
import postCoreOffersStatusApproveMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusApproveErrorType } from '../axios';
import postCoreOffersStatusApproveBusiMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusApproveBusiErrorType } from '../axios';
import postCoreOffersStatusDeleteMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusDeleteErrorType } from '../axios';
import postCoreOffersStatusRefuseMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusRefuseErrorType } from '../axios';
import postCoreOffersStatusRefuseBusiMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusRefuseBusiErrorType } from '../axios';
import postCoreOffersStatusSelectForApprovalMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusSelectForApprovalErrorType } from '../axios';
import postCoreOffersStatusTradingMutator from '../axios';
import type { ErrorType as PostCoreOffersStatusTradingErrorType } from '../axios';
import getCoreOffersUploadExcelPricesTasksMutator from '../axios';
import type { ErrorType as GetCoreOffersUploadExcelPricesTasksErrorType } from '../axios';
import postCoreOffersUploadExcelPricesTasksMutator from '../axios';
import type { ErrorType as PostCoreOffersUploadExcelPricesTasksErrorType } from '../axios';
import getCoreOffersUploadExcelPricesTasksIdMutator from '../axios';
import type { ErrorType as GetCoreOffersUploadExcelPricesTasksIdErrorType } from '../axios';
import patchCoreOffersWaitingForApprovalMutator from '../axios';
import type { ErrorType as PatchCoreOffersWaitingForApprovalErrorType } from '../axios';
import getCorePointToPointPricesMutator from '../axios';
import type { ErrorType as GetCorePointToPointPricesErrorType } from '../axios';
import getCoreProgramOffersMutator from '../axios';
import type { ErrorType as GetCoreProgramOffersErrorType } from '../axios';
import getCoreProgramOffersFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetCoreProgramOffersFiltersFilterNameErrorType } from '../axios';
import getCoreRefValuesForExtCalcMutator from '../axios';
import type { ErrorType as GetCoreRefValuesForExtCalcErrorType } from '../axios';
import getCoreSystemInfoMutator from '../axios';
import type { ErrorType as GetCoreSystemInfoErrorType } from '../axios';
import getCoreTemplatesMutator from '../axios';
import type { ErrorType as GetCoreTemplatesErrorType } from '../axios';
import postCoreTemplatesMutator from '../axios';
import type { ErrorType as PostCoreTemplatesErrorType } from '../axios';
import getCoreTemplatesIdMutator from '../axios';
import type { ErrorType as GetCoreTemplatesIdErrorType } from '../axios';
import patchCoreTemplatesIdMutator from '../axios';
import type { ErrorType as PatchCoreTemplatesIdErrorType } from '../axios';
import deleteCoreTemplatesIdMutator from '../axios';
import type { ErrorType as DeleteCoreTemplatesIdErrorType } from '../axios';
import postCoreUploadVolumeFileMutator from '../axios';
import type { ErrorType as PostCoreUploadVolumeFileErrorType } from '../axios';
import getCoreWeekActivitiesMutator from '../axios';
import type { ErrorType as GetCoreWeekActivitiesErrorType } from '../axios';
import getCoreWeekActivitiesIdMutator from '../axios';
import type { ErrorType as GetCoreWeekActivitiesIdErrorType } from '../axios';
import getEventsMutator from '../axios';
import type { ErrorType as GetEventsErrorType } from '../axios';
import getEventsFilterValuesEventTypesMutator from '../axios';
import type { ErrorType as GetEventsFilterValuesEventTypesErrorType } from '../axios';
import getEventsFilterValuesProductsMutator from '../axios';
import type { ErrorType as GetEventsFilterValuesProductsErrorType } from '../axios';
import getEventsFilterValuesSuppliersMutator from '../axios';
import type { ErrorType as GetEventsFilterValuesSuppliersErrorType } from '../axios';
import postEventsMakeAllViewedMutator from '../axios';
import type { ErrorType as PostEventsMakeAllViewedErrorType } from '../axios';
import postEventsMakeViewedMutator from '../axios';
import type { ErrorType as PostEventsMakeViewedErrorType } from '../axios';
import postEventsToggleViewedAtObjectMutator from '../axios';
import type { ErrorType as PostEventsToggleViewedAtObjectErrorType } from '../axios';
import getGeoCountryCountryPkRegionsMutator from '../axios';
import type { ErrorType as GetGeoCountryCountryPkRegionsErrorType } from '../axios';
import getGuidesOfferSizesMutator from '../axios';
import type { ErrorType as GetGuidesOfferSizesErrorType } from '../axios';
import getGuidesOfferSortsMutator from '../axios';
import type { ErrorType as GetGuidesOfferSortsErrorType } from '../axios';
import getMixMutator from '../axios';
import type { ErrorType as GetMixErrorType } from '../axios';
import postMixMutator from '../axios';
import type { ErrorType as PostMixErrorType } from '../axios';
import getMixIdMutator from '../axios';
import type { ErrorType as GetMixIdErrorType } from '../axios';
import putMixIdMutator from '../axios';
import type { ErrorType as PutMixIdErrorType } from '../axios';
import postMixIdManageMutator from '../axios';
import type { ErrorType as PostMixIdManageErrorType } from '../axios';
import getOrderMutator from '../axios';
import type { ErrorType as GetOrderErrorType } from '../axios';
import putOrderIdMutator from '../axios';
import type { ErrorType as PutOrderIdErrorType } from '../axios';
import patchOrderIdMutator from '../axios';
import type { ErrorType as PatchOrderIdErrorType } from '../axios';
import postOrderExportToLogosMutator from '../axios';
import type { ErrorType as PostOrderExportToLogosErrorType } from '../axios';
import getOrderStatusesMutator from '../axios';
import type { ErrorType as GetOrderStatusesErrorType } from '../axios';
import getProductsMutator from '../axios';
import type { ErrorType as GetProductsErrorType } from '../axios';
import postProductsMutator from '../axios';
import type { ErrorType as PostProductsErrorType } from '../axios';
import getProductsIdMutator from '../axios';
import type { ErrorType as GetProductsIdErrorType } from '../axios';
import patchProductsIdMutator from '../axios';
import type { ErrorType as PatchProductsIdErrorType } from '../axios';
import getProductsIdAvailableDeliveryPointsMutator from '../axios';
import type { ErrorType as GetProductsIdAvailableDeliveryPointsErrorType } from '../axios';
import getProductsIdOffersMutator from '../axios';
import type { ErrorType as GetProductsIdOffersErrorType } from '../axios';
import getProductsIdVolumesMutator from '../axios';
import type { ErrorType as GetProductsIdVolumesErrorType } from '../axios';
import getProductsCustomDutiesMutator from '../axios';
import type { ErrorType as GetProductsCustomDutiesErrorType } from '../axios';
import getProductsCustomDutiesExportImportMutator from '../axios';
import type { ErrorType as GetProductsCustomDutiesExportImportErrorType } from '../axios';
import postProductsCustomDutiesExportImportMutator from '../axios';
import type { ErrorType as PostProductsCustomDutiesExportImportErrorType } from '../axios';
import getProductsForExtCalcMutator from '../axios';
import type { ErrorType as GetProductsForExtCalcErrorType } from '../axios';
import getProductsGroupsMutator from '../axios';
import type { ErrorType as GetProductsGroupsErrorType } from '../axios';
import patchProductsManageMutator from '../axios';
import type { ErrorType as PatchProductsManageErrorType } from '../axios';
import getProgramsMutator from '../axios';
import type { ErrorType as GetProgramsErrorType } from '../axios';
import postProgramsMutator from '../axios';
import type { ErrorType as PostProgramsErrorType } from '../axios';
import getProgramsIdMutator from '../axios';
import type { ErrorType as GetProgramsIdErrorType } from '../axios';
import putProgramsIdMutator from '../axios';
import type { ErrorType as PutProgramsIdErrorType } from '../axios';
import patchProgramsIdMutator from '../axios';
import type { ErrorType as PatchProgramsIdErrorType } from '../axios';
import postProgramsIdExportReportMutator from '../axios';
import type { ErrorType as PostProgramsIdExportReportErrorType } from '../axios';
import postProgramsIdManageMutator from '../axios';
import type { ErrorType as PostProgramsIdManageErrorType } from '../axios';
import getProgramsFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetProgramsFiltersFilterNameErrorType } from '../axios';
import postProgramsTsApproveMutator from '../axios';
import type { ErrorType as PostProgramsTsApproveErrorType } from '../axios';
import putQaAuctionStagesIdMutator from '../axios';
import type { ErrorType as PutQaAuctionStagesIdErrorType } from '../axios';
import patchQaAuctionStagesIdMutator from '../axios';
import type { ErrorType as PatchQaAuctionStagesIdErrorType } from '../axios';
import deleteQaBananasIdMutator from '../axios';
import type { ErrorType as DeleteQaBananasIdErrorType } from '../axios';
import patchQaCustomsEntryPointsIdActualizeMutator from '../axios';
import type { ErrorType as PatchQaCustomsEntryPointsIdActualizeErrorType } from '../axios';
import patchQaDeliveryPointsCodeActualizeMutator from '../axios';
import type { ErrorType as PatchQaDeliveryPointsCodeActualizeErrorType } from '../axios';
import patchQaOffersIdMutator from '../axios';
import type { ErrorType as PatchQaOffersIdErrorType } from '../axios';
import deleteQaOffersIdMutator from '../axios';
import type { ErrorType as DeleteQaOffersIdErrorType } from '../axios';
import getQaProductsMutator from '../axios';
import type { ErrorType as GetQaProductsErrorType } from '../axios';
import getQaProductsIdMutator from '../axios';
import type { ErrorType as GetQaProductsIdErrorType } from '../axios';
import deleteQaProductsIdMutator from '../axios';
import type { ErrorType as DeleteQaProductsIdErrorType } from '../axios';
import deleteQaProgramsIdMutator from '../axios';
import type { ErrorType as DeleteQaProgramsIdErrorType } from '../axios';
import deleteQaRegularDemandsIdMutator from '../axios';
import type { ErrorType as DeleteQaRegularDemandsIdErrorType } from '../axios';
import postQaSentryCheckMutator from '../axios';
import type { ErrorType as PostQaSentryCheckErrorType } from '../axios';
import postQaSizesMutator from '../axios';
import type { ErrorType as PostQaSizesErrorType } from '../axios';
import postQaSizesDeleteMutator from '../axios';
import type { ErrorType as PostQaSizesDeleteErrorType } from '../axios';
import postQaSortsMutator from '../axios';
import type { ErrorType as PostQaSortsErrorType } from '../axios';
import postQaSortsDeleteMutator from '../axios';
import type { ErrorType as PostQaSortsDeleteErrorType } from '../axios';
import getQaSuppliersMutator from '../axios';
import type { ErrorType as GetQaSuppliersErrorType } from '../axios';
import postQaSuppliersMutator from '../axios';
import type { ErrorType as PostQaSuppliersErrorType } from '../axios';
import deleteQaSuppliersIdMutator from '../axios';
import type { ErrorType as DeleteQaSuppliersIdErrorType } from '../axios';
import patchQaSuppliersIdActivateMutator from '../axios';
import type { ErrorType as PatchQaSuppliersIdActivateErrorType } from '../axios';
import patchQaSuppliersIdArchiveMutator from '../axios';
import type { ErrorType as PatchQaSuppliersIdArchiveErrorType } from '../axios';
import patchQaSuppliersIdDeactivateMutator from '../axios';
import type { ErrorType as PatchQaSuppliersIdDeactivateErrorType } from '../axios';
import patchQaSuppliersIdUnarchiveMutator from '../axios';
import type { ErrorType as PatchQaSuppliersIdUnarchiveErrorType } from '../axios';
import getQaUsersMutator from '../axios';
import type { ErrorType as GetQaUsersErrorType } from '../axios';
import postQaUsersMutator from '../axios';
import type { ErrorType as PostQaUsersErrorType } from '../axios';
import getQaUsersIdMutator from '../axios';
import type { ErrorType as GetQaUsersIdErrorType } from '../axios';
import putQaUsersIdMutator from '../axios';
import type { ErrorType as PutQaUsersIdErrorType } from '../axios';
import patchQaUsersIdMutator from '../axios';
import type { ErrorType as PatchQaUsersIdErrorType } from '../axios';
import deleteQaUsersIdMutator from '../axios';
import type { ErrorType as DeleteQaUsersIdErrorType } from '../axios';
import patchQaUsersIdArchiveMutator from '../axios';
import type { ErrorType as PatchQaUsersIdArchiveErrorType } from '../axios';
import getQaUsersIdPasswordTokenMutator from '../axios';
import type { ErrorType as GetQaUsersIdPasswordTokenErrorType } from '../axios';
import patchQaUsersIdSetProductsMutator from '../axios';
import type { ErrorType as PatchQaUsersIdSetProductsErrorType } from '../axios';
import patchQaUsersIdUnarchiveMutator from '../axios';
import type { ErrorType as PatchQaUsersIdUnarchiveErrorType } from '../axios';
import getRegularDemandsMutator from '../axios';
import type { ErrorType as GetRegularDemandsErrorType } from '../axios';
import getRegularDemandsFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetRegularDemandsFiltersFilterNameErrorType } from '../axios';
import postRegularDemandsUploadMutator from '../axios';
import type { ErrorType as PostRegularDemandsUploadErrorType } from '../axios';
import getReportsMutator from '../axios';
import type { ErrorType as GetReportsErrorType } from '../axios';
import getReportsIdMutator from '../axios';
import type { ErrorType as GetReportsIdErrorType } from '../axios';
import deleteReportsIdMutator from '../axios';
import type { ErrorType as DeleteReportsIdErrorType } from '../axios';
import getSupplierMutator from '../axios';
import type { ErrorType as GetSupplierErrorType } from '../axios';
import postSupplierMutator from '../axios';
import type { ErrorType as PostSupplierErrorType } from '../axios';
import getSupplierIdMutator from '../axios';
import type { ErrorType as GetSupplierIdErrorType } from '../axios';
import putSupplierIdMutator from '../axios';
import type { ErrorType as PutSupplierIdErrorType } from '../axios';
import getSupplierIdAvailableProductsMutator from '../axios';
import type { ErrorType as GetSupplierIdAvailableProductsErrorType } from '../axios';
import putSupplierIdUpdateUsersProductsMutator from '../axios';
import type { ErrorType as PutSupplierIdUpdateUsersProductsErrorType } from '../axios';
import getSupplierFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetSupplierFiltersFilterNameErrorType } from '../axios';
import postSupplierManageMutator from '../axios';
import type { ErrorType as PostSupplierManageErrorType } from '../axios';
import getSupplierPaginatedMutator from '../axios';
import type { ErrorType as GetSupplierPaginatedErrorType } from '../axios';
import getTradingWeeksCurrentMutator from '../axios';
import type { ErrorType as GetTradingWeeksCurrentErrorType } from '../axios';
import getTradingWeeksNextMutator from '../axios';
import type { ErrorType as GetTradingWeeksNextErrorType } from '../axios';
import getUserMutator from '../axios';
import type { ErrorType as GetUserErrorType } from '../axios';
import postUserMutator from '../axios';
import type { ErrorType as PostUserErrorType } from '../axios';
import patchUserMutator from '../axios';
import type { ErrorType as PatchUserErrorType } from '../axios';
import getUserContractorsMutator from '../axios';
import type { ErrorType as GetUserContractorsErrorType } from '../axios';
import postUserContractorsMutator from '../axios';
import type { ErrorType as PostUserContractorsErrorType } from '../axios';
import getUserContractorsIdMutator from '../axios';
import type { ErrorType as GetUserContractorsIdErrorType } from '../axios';
import putUserContractorsIdMutator from '../axios';
import type { ErrorType as PutUserContractorsIdErrorType } from '../axios';
import getUserContractorsFiltersFilterNameMutator from '../axios';
import type { ErrorType as GetUserContractorsFiltersFilterNameErrorType } from '../axios';
import postUserContractorsManageMutator from '../axios';
import type { ErrorType as PostUserContractorsManageErrorType } from '../axios';
import getUserContractorsPaginatedMutator from '../axios';
import type { ErrorType as GetUserContractorsPaginatedErrorType } from '../axios';
import getUserFilterPresetsMutator from '../axios';
import type { ErrorType as GetUserFilterPresetsErrorType } from '../axios';
import postUserFilterPresetsMutator from '../axios';
import type { ErrorType as PostUserFilterPresetsErrorType } from '../axios';
import getUserFilterPresetsIdMutator from '../axios';
import type { ErrorType as GetUserFilterPresetsIdErrorType } from '../axios';
import patchUserFilterPresetsIdMutator from '../axios';
import type { ErrorType as PatchUserFilterPresetsIdErrorType } from '../axios';
import deleteUserFilterPresetsIdMutator from '../axios';
import type { ErrorType as DeleteUserFilterPresetsIdErrorType } from '../axios';
import postUserLoginMutator from '../axios';
import type { ErrorType as PostUserLoginErrorType } from '../axios';
import postUserOtpVerifyMutator from '../axios';
import type { ErrorType as PostUserOtpVerifyErrorType } from '../axios';
import postUserPasswordResetCheckTokenMutator from '../axios';
import type { ErrorType as PostUserPasswordResetCheckTokenErrorType } from '../axios';
import postUserPasswordResetRequestTokenMutator from '../axios';
import type { ErrorType as PostUserPasswordResetRequestTokenErrorType } from '../axios';
import postUserPasswordResetSetPasswordMutator from '../axios';
import type { ErrorType as PostUserPasswordResetSetPasswordErrorType } from '../axios';
import getUserRviMutator from '../axios';
import type { ErrorType as GetUserRviErrorType } from '../axios';
import getVolumesMutator from '../axios';
import type { ErrorType as GetVolumesErrorType } from '../axios';
import postVolumesMutator from '../axios';
import type { ErrorType as PostVolumesErrorType } from '../axios';
import getVolumesIdMutator from '../axios';
import type { ErrorType as GetVolumesIdErrorType } from '../axios';
import putVolumesIdMutator from '../axios';
import type { ErrorType as PutVolumesIdErrorType } from '../axios';
import deleteVolumesIdMutator from '../axios';
import type { ErrorType as DeleteVolumesIdErrorType } from '../axios';
import getVolumesDeliveryPointVolumeMutator from '../axios';
import type { ErrorType as GetVolumesDeliveryPointVolumeErrorType } from '../axios';
import postVolumesDeliveryPointVolumeMutator from '../axios';
import type { ErrorType as PostVolumesDeliveryPointVolumeErrorType } from '../axios';
import getVolumesDeliveryPointVolumeIdMutator from '../axios';
import type { ErrorType as GetVolumesDeliveryPointVolumeIdErrorType } from '../axios';
import putVolumesDeliveryPointVolumeIdMutator from '../axios';
import type { ErrorType as PutVolumesDeliveryPointVolumeIdErrorType } from '../axios';
import deleteVolumesDeliveryPointVolumeIdMutator from '../axios';
import type { ErrorType as DeleteVolumesDeliveryPointVolumeIdErrorType } from '../axios';
import putVolumesDeliveryPointVolumeIdKmtsMutator from '../axios';
import type { ErrorType as PutVolumesDeliveryPointVolumeIdKmtsErrorType } from '../axios';
import postVolumesDeliveryPointVolumeKmtsMutator from '../axios';
import type { ErrorType as PostVolumesDeliveryPointVolumeKmtsErrorType } from '../axios';



// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;




export type getAuctionsResponse200 = {
  data: PaginatedAuctionRviListList
  status: 200
}

export type getAuctionsResponseSuccess = (getAuctionsResponse200) & {
  headers: Headers;
};
;

export type getAuctionsResponse = (getAuctionsResponseSuccess)

export const getGetAuctionsUrl = (params?: GetAuctionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auctions/?${stringifiedParams}` : `/api/auctions/`
}

export const getAuctions = async (params?: GetAuctionsParams, options?: RequestInit): Promise<getAuctionsResponse> => {
  
  return getAuctionsMutator<getAuctionsResponse>(getGetAuctionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsQueryKey = (params?: GetAuctionsParams,) => {
    return [
    `/api/auctions/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAuctionsQueryOptions = <TData = Awaited<ReturnType<typeof getAuctions>>, TError = GetAuctionsErrorType<unknown>>(params?: GetAuctionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctions>>> = ({ signal }) => getAuctions(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctions>>>
export type GetAuctionsQueryError = GetAuctionsErrorType<unknown>



export function useGetAuctions<TData = Awaited<ReturnType<typeof getAuctions>>, TError = GetAuctionsErrorType<unknown>>(
 params?: GetAuctionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postAuctionsResponse201 = {
  data: AuctionCreate
  status: 201
}

export type postAuctionsResponseSuccess = (postAuctionsResponse201) & {
  headers: Headers;
};
;

export type postAuctionsResponse = (postAuctionsResponseSuccess)

export const getPostAuctionsUrl = () => {


  

  return `/api/auctions/`
}

export const postAuctions = async (auctionCreate: NonReadonly<AuctionCreate>, options?: RequestInit): Promise<postAuctionsResponse> => {
  
  return postAuctionsMutator<postAuctionsResponse>(getPostAuctionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionCreate,)
  }
);}
  



export const getPostAuctionsMutationOptions = <TError = PostAuctionsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctions>>, TError,{data: NonReadonly<AuctionCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctions>>, TError,{data: NonReadonly<AuctionCreate>}, TContext> => {

const mutationKey = ['postAuctions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctions>>, {data: NonReadonly<AuctionCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postAuctions(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctions>>>
    export type PostAuctionsMutationBody = NonReadonly<AuctionCreate>
    export type PostAuctionsMutationError = PostAuctionsErrorType<unknown>

    export const usePostAuctions = <TError = PostAuctionsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctions>>, TError,{data: NonReadonly<AuctionCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctions>>,
        TError,
        {data: NonReadonly<AuctionCreate>},
        TContext
      > => {
      return useMutation(getPostAuctionsMutationOptions(options));
    }
    /**
 * Этапы аукциона RVI.
 */
export type getAuctionsAuctionPkStagesIdResponse200 = {
  data: AuctionStageDetailRvi
  status: 200
}

export type getAuctionsAuctionPkStagesIdResponseSuccess = (getAuctionsAuctionPkStagesIdResponse200) & {
  headers: Headers;
};
;

export type getAuctionsAuctionPkStagesIdResponse = (getAuctionsAuctionPkStagesIdResponseSuccess)

export const getGetAuctionsAuctionPkStagesIdUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/stages/${id}/`
}

export const getAuctionsAuctionPkStagesId = async (auctionPk: number,
    id: number, options?: RequestInit): Promise<getAuctionsAuctionPkStagesIdResponse> => {
  
  return getAuctionsAuctionPkStagesIdMutator<getAuctionsAuctionPkStagesIdResponse>(getGetAuctionsAuctionPkStagesIdUrl(auctionPk,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsAuctionPkStagesIdQueryKey = (auctionPk: number,
    id: number,) => {
    return [
    `/api/auctions/${auctionPk}/stages/${id}/`
    ] as const;
    }

    
export const getGetAuctionsAuctionPkStagesIdQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>, TError = GetAuctionsAuctionPkStagesIdErrorType<unknown>>(auctionPk: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsAuctionPkStagesIdQueryKey(auctionPk,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>> = ({ signal }) => getAuctionsAuctionPkStagesId(auctionPk,id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(auctionPk && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsAuctionPkStagesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>>
export type GetAuctionsAuctionPkStagesIdQueryError = GetAuctionsAuctionPkStagesIdErrorType<unknown>



export function useGetAuctionsAuctionPkStagesId<TData = Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>, TError = GetAuctionsAuctionPkStagesIdErrorType<unknown>>(
 auctionPk: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkStagesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsAuctionPkStagesIdQueryOptions(auctionPk,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Удаление этапа аукциона.
 */
export type postAuctionsAuctionPkStagesIdDeleteResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsAuctionPkStagesIdDeleteResponseSuccess = (postAuctionsAuctionPkStagesIdDeleteResponse200) & {
  headers: Headers;
};
;

export type postAuctionsAuctionPkStagesIdDeleteResponse = (postAuctionsAuctionPkStagesIdDeleteResponseSuccess)

export const getPostAuctionsAuctionPkStagesIdDeleteUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/stages/${id}/delete/`
}

export const postAuctionsAuctionPkStagesIdDelete = async (auctionPk: number,
    id: number,
    auctionStageDelete: AuctionStageDelete, options?: RequestInit): Promise<postAuctionsAuctionPkStagesIdDeleteResponse> => {
  
  return postAuctionsAuctionPkStagesIdDeleteMutator<postAuctionsAuctionPkStagesIdDeleteResponse>(getPostAuctionsAuctionPkStagesIdDeleteUrl(auctionPk,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionStageDelete,)
  }
);}
  



export const getPostAuctionsAuctionPkStagesIdDeleteMutationOptions = <TError = PostAuctionsAuctionPkStagesIdDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>, TError,{auctionPk: number;id: number;data: AuctionStageDelete}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>, TError,{auctionPk: number;id: number;data: AuctionStageDelete}, TContext> => {

const mutationKey = ['postAuctionsAuctionPkStagesIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>, {auctionPk: number;id: number;data: AuctionStageDelete}> = (props) => {
          const {auctionPk,id,data} = props ?? {};

          return  postAuctionsAuctionPkStagesIdDelete(auctionPk,id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsAuctionPkStagesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>>
    export type PostAuctionsAuctionPkStagesIdDeleteMutationBody = AuctionStageDelete
    export type PostAuctionsAuctionPkStagesIdDeleteMutationError = PostAuctionsAuctionPkStagesIdDeleteErrorType<unknown>

    export const usePostAuctionsAuctionPkStagesIdDelete = <TError = PostAuctionsAuctionPkStagesIdDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>, TError,{auctionPk: number;id: number;data: AuctionStageDelete}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdDelete>>,
        TError,
        {auctionPk: number;id: number;data: AuctionStageDelete},
        TContext
      > => {
      return useMutation(getPostAuctionsAuctionPkStagesIdDeleteMutationOptions(options));
    }
    /**
 * Повторный запуск этапа аукциона после остановки.
 */
export type postAuctionsAuctionPkStagesIdRestartResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsAuctionPkStagesIdRestartResponseSuccess = (postAuctionsAuctionPkStagesIdRestartResponse200) & {
  headers: Headers;
};
;

export type postAuctionsAuctionPkStagesIdRestartResponse = (postAuctionsAuctionPkStagesIdRestartResponseSuccess)

export const getPostAuctionsAuctionPkStagesIdRestartUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/stages/${id}/restart/`
}

export const postAuctionsAuctionPkStagesIdRestart = async (auctionPk: number,
    id: number, options?: RequestInit): Promise<postAuctionsAuctionPkStagesIdRestartResponse> => {
  
  return postAuctionsAuctionPkStagesIdRestartMutator<postAuctionsAuctionPkStagesIdRestartResponse>(getPostAuctionsAuctionPkStagesIdRestartUrl(auctionPk,id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getPostAuctionsAuctionPkStagesIdRestartMutationOptions = <TError = PostAuctionsAuctionPkStagesIdRestartErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>, TError,{auctionPk: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>, TError,{auctionPk: number;id: number}, TContext> => {

const mutationKey = ['postAuctionsAuctionPkStagesIdRestart'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>, {auctionPk: number;id: number}> = (props) => {
          const {auctionPk,id} = props ?? {};

          return  postAuctionsAuctionPkStagesIdRestart(auctionPk,id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsAuctionPkStagesIdRestartMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>>
    
    export type PostAuctionsAuctionPkStagesIdRestartMutationError = PostAuctionsAuctionPkStagesIdRestartErrorType<unknown>

    export const usePostAuctionsAuctionPkStagesIdRestart = <TError = PostAuctionsAuctionPkStagesIdRestartErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>, TError,{auctionPk: number;id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdRestart>>,
        TError,
        {auctionPk: number;id: number},
        TContext
      > => {
      return useMutation(getPostAuctionsAuctionPkStagesIdRestartMutationOptions(options));
    }
    /**
 * Остановка этапа аукциона.
 */
export type postAuctionsAuctionPkStagesIdStopResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsAuctionPkStagesIdStopResponseSuccess = (postAuctionsAuctionPkStagesIdStopResponse200) & {
  headers: Headers;
};
;

export type postAuctionsAuctionPkStagesIdStopResponse = (postAuctionsAuctionPkStagesIdStopResponseSuccess)

export const getPostAuctionsAuctionPkStagesIdStopUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/stages/${id}/stop/`
}

export const postAuctionsAuctionPkStagesIdStop = async (auctionPk: number,
    id: number,
    auctionStageStop: AuctionStageStop, options?: RequestInit): Promise<postAuctionsAuctionPkStagesIdStopResponse> => {
  
  return postAuctionsAuctionPkStagesIdStopMutator<postAuctionsAuctionPkStagesIdStopResponse>(getPostAuctionsAuctionPkStagesIdStopUrl(auctionPk,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionStageStop,)
  }
);}
  



export const getPostAuctionsAuctionPkStagesIdStopMutationOptions = <TError = PostAuctionsAuctionPkStagesIdStopErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>, TError,{auctionPk: number;id: number;data: AuctionStageStop}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>, TError,{auctionPk: number;id: number;data: AuctionStageStop}, TContext> => {

const mutationKey = ['postAuctionsAuctionPkStagesIdStop'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>, {auctionPk: number;id: number;data: AuctionStageStop}> = (props) => {
          const {auctionPk,id,data} = props ?? {};

          return  postAuctionsAuctionPkStagesIdStop(auctionPk,id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsAuctionPkStagesIdStopMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>>
    export type PostAuctionsAuctionPkStagesIdStopMutationBody = AuctionStageStop
    export type PostAuctionsAuctionPkStagesIdStopMutationError = PostAuctionsAuctionPkStagesIdStopErrorType<unknown>

    export const usePostAuctionsAuctionPkStagesIdStop = <TError = PostAuctionsAuctionPkStagesIdStopErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>, TError,{auctionPk: number;id: number;data: AuctionStageStop}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsAuctionPkStagesIdStop>>,
        TError,
        {auctionPk: number;id: number;data: AuctionStageStop},
        TContext
      > => {
      return useMutation(getPostAuctionsAuctionPkStagesIdStopMutationOptions(options));
    }
    /**
 * Этапы аукциона поставщиков.
 */
export type getAuctionsAuctionPkSupplierStagesIdResponse200 = {
  data: AuctionStageDetailSupplier
  status: 200
}

export type getAuctionsAuctionPkSupplierStagesIdResponseSuccess = (getAuctionsAuctionPkSupplierStagesIdResponse200) & {
  headers: Headers;
};
;

export type getAuctionsAuctionPkSupplierStagesIdResponse = (getAuctionsAuctionPkSupplierStagesIdResponseSuccess)

export const getGetAuctionsAuctionPkSupplierStagesIdUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/supplier/stages/${id}/`
}

export const getAuctionsAuctionPkSupplierStagesId = async (auctionPk: number,
    id: number, options?: RequestInit): Promise<getAuctionsAuctionPkSupplierStagesIdResponse> => {
  
  return getAuctionsAuctionPkSupplierStagesIdMutator<getAuctionsAuctionPkSupplierStagesIdResponse>(getGetAuctionsAuctionPkSupplierStagesIdUrl(auctionPk,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsAuctionPkSupplierStagesIdQueryKey = (auctionPk: number,
    id: number,) => {
    return [
    `/api/auctions/${auctionPk}/supplier/stages/${id}/`
    ] as const;
    }

    
export const getGetAuctionsAuctionPkSupplierStagesIdQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>, TError = GetAuctionsAuctionPkSupplierStagesIdErrorType<unknown>>(auctionPk: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsAuctionPkSupplierStagesIdQueryKey(auctionPk,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>> = ({ signal }) => getAuctionsAuctionPkSupplierStagesId(auctionPk,id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(auctionPk && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsAuctionPkSupplierStagesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>>
export type GetAuctionsAuctionPkSupplierStagesIdQueryError = GetAuctionsAuctionPkSupplierStagesIdErrorType<unknown>



export function useGetAuctionsAuctionPkSupplierStagesId<TData = Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>, TError = GetAuctionsAuctionPkSupplierStagesIdErrorType<unknown>>(
 auctionPk: number,
    id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsAuctionPkSupplierStagesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsAuctionPkSupplierStagesIdQueryOptions(auctionPk,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Этапы аукциона поставщиков.
 */
export type postAuctionsAuctionPkSupplierStagesIdOfferResponse201 = {
  data: AuctionStageOfferCreate
  status: 201
}

export type postAuctionsAuctionPkSupplierStagesIdOfferResponseSuccess = (postAuctionsAuctionPkSupplierStagesIdOfferResponse201) & {
  headers: Headers;
};
;

export type postAuctionsAuctionPkSupplierStagesIdOfferResponse = (postAuctionsAuctionPkSupplierStagesIdOfferResponseSuccess)

export const getPostAuctionsAuctionPkSupplierStagesIdOfferUrl = (auctionPk: number,
    id: number,) => {


  

  return `/api/auctions/${auctionPk}/supplier/stages/${id}/offer/`
}

export const postAuctionsAuctionPkSupplierStagesIdOffer = async (auctionPk: number,
    id: number,
    auctionStageOfferCreate: NonReadonly<AuctionStageOfferCreate>, options?: RequestInit): Promise<postAuctionsAuctionPkSupplierStagesIdOfferResponse> => {
  
  return postAuctionsAuctionPkSupplierStagesIdOfferMutator<postAuctionsAuctionPkSupplierStagesIdOfferResponse>(getPostAuctionsAuctionPkSupplierStagesIdOfferUrl(auctionPk,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionStageOfferCreate,)
  }
);}
  



export const getPostAuctionsAuctionPkSupplierStagesIdOfferMutationOptions = <TError = PostAuctionsAuctionPkSupplierStagesIdOfferErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>, TError,{auctionPk: number;id: number;data: NonReadonly<AuctionStageOfferCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>, TError,{auctionPk: number;id: number;data: NonReadonly<AuctionStageOfferCreate>}, TContext> => {

const mutationKey = ['postAuctionsAuctionPkSupplierStagesIdOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>, {auctionPk: number;id: number;data: NonReadonly<AuctionStageOfferCreate>}> = (props) => {
          const {auctionPk,id,data} = props ?? {};

          return  postAuctionsAuctionPkSupplierStagesIdOffer(auctionPk,id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsAuctionPkSupplierStagesIdOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>>
    export type PostAuctionsAuctionPkSupplierStagesIdOfferMutationBody = NonReadonly<AuctionStageOfferCreate>
    export type PostAuctionsAuctionPkSupplierStagesIdOfferMutationError = PostAuctionsAuctionPkSupplierStagesIdOfferErrorType<unknown>

    export const usePostAuctionsAuctionPkSupplierStagesIdOffer = <TError = PostAuctionsAuctionPkSupplierStagesIdOfferErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>, TError,{auctionPk: number;id: number;data: NonReadonly<AuctionStageOfferCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsAuctionPkSupplierStagesIdOffer>>,
        TError,
        {auctionPk: number;id: number;data: NonReadonly<AuctionStageOfferCreate>},
        TContext
      > => {
      return useMutation(getPostAuctionsAuctionPkSupplierStagesIdOfferMutationOptions(options));
    }
    /**
 * Этапы аукциона поставщиков.
 */
export type putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponse200 = {
  data: AuctionStageOfferUpdate
  status: 200
}

export type putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponseSuccess = (putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponse200) & {
  headers: Headers;
};
;

export type putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponse = (putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponseSuccess)

export const getPutAuctionsAuctionPkSupplierStagesIdOfferAsoIdUrl = (auctionPk: number,
    id: number,
    asoId: number,) => {


  

  return `/api/auctions/${auctionPk}/supplier/stages/${id}/offer/${asoId}/`
}

export const putAuctionsAuctionPkSupplierStagesIdOfferAsoId = async (auctionPk: number,
    id: number,
    asoId: number,
    auctionStageOfferUpdate: NonReadonly<AuctionStageOfferUpdate>, options?: RequestInit): Promise<putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponse> => {
  
  return putAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutator<putAuctionsAuctionPkSupplierStagesIdOfferAsoIdResponse>(getPutAuctionsAuctionPkSupplierStagesIdOfferAsoIdUrl(auctionPk,id,asoId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionStageOfferUpdate,)
  }
);}
  



export const getPutAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutationOptions = <TError = PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>, TError,{auctionPk: number;id: number;asoId: number;data: NonReadonly<AuctionStageOfferUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>, TError,{auctionPk: number;id: number;asoId: number;data: NonReadonly<AuctionStageOfferUpdate>}, TContext> => {

const mutationKey = ['putAuctionsAuctionPkSupplierStagesIdOfferAsoId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>, {auctionPk: number;id: number;asoId: number;data: NonReadonly<AuctionStageOfferUpdate>}> = (props) => {
          const {auctionPk,id,asoId,data} = props ?? {};

          return  putAuctionsAuctionPkSupplierStagesIdOfferAsoId(auctionPk,id,asoId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>>
    export type PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutationBody = NonReadonly<AuctionStageOfferUpdate>
    export type PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutationError = PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdErrorType<unknown>

    export const usePutAuctionsAuctionPkSupplierStagesIdOfferAsoId = <TError = PutAuctionsAuctionPkSupplierStagesIdOfferAsoIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>, TError,{auctionPk: number;id: number;asoId: number;data: NonReadonly<AuctionStageOfferUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putAuctionsAuctionPkSupplierStagesIdOfferAsoId>>,
        TError,
        {auctionPk: number;id: number;asoId: number;data: NonReadonly<AuctionStageOfferUpdate>},
        TContext
      > => {
      return useMutation(getPutAuctionsAuctionPkSupplierStagesIdOfferAsoIdMutationOptions(options));
    }
    export type getAuctionsIdResponse200 = {
  data: AuctionDetail
  status: 200
}

export type getAuctionsIdResponseSuccess = (getAuctionsIdResponse200) & {
  headers: Headers;
};
;

export type getAuctionsIdResponse = (getAuctionsIdResponseSuccess)

export const getGetAuctionsIdUrl = (id: number,) => {


  

  return `/api/auctions/${id}/`
}

export const getAuctionsId = async (id: number, options?: RequestInit): Promise<getAuctionsIdResponse> => {
  
  return getAuctionsIdMutator<getAuctionsIdResponse>(getGetAuctionsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsIdQueryKey = (id: number,) => {
    return [
    `/api/auctions/${id}/`
    ] as const;
    }

    
export const getGetAuctionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsId>>, TError = GetAuctionsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsId>>> = ({ signal }) => getAuctionsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsId>>>
export type GetAuctionsIdQueryError = GetAuctionsIdErrorType<unknown>



export function useGetAuctionsId<TData = Awaited<ReturnType<typeof getAuctionsId>>, TError = GetAuctionsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putAuctionsIdResponse200 = {
  data: AuctionUpdate
  status: 200
}

export type putAuctionsIdResponseSuccess = (putAuctionsIdResponse200) & {
  headers: Headers;
};
;

export type putAuctionsIdResponse = (putAuctionsIdResponseSuccess)

export const getPutAuctionsIdUrl = (id: number,) => {


  

  return `/api/auctions/${id}/`
}

export const putAuctionsId = async (id: number,
    auctionUpdate: NonReadonly<AuctionUpdate>, options?: RequestInit): Promise<putAuctionsIdResponse> => {
  
  return putAuctionsIdMutator<putAuctionsIdResponse>(getPutAuctionsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionUpdate,)
  }
);}
  



export const getPutAuctionsIdMutationOptions = <TError = PutAuctionsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsId>>, TError,{id: number;data: NonReadonly<AuctionUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAuctionsId>>, TError,{id: number;data: NonReadonly<AuctionUpdate>}, TContext> => {

const mutationKey = ['putAuctionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuctionsId>>, {id: number;data: NonReadonly<AuctionUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putAuctionsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuctionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAuctionsId>>>
    export type PutAuctionsIdMutationBody = NonReadonly<AuctionUpdate>
    export type PutAuctionsIdMutationError = PutAuctionsIdErrorType<unknown>

    export const usePutAuctionsId = <TError = PutAuctionsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsId>>, TError,{id: number;data: NonReadonly<AuctionUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putAuctionsId>>,
        TError,
        {id: number;data: NonReadonly<AuctionUpdate>},
        TContext
      > => {
      return useMutation(getPutAuctionsIdMutationOptions(options));
    }
    export type deleteAuctionsIdResponse204 = {
  data: void
  status: 204
}

export type deleteAuctionsIdResponseSuccess = (deleteAuctionsIdResponse204) & {
  headers: Headers;
};
;

export type deleteAuctionsIdResponse = (deleteAuctionsIdResponseSuccess)

export const getDeleteAuctionsIdUrl = (id: number,) => {


  

  return `/api/auctions/${id}/`
}

export const deleteAuctionsId = async (id: number, options?: RequestInit): Promise<deleteAuctionsIdResponse> => {
  
  return deleteAuctionsIdMutator<deleteAuctionsIdResponse>(getDeleteAuctionsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteAuctionsIdMutationOptions = <TError = DeleteAuctionsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAuctionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAuctionsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAuctionsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAuctionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAuctionsId>>>
    
    export type DeleteAuctionsIdMutationError = DeleteAuctionsIdErrorType<unknown>

    export const useDeleteAuctionsId = <TError = DeleteAuctionsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAuctionsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAuctionsIdMutationOptions(options));
    }
    /**
 * Отмена аукциона.
 */
export type postAuctionsIdCancelResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsIdCancelResponseSuccess = (postAuctionsIdCancelResponse200) & {
  headers: Headers;
};
;

export type postAuctionsIdCancelResponse = (postAuctionsIdCancelResponseSuccess)

export const getPostAuctionsIdCancelUrl = (id: number,) => {


  

  return `/api/auctions/${id}/cancel/`
}

export const postAuctionsIdCancel = async (id: number,
    auctionManage: AuctionManage, options?: RequestInit): Promise<postAuctionsIdCancelResponse> => {
  
  return postAuctionsIdCancelMutator<postAuctionsIdCancelResponse>(getPostAuctionsIdCancelUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionManage,)
  }
);}
  



export const getPostAuctionsIdCancelMutationOptions = <TError = PostAuctionsIdCancelErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdCancel>>, TError,{id: number;data: AuctionManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdCancel>>, TError,{id: number;data: AuctionManage}, TContext> => {

const mutationKey = ['postAuctionsIdCancel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsIdCancel>>, {id: number;data: AuctionManage}> = (props) => {
          const {id,data} = props ?? {};

          return  postAuctionsIdCancel(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsIdCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsIdCancel>>>
    export type PostAuctionsIdCancelMutationBody = AuctionManage
    export type PostAuctionsIdCancelMutationError = PostAuctionsIdCancelErrorType<unknown>

    export const usePostAuctionsIdCancel = <TError = PostAuctionsIdCancelErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdCancel>>, TError,{id: number;data: AuctionManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsIdCancel>>,
        TError,
        {id: number;data: AuctionManage},
        TContext
      > => {
      return useMutation(getPostAuctionsIdCancelMutationOptions(options));
    }
    /**
 * Досрочное завершение аукциона.
 */
export type postAuctionsIdCompleteResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsIdCompleteResponseSuccess = (postAuctionsIdCompleteResponse200) & {
  headers: Headers;
};
;

export type postAuctionsIdCompleteResponse = (postAuctionsIdCompleteResponseSuccess)

export const getPostAuctionsIdCompleteUrl = (id: number,) => {


  

  return `/api/auctions/${id}/complete/`
}

export const postAuctionsIdComplete = async (id: number,
    auctionManage: AuctionManage, options?: RequestInit): Promise<postAuctionsIdCompleteResponse> => {
  
  return postAuctionsIdCompleteMutator<postAuctionsIdCompleteResponse>(getPostAuctionsIdCompleteUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionManage,)
  }
);}
  



export const getPostAuctionsIdCompleteMutationOptions = <TError = PostAuctionsIdCompleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdComplete>>, TError,{id: number;data: AuctionManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdComplete>>, TError,{id: number;data: AuctionManage}, TContext> => {

const mutationKey = ['postAuctionsIdComplete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsIdComplete>>, {id: number;data: AuctionManage}> = (props) => {
          const {id,data} = props ?? {};

          return  postAuctionsIdComplete(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsIdComplete>>>
    export type PostAuctionsIdCompleteMutationBody = AuctionManage
    export type PostAuctionsIdCompleteMutationError = PostAuctionsIdCompleteErrorType<unknown>

    export const usePostAuctionsIdComplete = <TError = PostAuctionsIdCompleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdComplete>>, TError,{id: number;data: AuctionManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsIdComplete>>,
        TError,
        {id: number;data: AuctionManage},
        TContext
      > => {
      return useMutation(getPostAuctionsIdCompleteMutationOptions(options));
    }
    /**
 * Запуск аукциона.
 */
export type postAuctionsIdStartResponse200 = {
  data: Result
  status: 200
}

export type postAuctionsIdStartResponseSuccess = (postAuctionsIdStartResponse200) & {
  headers: Headers;
};
;

export type postAuctionsIdStartResponse = (postAuctionsIdStartResponseSuccess)

export const getPostAuctionsIdStartUrl = (id: number,) => {


  

  return `/api/auctions/${id}/start/`
}

export const postAuctionsIdStart = async (id: number, options?: RequestInit): Promise<postAuctionsIdStartResponse> => {
  
  return postAuctionsIdStartMutator<postAuctionsIdStartResponse>(getPostAuctionsIdStartUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getPostAuctionsIdStartMutationOptions = <TError = PostAuctionsIdStartErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdStart>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdStart>>, TError,{id: number}, TContext> => {

const mutationKey = ['postAuctionsIdStart'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsIdStart>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postAuctionsIdStart(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsIdStartMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsIdStart>>>
    
    export type PostAuctionsIdStartMutationError = PostAuctionsIdStartErrorType<unknown>

    export const usePostAuctionsIdStart = <TError = PostAuctionsIdStartErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsIdStart>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsIdStart>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostAuctionsIdStartMutationOptions(options));
    }
    export type getAuctionsFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getAuctionsFiltersFilterNameResponseSuccess = (getAuctionsFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getAuctionsFiltersFilterNameResponse = (getAuctionsFiltersFilterNameResponseSuccess)

export const getGetAuctionsFiltersFilterNameUrl = (filterName: string,
    params?: GetAuctionsFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auctions/filters/${filterName}/?${stringifiedParams}` : `/api/auctions/filters/${filterName}/`
}

export const getAuctionsFiltersFilterName = async (filterName: string,
    params?: GetAuctionsFiltersFilterNameParams, options?: RequestInit): Promise<getAuctionsFiltersFilterNameResponse> => {
  
  return getAuctionsFiltersFilterNameMutator<getAuctionsFiltersFilterNameResponse>(getGetAuctionsFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsFiltersFilterNameQueryKey = (filterName: string,
    params?: GetAuctionsFiltersFilterNameParams,) => {
    return [
    `/api/auctions/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAuctionsFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>, TError = GetAuctionsFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetAuctionsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>> = ({ signal }) => getAuctionsFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>>
export type GetAuctionsFiltersFilterNameQueryError = GetAuctionsFiltersFilterNameErrorType<unknown>



export function useGetAuctionsFiltersFilterName<TData = Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>, TError = GetAuctionsFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetAuctionsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type patchAuctionsStageOffersIdResponse200 = {
  data: AuctionStageOfferSelection
  status: 200
}

export type patchAuctionsStageOffersIdResponseSuccess = (patchAuctionsStageOffersIdResponse200) & {
  headers: Headers;
};
;

export type patchAuctionsStageOffersIdResponse = (patchAuctionsStageOffersIdResponseSuccess)

export const getPatchAuctionsStageOffersIdUrl = (id: number,) => {


  

  return `/api/auctions/stage-offers/${id}/`
}

export const patchAuctionsStageOffersId = async (id: number,
    patchedAuctionStageOfferSelection: PatchedAuctionStageOfferSelection, options?: RequestInit): Promise<patchAuctionsStageOffersIdResponse> => {
  
  return patchAuctionsStageOffersIdMutator<patchAuctionsStageOffersIdResponse>(getPatchAuctionsStageOffersIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAuctionStageOfferSelection,)
  }
);}
  



export const getPatchAuctionsStageOffersIdMutationOptions = <TError = PatchAuctionsStageOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAuctionsStageOffersId>>, TError,{id: number;data: PatchedAuctionStageOfferSelection}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAuctionsStageOffersId>>, TError,{id: number;data: PatchedAuctionStageOfferSelection}, TContext> => {

const mutationKey = ['patchAuctionsStageOffersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAuctionsStageOffersId>>, {id: number;data: PatchedAuctionStageOfferSelection}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAuctionsStageOffersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAuctionsStageOffersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAuctionsStageOffersId>>>
    export type PatchAuctionsStageOffersIdMutationBody = PatchedAuctionStageOfferSelection
    export type PatchAuctionsStageOffersIdMutationError = PatchAuctionsStageOffersIdErrorType<unknown>

    export const usePatchAuctionsStageOffersId = <TError = PatchAuctionsStageOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAuctionsStageOffersId>>, TError,{id: number;data: PatchedAuctionStageOfferSelection}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchAuctionsStageOffersId>>,
        TError,
        {id: number;data: PatchedAuctionStageOfferSelection},
        TContext
      > => {
      return useMutation(getPatchAuctionsStageOffersIdMutationOptions(options));
    }
    export type getAuctionsSupplierResponse200 = {
  data: PaginatedAuctionSupplierListList
  status: 200
}

export type getAuctionsSupplierResponseSuccess = (getAuctionsSupplierResponse200) & {
  headers: Headers;
};
;

export type getAuctionsSupplierResponse = (getAuctionsSupplierResponseSuccess)

export const getGetAuctionsSupplierUrl = (params?: GetAuctionsSupplierParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auctions/supplier/?${stringifiedParams}` : `/api/auctions/supplier/`
}

export const getAuctionsSupplier = async (params?: GetAuctionsSupplierParams, options?: RequestInit): Promise<getAuctionsSupplierResponse> => {
  
  return getAuctionsSupplierMutator<getAuctionsSupplierResponse>(getGetAuctionsSupplierUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsSupplierQueryKey = (params?: GetAuctionsSupplierParams,) => {
    return [
    `/api/auctions/supplier/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAuctionsSupplierQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsSupplier>>, TError = GetAuctionsSupplierErrorType<unknown>>(params?: GetAuctionsSupplierParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplier>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsSupplierQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsSupplier>>> = ({ signal }) => getAuctionsSupplier(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplier>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsSupplierQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsSupplier>>>
export type GetAuctionsSupplierQueryError = GetAuctionsSupplierErrorType<unknown>



export function useGetAuctionsSupplier<TData = Awaited<ReturnType<typeof getAuctionsSupplier>>, TError = GetAuctionsSupplierErrorType<unknown>>(
 params?: GetAuctionsSupplierParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplier>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsSupplierQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Проверяем наличие query-параметров отмеченных обязательными в фильтре.

Тут тот же подход, что в UserFilterPresetViewSet.
Хотим максимально уменьшить вероятность выбрать шаблон неподходящий к конкретному аукциону.
 */
export type getAuctionsSupplierProgramTemplatesResponse200 = {
  data: AuctionSupplierProgramTemplate[]
  status: 200
}

export type getAuctionsSupplierProgramTemplatesResponseSuccess = (getAuctionsSupplierProgramTemplatesResponse200) & {
  headers: Headers;
};
;

export type getAuctionsSupplierProgramTemplatesResponse = (getAuctionsSupplierProgramTemplatesResponseSuccess)

export const getGetAuctionsSupplierProgramTemplatesUrl = (params: GetAuctionsSupplierProgramTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auctions/supplier-program-templates/?${stringifiedParams}` : `/api/auctions/supplier-program-templates/`
}

export const getAuctionsSupplierProgramTemplates = async (params: GetAuctionsSupplierProgramTemplatesParams, options?: RequestInit): Promise<getAuctionsSupplierProgramTemplatesResponse> => {
  
  return getAuctionsSupplierProgramTemplatesMutator<getAuctionsSupplierProgramTemplatesResponse>(getGetAuctionsSupplierProgramTemplatesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsSupplierProgramTemplatesQueryKey = (params?: GetAuctionsSupplierProgramTemplatesParams,) => {
    return [
    `/api/auctions/supplier-program-templates/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAuctionsSupplierProgramTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>, TError = GetAuctionsSupplierProgramTemplatesErrorType<unknown>>(params: GetAuctionsSupplierProgramTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsSupplierProgramTemplatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>> = ({ signal }) => getAuctionsSupplierProgramTemplates(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsSupplierProgramTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>>
export type GetAuctionsSupplierProgramTemplatesQueryError = GetAuctionsSupplierProgramTemplatesErrorType<unknown>



export function useGetAuctionsSupplierProgramTemplates<TData = Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>, TError = GetAuctionsSupplierProgramTemplatesErrorType<unknown>>(
 params: GetAuctionsSupplierProgramTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsSupplierProgramTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postAuctionsSupplierProgramTemplatesResponse201 = {
  data: AuctionSupplierProgramTemplateCreateUpdate
  status: 201
}

export type postAuctionsSupplierProgramTemplatesResponseSuccess = (postAuctionsSupplierProgramTemplatesResponse201) & {
  headers: Headers;
};
;

export type postAuctionsSupplierProgramTemplatesResponse = (postAuctionsSupplierProgramTemplatesResponseSuccess)

export const getPostAuctionsSupplierProgramTemplatesUrl = () => {


  

  return `/api/auctions/supplier-program-templates/`
}

export const postAuctionsSupplierProgramTemplates = async (auctionSupplierProgramTemplateCreateUpdate: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>, options?: RequestInit): Promise<postAuctionsSupplierProgramTemplatesResponse> => {
  
  return postAuctionsSupplierProgramTemplatesMutator<postAuctionsSupplierProgramTemplatesResponse>(getPostAuctionsSupplierProgramTemplatesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionSupplierProgramTemplateCreateUpdate,)
  }
);}
  



export const getPostAuctionsSupplierProgramTemplatesMutationOptions = <TError = PostAuctionsSupplierProgramTemplatesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>, TError,{data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>, TError,{data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext> => {

const mutationKey = ['postAuctionsSupplierProgramTemplates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>, {data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  postAuctionsSupplierProgramTemplates(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuctionsSupplierProgramTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>>
    export type PostAuctionsSupplierProgramTemplatesMutationBody = NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>
    export type PostAuctionsSupplierProgramTemplatesMutationError = PostAuctionsSupplierProgramTemplatesErrorType<unknown>

    export const usePostAuctionsSupplierProgramTemplates = <TError = PostAuctionsSupplierProgramTemplatesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>, TError,{data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuctionsSupplierProgramTemplates>>,
        TError,
        {data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>},
        TContext
      > => {
      return useMutation(getPostAuctionsSupplierProgramTemplatesMutationOptions(options));
    }
    export type getAuctionsSupplierProgramTemplatesIdResponse200 = {
  data: AuctionSupplierProgramTemplate
  status: 200
}

export type getAuctionsSupplierProgramTemplatesIdResponseSuccess = (getAuctionsSupplierProgramTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type getAuctionsSupplierProgramTemplatesIdResponse = (getAuctionsSupplierProgramTemplatesIdResponseSuccess)

export const getGetAuctionsSupplierProgramTemplatesIdUrl = (id: number,) => {


  

  return `/api/auctions/supplier-program-templates/${id}/`
}

export const getAuctionsSupplierProgramTemplatesId = async (id: number, options?: RequestInit): Promise<getAuctionsSupplierProgramTemplatesIdResponse> => {
  
  return getAuctionsSupplierProgramTemplatesIdMutator<getAuctionsSupplierProgramTemplatesIdResponse>(getGetAuctionsSupplierProgramTemplatesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsSupplierProgramTemplatesIdQueryKey = (id: number,) => {
    return [
    `/api/auctions/supplier-program-templates/${id}/`
    ] as const;
    }

    
export const getGetAuctionsSupplierProgramTemplatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>, TError = GetAuctionsSupplierProgramTemplatesIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsSupplierProgramTemplatesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>> = ({ signal }) => getAuctionsSupplierProgramTemplatesId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsSupplierProgramTemplatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>>
export type GetAuctionsSupplierProgramTemplatesIdQueryError = GetAuctionsSupplierProgramTemplatesIdErrorType<unknown>



export function useGetAuctionsSupplierProgramTemplatesId<TData = Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>, TError = GetAuctionsSupplierProgramTemplatesIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierProgramTemplatesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsSupplierProgramTemplatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putAuctionsSupplierProgramTemplatesIdResponse200 = {
  data: AuctionSupplierProgramTemplateCreateUpdate
  status: 200
}

export type putAuctionsSupplierProgramTemplatesIdResponseSuccess = (putAuctionsSupplierProgramTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type putAuctionsSupplierProgramTemplatesIdResponse = (putAuctionsSupplierProgramTemplatesIdResponseSuccess)

export const getPutAuctionsSupplierProgramTemplatesIdUrl = (id: number,) => {


  

  return `/api/auctions/supplier-program-templates/${id}/`
}

export const putAuctionsSupplierProgramTemplatesId = async (id: number,
    auctionSupplierProgramTemplateCreateUpdate: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>, options?: RequestInit): Promise<putAuctionsSupplierProgramTemplatesIdResponse> => {
  
  return putAuctionsSupplierProgramTemplatesIdMutator<putAuctionsSupplierProgramTemplatesIdResponse>(getPutAuctionsSupplierProgramTemplatesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      auctionSupplierProgramTemplateCreateUpdate,)
  }
);}
  



export const getPutAuctionsSupplierProgramTemplatesIdMutationOptions = <TError = PutAuctionsSupplierProgramTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>, TError,{id: number;data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>, TError,{id: number;data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext> => {

const mutationKey = ['putAuctionsSupplierProgramTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>, {id: number;data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putAuctionsSupplierProgramTemplatesId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuctionsSupplierProgramTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>>
    export type PutAuctionsSupplierProgramTemplatesIdMutationBody = NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>
    export type PutAuctionsSupplierProgramTemplatesIdMutationError = PutAuctionsSupplierProgramTemplatesIdErrorType<unknown>

    export const usePutAuctionsSupplierProgramTemplatesId = <TError = PutAuctionsSupplierProgramTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>, TError,{id: number;data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putAuctionsSupplierProgramTemplatesId>>,
        TError,
        {id: number;data: NonReadonly<AuctionSupplierProgramTemplateCreateUpdate>},
        TContext
      > => {
      return useMutation(getPutAuctionsSupplierProgramTemplatesIdMutationOptions(options));
    }
    export type deleteAuctionsSupplierProgramTemplatesIdResponse204 = {
  data: void
  status: 204
}

export type deleteAuctionsSupplierProgramTemplatesIdResponseSuccess = (deleteAuctionsSupplierProgramTemplatesIdResponse204) & {
  headers: Headers;
};
;

export type deleteAuctionsSupplierProgramTemplatesIdResponse = (deleteAuctionsSupplierProgramTemplatesIdResponseSuccess)

export const getDeleteAuctionsSupplierProgramTemplatesIdUrl = (id: number,) => {


  

  return `/api/auctions/supplier-program-templates/${id}/`
}

export const deleteAuctionsSupplierProgramTemplatesId = async (id: number, options?: RequestInit): Promise<deleteAuctionsSupplierProgramTemplatesIdResponse> => {
  
  return deleteAuctionsSupplierProgramTemplatesIdMutator<deleteAuctionsSupplierProgramTemplatesIdResponse>(getDeleteAuctionsSupplierProgramTemplatesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteAuctionsSupplierProgramTemplatesIdMutationOptions = <TError = DeleteAuctionsSupplierProgramTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAuctionsSupplierProgramTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAuctionsSupplierProgramTemplatesId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAuctionsSupplierProgramTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>>
    
    export type DeleteAuctionsSupplierProgramTemplatesIdMutationError = DeleteAuctionsSupplierProgramTemplatesIdErrorType<unknown>

    export const useDeleteAuctionsSupplierProgramTemplatesId = <TError = DeleteAuctionsSupplierProgramTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAuctionsSupplierProgramTemplatesId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAuctionsSupplierProgramTemplatesIdMutationOptions(options));
    }
    export type getAuctionsSupplierFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getAuctionsSupplierFiltersFilterNameResponseSuccess = (getAuctionsSupplierFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getAuctionsSupplierFiltersFilterNameResponse = (getAuctionsSupplierFiltersFilterNameResponseSuccess)

export const getGetAuctionsSupplierFiltersFilterNameUrl = (filterName: string,
    params?: GetAuctionsSupplierFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auctions/supplier/filters/${filterName}/?${stringifiedParams}` : `/api/auctions/supplier/filters/${filterName}/`
}

export const getAuctionsSupplierFiltersFilterName = async (filterName: string,
    params?: GetAuctionsSupplierFiltersFilterNameParams, options?: RequestInit): Promise<getAuctionsSupplierFiltersFilterNameResponse> => {
  
  return getAuctionsSupplierFiltersFilterNameMutator<getAuctionsSupplierFiltersFilterNameResponse>(getGetAuctionsSupplierFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetAuctionsSupplierFiltersFilterNameQueryKey = (filterName: string,
    params?: GetAuctionsSupplierFiltersFilterNameParams,) => {
    return [
    `/api/auctions/supplier/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetAuctionsSupplierFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>, TError = GetAuctionsSupplierFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetAuctionsSupplierFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuctionsSupplierFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>> = ({ signal }) => getAuctionsSupplierFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuctionsSupplierFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>>
export type GetAuctionsSupplierFiltersFilterNameQueryError = GetAuctionsSupplierFiltersFilterNameErrorType<unknown>



export function useGetAuctionsSupplierFiltersFilterName<TData = Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>, TError = GetAuctionsSupplierFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetAuctionsSupplierFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuctionsSupplierFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuctionsSupplierFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getBananasResponse200 = {
  data: BananaOfferList[]
  status: 200
}

export type getBananasResponseSuccess = (getBananasResponse200) & {
  headers: Headers;
};
;

export type getBananasResponse = (getBananasResponseSuccess)

export const getGetBananasUrl = () => {


  

  return `/api/bananas/`
}

export const getBananas = async ( options?: RequestInit): Promise<getBananasResponse> => {
  
  return getBananasMutator<getBananasResponse>(getGetBananasUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasQueryKey = () => {
    return [
    `/api/bananas/`
    ] as const;
    }

    
export const getGetBananasQueryOptions = <TData = Awaited<ReturnType<typeof getBananas>>, TError = GetBananasErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananas>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananas>>> = ({ signal }) => getBananas({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananas>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasQueryResult = NonNullable<Awaited<ReturnType<typeof getBananas>>>
export type GetBananasQueryError = GetBananasErrorType<unknown>



export function useGetBananas<TData = Awaited<ReturnType<typeof getBananas>>, TError = GetBananasErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananas>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postBananasResponse201 = {
  data: BananaOffer
  status: 201
}

export type postBananasResponseSuccess = (postBananasResponse201) & {
  headers: Headers;
};
;

export type postBananasResponse = (postBananasResponseSuccess)

export const getPostBananasUrl = () => {


  

  return `/api/bananas/`
}

export const postBananas = async (bananaOffer: NonReadonly<BananaOffer>, options?: RequestInit): Promise<postBananasResponse> => {
  
  return postBananasMutator<postBananasResponse>(getPostBananasUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bananaOffer,)
  }
);}
  



export const getPostBananasMutationOptions = <TError = PostBananasErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBananas>>, TError,{data: NonReadonly<BananaOffer>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBananas>>, TError,{data: NonReadonly<BananaOffer>}, TContext> => {

const mutationKey = ['postBananas'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBananas>>, {data: NonReadonly<BananaOffer>}> = (props) => {
          const {data} = props ?? {};

          return  postBananas(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostBananasMutationResult = NonNullable<Awaited<ReturnType<typeof postBananas>>>
    export type PostBananasMutationBody = NonReadonly<BananaOffer>
    export type PostBananasMutationError = PostBananasErrorType<unknown>

    export const usePostBananas = <TError = PostBananasErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBananas>>, TError,{data: NonReadonly<BananaOffer>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postBananas>>,
        TError,
        {data: NonReadonly<BananaOffer>},
        TContext
      > => {
      return useMutation(getPostBananasMutationOptions(options));
    }
    export type getBananasIdResponse200 = {
  data: BananaOffer
  status: 200
}

export type getBananasIdResponseSuccess = (getBananasIdResponse200) & {
  headers: Headers;
};
;

export type getBananasIdResponse = (getBananasIdResponseSuccess)

export const getGetBananasIdUrl = (id: number,) => {


  

  return `/api/bananas/${id}/`
}

export const getBananasId = async (id: number, options?: RequestInit): Promise<getBananasIdResponse> => {
  
  return getBananasIdMutator<getBananasIdResponse>(getGetBananasIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasIdQueryKey = (id: number,) => {
    return [
    `/api/bananas/${id}/`
    ] as const;
    }

    
export const getGetBananasIdQueryOptions = <TData = Awaited<ReturnType<typeof getBananasId>>, TError = GetBananasIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananasId>>> = ({ signal }) => getBananasId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananasId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBananasId>>>
export type GetBananasIdQueryError = GetBananasIdErrorType<unknown>



export function useGetBananasId<TData = Awaited<ReturnType<typeof getBananasId>>, TError = GetBananasIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putBananasIdResponse200 = {
  data: BananaOffer
  status: 200
}

export type putBananasIdResponseSuccess = (putBananasIdResponse200) & {
  headers: Headers;
};
;

export type putBananasIdResponse = (putBananasIdResponseSuccess)

export const getPutBananasIdUrl = (id: number,) => {


  

  return `/api/bananas/${id}/`
}

export const putBananasId = async (id: number,
    bananaOffer: NonReadonly<BananaOffer>, options?: RequestInit): Promise<putBananasIdResponse> => {
  
  return putBananasIdMutator<putBananasIdResponse>(getPutBananasIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bananaOffer,)
  }
);}
  



export const getPutBananasIdMutationOptions = <TError = PutBananasIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBananasId>>, TError,{id: number;data: NonReadonly<BananaOffer>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBananasId>>, TError,{id: number;data: NonReadonly<BananaOffer>}, TContext> => {

const mutationKey = ['putBananasId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBananasId>>, {id: number;data: NonReadonly<BananaOffer>}> = (props) => {
          const {id,data} = props ?? {};

          return  putBananasId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutBananasIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBananasId>>>
    export type PutBananasIdMutationBody = NonReadonly<BananaOffer>
    export type PutBananasIdMutationError = PutBananasIdErrorType<unknown>

    export const usePutBananasId = <TError = PutBananasIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBananasId>>, TError,{id: number;data: NonReadonly<BananaOffer>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putBananasId>>,
        TError,
        {id: number;data: NonReadonly<BananaOffer>},
        TContext
      > => {
      return useMutation(getPutBananasIdMutationOptions(options));
    }
    /**
 * Выгрузка банановых офферов в Excel.
 */
export type getBananasExportReportResponse200 = {
  data: Blob
  status: 200
}

export type getBananasExportReportResponseSuccess = (getBananasExportReportResponse200) & {
  headers: Headers;
};
;

export type getBananasExportReportResponse = (getBananasExportReportResponseSuccess)

export const getGetBananasExportReportUrl = () => {


  

  return `/api/bananas/export-report/`
}

export const getBananasExportReport = async ( options?: RequestInit): Promise<getBananasExportReportResponse> => {
  
  return getBananasExportReportMutator<getBananasExportReportResponse>(getGetBananasExportReportUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasExportReportQueryKey = () => {
    return [
    `/api/bananas/export-report/`
    ] as const;
    }

    
export const getGetBananasExportReportQueryOptions = <TData = Awaited<ReturnType<typeof getBananasExportReport>>, TError = GetBananasExportReportErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasExportReport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasExportReportQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananasExportReport>>> = ({ signal }) => getBananasExportReport({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananasExportReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasExportReportQueryResult = NonNullable<Awaited<ReturnType<typeof getBananasExportReport>>>
export type GetBananasExportReportQueryError = GetBananasExportReportErrorType<unknown>



export function useGetBananasExportReport<TData = Awaited<ReturnType<typeof getBananasExportReport>>, TError = GetBananasExportReportErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasExportReport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasExportReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Mixin which allows the override of the filename being
passed back to the user when the spreadsheet is downloaded.
 * @deprecated
 */
export type getBananasExportExcelResponse200 = {
  data: Blob
  status: 200
}

export type getBananasExportExcelResponseSuccess = (getBananasExportExcelResponse200) & {
  headers: Headers;
};
;

export type getBananasExportExcelResponse = (getBananasExportExcelResponseSuccess)

export const getGetBananasExportExcelUrl = () => {


  

  return `/api/bananas/export/excel/`
}

export const getBananasExportExcel = async ( options?: RequestInit): Promise<getBananasExportExcelResponse> => {
  
  return getBananasExportExcelMutator<getBananasExportExcelResponse>(getGetBananasExportExcelUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasExportExcelQueryKey = () => {
    return [
    `/api/bananas/export/excel/`
    ] as const;
    }

    
export const getGetBananasExportExcelQueryOptions = <TData = Awaited<ReturnType<typeof getBananasExportExcel>>, TError = GetBananasExportExcelErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasExportExcel>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasExportExcelQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananasExportExcel>>> = ({ signal }) => getBananasExportExcel({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananasExportExcel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasExportExcelQueryResult = NonNullable<Awaited<ReturnType<typeof getBananasExportExcel>>>
export type GetBananasExportExcelQueryError = GetBananasExportExcelErrorType<unknown>


/**
 * @deprecated
 */

export function useGetBananasExportExcel<TData = Awaited<ReturnType<typeof getBananasExportExcel>>, TError = GetBananasExportExcelErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasExportExcel>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasExportExcelQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getBananasProductsResponse200 = {
  data: BananaProductList[]
  status: 200
}

export type getBananasProductsResponseSuccess = (getBananasProductsResponse200) & {
  headers: Headers;
};
;

export type getBananasProductsResponse = (getBananasProductsResponseSuccess)

export const getGetBananasProductsUrl = () => {


  

  return `/api/bananas/products/`
}

export const getBananasProducts = async ( options?: RequestInit): Promise<getBananasProductsResponse> => {
  
  return getBananasProductsMutator<getBananasProductsResponse>(getGetBananasProductsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasProductsQueryKey = () => {
    return [
    `/api/bananas/products/`
    ] as const;
    }

    
export const getGetBananasProductsQueryOptions = <TData = Awaited<ReturnType<typeof getBananasProducts>>, TError = GetBananasProductsErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasProducts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananasProducts>>> = ({ signal }) => getBananasProducts({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananasProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getBananasProducts>>>
export type GetBananasProductsQueryError = GetBananasProductsErrorType<unknown>



export function useGetBananasProducts<TData = Awaited<ReturnType<typeof getBananasProducts>>, TError = GetBananasProductsErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasProducts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getBananasProductsIdResponse200 = {
  data: BananaProductList
  status: 200
}

export type getBananasProductsIdResponseSuccess = (getBananasProductsIdResponse200) & {
  headers: Headers;
};
;

export type getBananasProductsIdResponse = (getBananasProductsIdResponseSuccess)

export const getGetBananasProductsIdUrl = (id: number,) => {


  

  return `/api/bananas/products/${id}/`
}

export const getBananasProductsId = async (id: number, options?: RequestInit): Promise<getBananasProductsIdResponse> => {
  
  return getBananasProductsIdMutator<getBananasProductsIdResponse>(getGetBananasProductsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetBananasProductsIdQueryKey = (id: number,) => {
    return [
    `/api/bananas/products/${id}/`
    ] as const;
    }

    
export const getGetBananasProductsIdQueryOptions = <TData = Awaited<ReturnType<typeof getBananasProductsId>>, TError = GetBananasProductsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasProductsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBananasProductsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBananasProductsId>>> = ({ signal }) => getBananasProductsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBananasProductsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBananasProductsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBananasProductsId>>>
export type GetBananasProductsIdQueryError = GetBananasProductsIdErrorType<unknown>



export function useGetBananasProductsId<TData = Awaited<ReturnType<typeof getBananasProductsId>>, TError = GetBananasProductsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBananasProductsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBananasProductsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCommentsResponse200 = {
  data: CommentList[]
  status: 200
}

export type getCommentsResponseSuccess = (getCommentsResponse200) & {
  headers: Headers;
};
;

export type getCommentsResponse = (getCommentsResponseSuccess)

export const getGetCommentsUrl = (params: GetCommentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/comments/?${stringifiedParams}` : `/api/comments/`
}

export const getComments = async (params: GetCommentsParams, options?: RequestInit): Promise<getCommentsResponse> => {
  
  return getCommentsMutator<getCommentsResponse>(getGetCommentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCommentsQueryKey = (params?: GetCommentsParams,) => {
    return [
    `/api/comments/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getComments>>, TError = GetCommentsErrorType<unknown>>(params: GetCommentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getComments>>> = ({ signal }) => getComments(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getComments>>>
export type GetCommentsQueryError = GetCommentsErrorType<unknown>



export function useGetComments<TData = Awaited<ReturnType<typeof getComments>>, TError = GetCommentsErrorType<unknown>>(
 params: GetCommentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getComments>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCommentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postCommentsCreateResponse201 = {
  data: Comment
  status: 201
}

export type postCommentsCreateResponseSuccess = (postCommentsCreateResponse201) & {
  headers: Headers;
};
;

export type postCommentsCreateResponse = (postCommentsCreateResponseSuccess)

export const getPostCommentsCreateUrl = () => {


  

  return `/api/comments/create/`
}

export const postCommentsCreate = async (comment: NonReadonly<Comment>, options?: RequestInit): Promise<postCommentsCreateResponse> => {
  
  return postCommentsCreateMutator<postCommentsCreateResponse>(getPostCommentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      comment,)
  }
);}
  



export const getPostCommentsCreateMutationOptions = <TError = PostCommentsCreateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreate>>, TError,{data: NonReadonly<Comment>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreate>>, TError,{data: NonReadonly<Comment>}, TContext> => {

const mutationKey = ['postCommentsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsCreate>>, {data: NonReadonly<Comment>}> = (props) => {
          const {data} = props ?? {};

          return  postCommentsCreate(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsCreate>>>
    export type PostCommentsCreateMutationBody = NonReadonly<Comment>
    export type PostCommentsCreateMutationError = PostCommentsCreateErrorType<unknown>

    export const usePostCommentsCreate = <TError = PostCommentsCreateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreate>>, TError,{data: NonReadonly<Comment>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCommentsCreate>>,
        TError,
        {data: NonReadonly<Comment>},
        TContext
      > => {
      return useMutation(getPostCommentsCreateMutationOptions(options));
    }
    export type postCommentsCreateMultipleResponse200 = {
  data: Comment[]
  status: 200
}

export type postCommentsCreateMultipleResponseSuccess = (postCommentsCreateMultipleResponse200) & {
  headers: Headers;
};
;

export type postCommentsCreateMultipleResponse = (postCommentsCreateMultipleResponseSuccess)

export const getPostCommentsCreateMultipleUrl = () => {


  

  return `/api/comments/create-multiple/`
}

export const postCommentsCreateMultiple = async (comment: NonReadonly<Comment[]>, options?: RequestInit): Promise<postCommentsCreateMultipleResponse> => {
  
  return postCommentsCreateMultipleMutator<postCommentsCreateMultipleResponse>(getPostCommentsCreateMultipleUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      comment,)
  }
);}
  



export const getPostCommentsCreateMultipleMutationOptions = <TError = PostCommentsCreateMultipleErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreateMultiple>>, TError,{data: NonReadonly<Comment[]>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreateMultiple>>, TError,{data: NonReadonly<Comment[]>}, TContext> => {

const mutationKey = ['postCommentsCreateMultiple'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsCreateMultiple>>, {data: NonReadonly<Comment[]>}> = (props) => {
          const {data} = props ?? {};

          return  postCommentsCreateMultiple(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsCreateMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsCreateMultiple>>>
    export type PostCommentsCreateMultipleMutationBody = NonReadonly<Comment[]>
    export type PostCommentsCreateMultipleMutationError = PostCommentsCreateMultipleErrorType<unknown>

    export const usePostCommentsCreateMultiple = <TError = PostCommentsCreateMultipleErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCreateMultiple>>, TError,{data: NonReadonly<Comment[]>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCommentsCreateMultiple>>,
        TError,
        {data: NonReadonly<Comment[]>},
        TContext
      > => {
      return useMutation(getPostCommentsCreateMultipleMutationOptions(options));
    }
    export type getCommentsUnseenCountersResponse200 = {
  data: UnseenCommentsCounters[]
  status: 200
}

export type getCommentsUnseenCountersResponseSuccess = (getCommentsUnseenCountersResponse200) & {
  headers: Headers;
};
;

export type getCommentsUnseenCountersResponse = (getCommentsUnseenCountersResponseSuccess)

export const getGetCommentsUnseenCountersUrl = (params: GetCommentsUnseenCountersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/comments/unseen-counters/?${stringifiedParams}` : `/api/comments/unseen-counters/`
}

export const getCommentsUnseenCounters = async (params: GetCommentsUnseenCountersParams, options?: RequestInit): Promise<getCommentsUnseenCountersResponse> => {
  
  return getCommentsUnseenCountersMutator<getCommentsUnseenCountersResponse>(getGetCommentsUnseenCountersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCommentsUnseenCountersQueryKey = (params?: GetCommentsUnseenCountersParams,) => {
    return [
    `/api/comments/unseen-counters/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCommentsUnseenCountersQueryOptions = <TData = Awaited<ReturnType<typeof getCommentsUnseenCounters>>, TError = GetCommentsUnseenCountersErrorType<unknown>>(params: GetCommentsUnseenCountersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommentsUnseenCounters>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsUnseenCountersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommentsUnseenCounters>>> = ({ signal }) => getCommentsUnseenCounters(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommentsUnseenCounters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCommentsUnseenCountersQueryResult = NonNullable<Awaited<ReturnType<typeof getCommentsUnseenCounters>>>
export type GetCommentsUnseenCountersQueryError = GetCommentsUnseenCountersErrorType<unknown>



export function useGetCommentsUnseenCounters<TData = Awaited<ReturnType<typeof getCommentsUnseenCounters>>, TError = GetCommentsUnseenCountersErrorType<unknown>>(
 params: GetCommentsUnseenCountersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCommentsUnseenCounters>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCommentsUnseenCountersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type getCoreCountryCountryPkRegionsResponse200 = {
  data: Region[]
  status: 200
}

export type getCoreCountryCountryPkRegionsResponseSuccess = (getCoreCountryCountryPkRegionsResponse200) & {
  headers: Headers;
};
;

export type getCoreCountryCountryPkRegionsResponse = (getCoreCountryCountryPkRegionsResponseSuccess)

export const getGetCoreCountryCountryPkRegionsUrl = (countryPk: number,) => {


  

  return `/api/core/country/${countryPk}/regions/`
}

export const getCoreCountryCountryPkRegions = async (countryPk: number, options?: RequestInit): Promise<getCoreCountryCountryPkRegionsResponse> => {
  
  return getCoreCountryCountryPkRegionsMutator<getCoreCountryCountryPkRegionsResponse>(getGetCoreCountryCountryPkRegionsUrl(countryPk),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreCountryCountryPkRegionsQueryKey = (countryPk: number,) => {
    return [
    `/api/core/country/${countryPk}/regions/`
    ] as const;
    }

    
export const getGetCoreCountryCountryPkRegionsQueryOptions = <TData = Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>, TError = GetCoreCountryCountryPkRegionsErrorType<unknown>>(countryPk: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreCountryCountryPkRegionsQueryKey(countryPk);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>> = ({ signal }) => getCoreCountryCountryPkRegions(countryPk, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(countryPk), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreCountryCountryPkRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>>
export type GetCoreCountryCountryPkRegionsQueryError = GetCoreCountryCountryPkRegionsErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreCountryCountryPkRegions<TData = Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>, TError = GetCoreCountryCountryPkRegionsErrorType<unknown>>(
 countryPk: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreCountryCountryPkRegions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreCountryCountryPkRegionsQueryOptions(countryPk,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreCustomsEntryPointsResponse200 = {
  data: GeoCustomsEntryPoint[]
  status: 200
}

export type getCoreCustomsEntryPointsResponseSuccess = (getCoreCustomsEntryPointsResponse200) & {
  headers: Headers;
};
;

export type getCoreCustomsEntryPointsResponse = (getCoreCustomsEntryPointsResponseSuccess)

export const getGetCoreCustomsEntryPointsUrl = (params?: GetCoreCustomsEntryPointsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/customs-entry-points/?${stringifiedParams}` : `/api/core/customs-entry-points/`
}

export const getCoreCustomsEntryPoints = async (params?: GetCoreCustomsEntryPointsParams, options?: RequestInit): Promise<getCoreCustomsEntryPointsResponse> => {
  
  return getCoreCustomsEntryPointsMutator<getCoreCustomsEntryPointsResponse>(getGetCoreCustomsEntryPointsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreCustomsEntryPointsQueryKey = (params?: GetCoreCustomsEntryPointsParams,) => {
    return [
    `/api/core/customs-entry-points/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreCustomsEntryPointsQueryOptions = <TData = Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>, TError = GetCoreCustomsEntryPointsErrorType<unknown>>(params?: GetCoreCustomsEntryPointsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreCustomsEntryPointsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>> = ({ signal }) => getCoreCustomsEntryPoints(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreCustomsEntryPointsQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>>
export type GetCoreCustomsEntryPointsQueryError = GetCoreCustomsEntryPointsErrorType<unknown>



export function useGetCoreCustomsEntryPoints<TData = Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>, TError = GetCoreCustomsEntryPointsErrorType<unknown>>(
 params?: GetCoreCustomsEntryPointsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreCustomsEntryPoints>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreCustomsEntryPointsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Список доступных точек доставки
 */
export type getCoreDeliveryPointsResponse200 = {
  data: DeliveryPointItem[]
  status: 200
}

export type getCoreDeliveryPointsResponseSuccess = (getCoreDeliveryPointsResponse200) & {
  headers: Headers;
};
;

export type getCoreDeliveryPointsResponse = (getCoreDeliveryPointsResponseSuccess)

export const getGetCoreDeliveryPointsUrl = () => {


  

  return `/api/core/delivery-points/`
}

export const getCoreDeliveryPoints = async ( options?: RequestInit): Promise<getCoreDeliveryPointsResponse> => {
  
  return getCoreDeliveryPointsMutator<getCoreDeliveryPointsResponse>(getGetCoreDeliveryPointsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreDeliveryPointsQueryKey = () => {
    return [
    `/api/core/delivery-points/`
    ] as const;
    }

    
export const getGetCoreDeliveryPointsQueryOptions = <TData = Awaited<ReturnType<typeof getCoreDeliveryPoints>>, TError = GetCoreDeliveryPointsErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPoints>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreDeliveryPointsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreDeliveryPoints>>> = ({ signal }) => getCoreDeliveryPoints({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPoints>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreDeliveryPointsQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreDeliveryPoints>>>
export type GetCoreDeliveryPointsQueryError = GetCoreDeliveryPointsErrorType<unknown>



export function useGetCoreDeliveryPoints<TData = Awaited<ReturnType<typeof getCoreDeliveryPoints>>, TError = GetCoreDeliveryPointsErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPoints>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreDeliveryPointsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Список точек доставки доступных для существующего предложения
 */
export type getCoreDeliveryPointsAvailableForOfferOfferIdResponse200 = {
  data: PointInlineWithPriceFlag[]
  status: 200
}

export type getCoreDeliveryPointsAvailableForOfferOfferIdResponseSuccess = (getCoreDeliveryPointsAvailableForOfferOfferIdResponse200) & {
  headers: Headers;
};
;

export type getCoreDeliveryPointsAvailableForOfferOfferIdResponse = (getCoreDeliveryPointsAvailableForOfferOfferIdResponseSuccess)

export const getGetCoreDeliveryPointsAvailableForOfferOfferIdUrl = (offerId: number,) => {


  

  return `/api/core/delivery-points/available-for-offer/${offerId}/`
}

export const getCoreDeliveryPointsAvailableForOfferOfferId = async (offerId: number, options?: RequestInit): Promise<getCoreDeliveryPointsAvailableForOfferOfferIdResponse> => {
  
  return getCoreDeliveryPointsAvailableForOfferOfferIdMutator<getCoreDeliveryPointsAvailableForOfferOfferIdResponse>(getGetCoreDeliveryPointsAvailableForOfferOfferIdUrl(offerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreDeliveryPointsAvailableForOfferOfferIdQueryKey = (offerId: number,) => {
    return [
    `/api/core/delivery-points/available-for-offer/${offerId}/`
    ] as const;
    }

    
export const getGetCoreDeliveryPointsAvailableForOfferOfferIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>, TError = GetCoreDeliveryPointsAvailableForOfferOfferIdErrorType<unknown>>(offerId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreDeliveryPointsAvailableForOfferOfferIdQueryKey(offerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>> = ({ signal }) => getCoreDeliveryPointsAvailableForOfferOfferId(offerId, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(offerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreDeliveryPointsAvailableForOfferOfferIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>>
export type GetCoreDeliveryPointsAvailableForOfferOfferIdQueryError = GetCoreDeliveryPointsAvailableForOfferOfferIdErrorType<unknown>



export function useGetCoreDeliveryPointsAvailableForOfferOfferId<TData = Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>, TError = GetCoreDeliveryPointsAvailableForOfferOfferIdErrorType<unknown>>(
 offerId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsAvailableForOfferOfferId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreDeliveryPointsAvailableForOfferOfferIdQueryOptions(offerId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Список точек доставки для внешнего калькулятора
 */
export type getCoreDeliveryPointsForExtCalcResponse200 = {
  data: DeliveryPointItemForExtCalc[]
  status: 200
}

export type getCoreDeliveryPointsForExtCalcResponseSuccess = (getCoreDeliveryPointsForExtCalcResponse200) & {
  headers: Headers;
};
;

export type getCoreDeliveryPointsForExtCalcResponse = (getCoreDeliveryPointsForExtCalcResponseSuccess)

export const getGetCoreDeliveryPointsForExtCalcUrl = () => {


  

  return `/api/core/delivery-points/for-ext-calc/`
}

export const getCoreDeliveryPointsForExtCalc = async ( options?: RequestInit): Promise<getCoreDeliveryPointsForExtCalcResponse> => {
  
  return getCoreDeliveryPointsForExtCalcMutator<getCoreDeliveryPointsForExtCalcResponse>(getGetCoreDeliveryPointsForExtCalcUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreDeliveryPointsForExtCalcQueryKey = () => {
    return [
    `/api/core/delivery-points/for-ext-calc/`
    ] as const;
    }

    
export const getGetCoreDeliveryPointsForExtCalcQueryOptions = <TData = Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>, TError = GetCoreDeliveryPointsForExtCalcErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreDeliveryPointsForExtCalcQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>> = ({ signal }) => getCoreDeliveryPointsForExtCalc({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreDeliveryPointsForExtCalcQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>>
export type GetCoreDeliveryPointsForExtCalcQueryError = GetCoreDeliveryPointsForExtCalcErrorType<unknown>



export function useGetCoreDeliveryPointsForExtCalc<TData = Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>, TError = GetCoreDeliveryPointsForExtCalcErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreDeliveryPointsForExtCalc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreDeliveryPointsForExtCalcQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreFeatureTogglesResponse200 = {
  data: FeatureToggles[]
  status: 200
}

export type getCoreFeatureTogglesResponseSuccess = (getCoreFeatureTogglesResponse200) & {
  headers: Headers;
};
;

export type getCoreFeatureTogglesResponse = (getCoreFeatureTogglesResponseSuccess)

export const getGetCoreFeatureTogglesUrl = () => {


  

  return `/api/core/feature-toggles/`
}

export const getCoreFeatureToggles = async ( options?: RequestInit): Promise<getCoreFeatureTogglesResponse> => {
  
  return getCoreFeatureTogglesMutator<getCoreFeatureTogglesResponse>(getGetCoreFeatureTogglesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreFeatureTogglesQueryKey = () => {
    return [
    `/api/core/feature-toggles/`
    ] as const;
    }

    
export const getGetCoreFeatureTogglesQueryOptions = <TData = Awaited<ReturnType<typeof getCoreFeatureToggles>>, TError = GetCoreFeatureTogglesErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreFeatureToggles>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreFeatureTogglesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreFeatureToggles>>> = ({ signal }) => getCoreFeatureToggles({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreFeatureToggles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreFeatureTogglesQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreFeatureToggles>>>
export type GetCoreFeatureTogglesQueryError = GetCoreFeatureTogglesErrorType<unknown>



export function useGetCoreFeatureToggles<TData = Awaited<ReturnType<typeof getCoreFeatureToggles>>, TError = GetCoreFeatureTogglesErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreFeatureToggles>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreFeatureTogglesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreMixOrdersResponse200 = {
  data: MixOrder[]
  status: 200
}

export type getCoreMixOrdersResponseSuccess = (getCoreMixOrdersResponse200) & {
  headers: Headers;
};
;

export type getCoreMixOrdersResponse = (getCoreMixOrdersResponseSuccess)

export const getGetCoreMixOrdersUrl = () => {


  

  return `/api/core/mix-orders/`
}

export const getCoreMixOrders = async ( options?: RequestInit): Promise<getCoreMixOrdersResponse> => {
  
  return getCoreMixOrdersMutator<getCoreMixOrdersResponse>(getGetCoreMixOrdersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreMixOrdersQueryKey = () => {
    return [
    `/api/core/mix-orders/`
    ] as const;
    }

    
export const getGetCoreMixOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getCoreMixOrders>>, TError = GetCoreMixOrdersErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrders>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreMixOrdersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreMixOrders>>> = ({ signal }) => getCoreMixOrders({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreMixOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreMixOrders>>>
export type GetCoreMixOrdersQueryError = GetCoreMixOrdersErrorType<unknown>



export function useGetCoreMixOrders<TData = Awaited<ReturnType<typeof getCoreMixOrders>>, TError = GetCoreMixOrdersErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrders>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreMixOrdersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postCoreMixOrdersResponse201 = {
  data: MixOrder
  status: 201
}

export type postCoreMixOrdersResponseSuccess = (postCoreMixOrdersResponse201) & {
  headers: Headers;
};
;

export type postCoreMixOrdersResponse = (postCoreMixOrdersResponseSuccess)

export const getPostCoreMixOrdersUrl = () => {


  

  return `/api/core/mix-orders/`
}

export const postCoreMixOrders = async (mixOrder: NonReadonly<MixOrder>, options?: RequestInit): Promise<postCoreMixOrdersResponse> => {
  
  return postCoreMixOrdersMutator<postCoreMixOrdersResponse>(getPostCoreMixOrdersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mixOrder,)
  }
);}
  



export const getPostCoreMixOrdersMutationOptions = <TError = PostCoreMixOrdersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreMixOrders>>, TError,{data: NonReadonly<MixOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreMixOrders>>, TError,{data: NonReadonly<MixOrder>}, TContext> => {

const mutationKey = ['postCoreMixOrders'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreMixOrders>>, {data: NonReadonly<MixOrder>}> = (props) => {
          const {data} = props ?? {};

          return  postCoreMixOrders(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreMixOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreMixOrders>>>
    export type PostCoreMixOrdersMutationBody = NonReadonly<MixOrder>
    export type PostCoreMixOrdersMutationError = PostCoreMixOrdersErrorType<unknown>

    export const usePostCoreMixOrders = <TError = PostCoreMixOrdersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreMixOrders>>, TError,{data: NonReadonly<MixOrder>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreMixOrders>>,
        TError,
        {data: NonReadonly<MixOrder>},
        TContext
      > => {
      return useMutation(getPostCoreMixOrdersMutationOptions(options));
    }
    export type getCoreMixOrdersIdResponse200 = {
  data: MixOrder
  status: 200
}

export type getCoreMixOrdersIdResponseSuccess = (getCoreMixOrdersIdResponse200) & {
  headers: Headers;
};
;

export type getCoreMixOrdersIdResponse = (getCoreMixOrdersIdResponseSuccess)

export const getGetCoreMixOrdersIdUrl = (id: number,) => {


  

  return `/api/core/mix-orders/${id}/`
}

export const getCoreMixOrdersId = async (id: number, options?: RequestInit): Promise<getCoreMixOrdersIdResponse> => {
  
  return getCoreMixOrdersIdMutator<getCoreMixOrdersIdResponse>(getGetCoreMixOrdersIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreMixOrdersIdQueryKey = (id: number,) => {
    return [
    `/api/core/mix-orders/${id}/`
    ] as const;
    }

    
export const getGetCoreMixOrdersIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreMixOrdersId>>, TError = GetCoreMixOrdersIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrdersId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreMixOrdersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreMixOrdersId>>> = ({ signal }) => getCoreMixOrdersId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrdersId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreMixOrdersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreMixOrdersId>>>
export type GetCoreMixOrdersIdQueryError = GetCoreMixOrdersIdErrorType<unknown>



export function useGetCoreMixOrdersId<TData = Awaited<ReturnType<typeof getCoreMixOrdersId>>, TError = GetCoreMixOrdersIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreMixOrdersId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreMixOrdersIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putCoreMixOrdersIdResponse200 = {
  data: MixOrder
  status: 200
}

export type putCoreMixOrdersIdResponseSuccess = (putCoreMixOrdersIdResponse200) & {
  headers: Headers;
};
;

export type putCoreMixOrdersIdResponse = (putCoreMixOrdersIdResponseSuccess)

export const getPutCoreMixOrdersIdUrl = (id: number,) => {


  

  return `/api/core/mix-orders/${id}/`
}

export const putCoreMixOrdersId = async (id: number,
    mixOrder: NonReadonly<MixOrder>, options?: RequestInit): Promise<putCoreMixOrdersIdResponse> => {
  
  return putCoreMixOrdersIdMutator<putCoreMixOrdersIdResponse>(getPutCoreMixOrdersIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mixOrder,)
  }
);}
  



export const getPutCoreMixOrdersIdMutationOptions = <TError = PutCoreMixOrdersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<MixOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<MixOrder>}, TContext> => {

const mutationKey = ['putCoreMixOrdersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCoreMixOrdersId>>, {id: number;data: NonReadonly<MixOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  putCoreMixOrdersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutCoreMixOrdersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCoreMixOrdersId>>>
    export type PutCoreMixOrdersIdMutationBody = NonReadonly<MixOrder>
    export type PutCoreMixOrdersIdMutationError = PutCoreMixOrdersIdErrorType<unknown>

    export const usePutCoreMixOrdersId = <TError = PutCoreMixOrdersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<MixOrder>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putCoreMixOrdersId>>,
        TError,
        {id: number;data: NonReadonly<MixOrder>},
        TContext
      > => {
      return useMutation(getPutCoreMixOrdersIdMutationOptions(options));
    }
    export type patchCoreMixOrdersIdResponse200 = {
  data: MixOrder
  status: 200
}

export type patchCoreMixOrdersIdResponseSuccess = (patchCoreMixOrdersIdResponse200) & {
  headers: Headers;
};
;

export type patchCoreMixOrdersIdResponse = (patchCoreMixOrdersIdResponseSuccess)

export const getPatchCoreMixOrdersIdUrl = (id: number,) => {


  

  return `/api/core/mix-orders/${id}/`
}

export const patchCoreMixOrdersId = async (id: number,
    patchedMixOrder: NonReadonly<PatchedMixOrder>, options?: RequestInit): Promise<patchCoreMixOrdersIdResponse> => {
  
  return patchCoreMixOrdersIdMutator<patchCoreMixOrdersIdResponse>(getPatchCoreMixOrdersIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedMixOrder,)
  }
);}
  



export const getPatchCoreMixOrdersIdMutationOptions = <TError = PatchCoreMixOrdersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<PatchedMixOrder>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<PatchedMixOrder>}, TContext> => {

const mutationKey = ['patchCoreMixOrdersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCoreMixOrdersId>>, {id: number;data: NonReadonly<PatchedMixOrder>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCoreMixOrdersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCoreMixOrdersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCoreMixOrdersId>>>
    export type PatchCoreMixOrdersIdMutationBody = NonReadonly<PatchedMixOrder>
    export type PatchCoreMixOrdersIdMutationError = PatchCoreMixOrdersIdErrorType<unknown>

    export const usePatchCoreMixOrdersId = <TError = PatchCoreMixOrdersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreMixOrdersId>>, TError,{id: number;data: NonReadonly<PatchedMixOrder>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchCoreMixOrdersId>>,
        TError,
        {id: number;data: NonReadonly<PatchedMixOrder>},
        TContext
      > => {
      return useMutation(getPatchCoreMixOrdersIdMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type getCoreOfferIdResponse200 = {
  data: Offer
  status: 200
}

export type getCoreOfferIdResponseSuccess = (getCoreOfferIdResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferIdResponse = (getCoreOfferIdResponseSuccess)

export const getGetCoreOfferIdUrl = (id: number,) => {


  

  return `/api/core/offer/${id}/`
}

export const getCoreOfferId = async (id: number, options?: RequestInit): Promise<getCoreOfferIdResponse> => {
  
  return getCoreOfferIdMutator<getCoreOfferIdResponse>(getGetCoreOfferIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferIdQueryKey = (id: number,) => {
    return [
    `/api/core/offer/${id}/`
    ] as const;
    }

    
export const getGetCoreOfferIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferId>>, TError = GetCoreOfferIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferId>>> = ({ signal }) => getCoreOfferId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferId>>>
export type GetCoreOfferIdQueryError = GetCoreOfferIdErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreOfferId<TData = Awaited<ReturnType<typeof getCoreOfferId>>, TError = GetCoreOfferIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOfferIdActivityResponse200 = {
  data: Activity
  status: 200
}

export type getCoreOfferIdActivityResponseSuccess = (getCoreOfferIdActivityResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferIdActivityResponse = (getCoreOfferIdActivityResponseSuccess)

export const getGetCoreOfferIdActivityUrl = (id: number,) => {


  

  return `/api/core/offer/${id}/activity/`
}

export const getCoreOfferIdActivity = async (id: number, options?: RequestInit): Promise<getCoreOfferIdActivityResponse> => {
  
  return getCoreOfferIdActivityMutator<getCoreOfferIdActivityResponse>(getGetCoreOfferIdActivityUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferIdActivityQueryKey = (id: number,) => {
    return [
    `/api/core/offer/${id}/activity/`
    ] as const;
    }

    
export const getGetCoreOfferIdActivityQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferIdActivity>>, TError = GetCoreOfferIdActivityErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdActivity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferIdActivityQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferIdActivity>>> = ({ signal }) => getCoreOfferIdActivity(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferIdActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferIdActivity>>>
export type GetCoreOfferIdActivityQueryError = GetCoreOfferIdActivityErrorType<unknown>



export function useGetCoreOfferIdActivity<TData = Awaited<ReturnType<typeof getCoreOfferIdActivity>>, TError = GetCoreOfferIdActivityErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdActivity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferIdActivityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type getCoreOfferIdCalculatePricesResponse200 = {
  data: OfferCalculatedPrices
  status: 200
}

export type getCoreOfferIdCalculatePricesResponseSuccess = (getCoreOfferIdCalculatePricesResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferIdCalculatePricesResponse = (getCoreOfferIdCalculatePricesResponseSuccess)

export const getGetCoreOfferIdCalculatePricesUrl = (id: number,) => {


  

  return `/api/core/offer/${id}/calculate-prices/`
}

export const getCoreOfferIdCalculatePrices = async (id: number, options?: RequestInit): Promise<getCoreOfferIdCalculatePricesResponse> => {
  
  return getCoreOfferIdCalculatePricesMutator<getCoreOfferIdCalculatePricesResponse>(getGetCoreOfferIdCalculatePricesUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferIdCalculatePricesQueryKey = (id: number,) => {
    return [
    `/api/core/offer/${id}/calculate-prices/`
    ] as const;
    }

    
export const getGetCoreOfferIdCalculatePricesQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>, TError = GetCoreOfferIdCalculatePricesErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferIdCalculatePricesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>> = ({ signal }) => getCoreOfferIdCalculatePrices(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferIdCalculatePricesQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>>
export type GetCoreOfferIdCalculatePricesQueryError = GetCoreOfferIdCalculatePricesErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreOfferIdCalculatePrices<TData = Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>, TError = GetCoreOfferIdCalculatePricesErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdCalculatePrices>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferIdCalculatePricesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOfferIdChoicesForMixordersResponse200 = {
  data: OfferMixOrderChoice
  status: 200
}

export type getCoreOfferIdChoicesForMixordersResponseSuccess = (getCoreOfferIdChoicesForMixordersResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferIdChoicesForMixordersResponse = (getCoreOfferIdChoicesForMixordersResponseSuccess)

export const getGetCoreOfferIdChoicesForMixordersUrl = (id: number,) => {


  

  return `/api/core/offer/${id}/choices-for-mixorders/`
}

export const getCoreOfferIdChoicesForMixorders = async (id: number, options?: RequestInit): Promise<getCoreOfferIdChoicesForMixordersResponse> => {
  
  return getCoreOfferIdChoicesForMixordersMutator<getCoreOfferIdChoicesForMixordersResponse>(getGetCoreOfferIdChoicesForMixordersUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferIdChoicesForMixordersQueryKey = (id: number,) => {
    return [
    `/api/core/offer/${id}/choices-for-mixorders/`
    ] as const;
    }

    
export const getGetCoreOfferIdChoicesForMixordersQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>, TError = GetCoreOfferIdChoicesForMixordersErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferIdChoicesForMixordersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>> = ({ signal }) => getCoreOfferIdChoicesForMixorders(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferIdChoicesForMixordersQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>>
export type GetCoreOfferIdChoicesForMixordersQueryError = GetCoreOfferIdChoicesForMixordersErrorType<unknown>



export function useGetCoreOfferIdChoicesForMixorders<TData = Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>, TError = GetCoreOfferIdChoicesForMixordersErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferIdChoicesForMixorders>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferIdChoicesForMixordersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type postCoreOfferCreateResponse201 = {
  data: OfferCreate
  status: 201
}

export type postCoreOfferCreateResponseSuccess = (postCoreOfferCreateResponse201) & {
  headers: Headers;
};
;

export type postCoreOfferCreateResponse = (postCoreOfferCreateResponseSuccess)

export const getPostCoreOfferCreateUrl = () => {


  

  return `/api/core/offer/create/`
}

export const postCoreOfferCreate = async (offerCreate: NonReadonly<OfferCreate>, options?: RequestInit): Promise<postCoreOfferCreateResponse> => {
  
  return postCoreOfferCreateMutator<postCoreOfferCreateResponse>(getPostCoreOfferCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerCreate,)
  }
);}
  



export const getPostCoreOfferCreateMutationOptions = <TError = PostCoreOfferCreateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOfferCreate>>, TError,{data: NonReadonly<OfferCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOfferCreate>>, TError,{data: NonReadonly<OfferCreate>}, TContext> => {

const mutationKey = ['postCoreOfferCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOfferCreate>>, {data: NonReadonly<OfferCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOfferCreate(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOfferCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOfferCreate>>>
    export type PostCoreOfferCreateMutationBody = NonReadonly<OfferCreate>
    export type PostCoreOfferCreateMutationError = PostCoreOfferCreateErrorType<unknown>

    /**
 * @deprecated
 */
export const usePostCoreOfferCreate = <TError = PostCoreOfferCreateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOfferCreate>>, TError,{data: NonReadonly<OfferCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOfferCreate>>,
        TError,
        {data: NonReadonly<OfferCreate>},
        TContext
      > => {
      return useMutation(getPostCoreOfferCreateMutationOptions(options));
    }
    export type getCoreOfferDownloadLogosReportResponse200 = {
  data: Blob
  status: 200
}

export type getCoreOfferDownloadLogosReportResponseSuccess = (getCoreOfferDownloadLogosReportResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferDownloadLogosReportResponse = (getCoreOfferDownloadLogosReportResponseSuccess)

export const getGetCoreOfferDownloadLogosReportUrl = () => {


  

  return `/api/core/offer/download_logos_report/`
}

export const getCoreOfferDownloadLogosReport = async ( options?: RequestInit): Promise<getCoreOfferDownloadLogosReportResponse> => {
  
  return getCoreOfferDownloadLogosReportMutator<getCoreOfferDownloadLogosReportResponse>(getGetCoreOfferDownloadLogosReportUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferDownloadLogosReportQueryKey = () => {
    return [
    `/api/core/offer/download_logos_report/`
    ] as const;
    }

    
export const getGetCoreOfferDownloadLogosReportQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>, TError = GetCoreOfferDownloadLogosReportErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferDownloadLogosReportQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>> = ({ signal }) => getCoreOfferDownloadLogosReport({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferDownloadLogosReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>>
export type GetCoreOfferDownloadLogosReportQueryError = GetCoreOfferDownloadLogosReportErrorType<unknown>



export function useGetCoreOfferDownloadLogosReport<TData = Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>, TError = GetCoreOfferDownloadLogosReportErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadLogosReport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferDownloadLogosReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOfferDownloadOffersForRegionsReportResponse200 = {
  data: Blob
  status: 200
}

export type getCoreOfferDownloadOffersForRegionsReportResponseSuccess = (getCoreOfferDownloadOffersForRegionsReportResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferDownloadOffersForRegionsReportResponse = (getCoreOfferDownloadOffersForRegionsReportResponseSuccess)

export const getGetCoreOfferDownloadOffersForRegionsReportUrl = () => {


  

  return `/api/core/offer/download_offers_for_regions_report/`
}

export const getCoreOfferDownloadOffersForRegionsReport = async ( options?: RequestInit): Promise<getCoreOfferDownloadOffersForRegionsReportResponse> => {
  
  return getCoreOfferDownloadOffersForRegionsReportMutator<getCoreOfferDownloadOffersForRegionsReportResponse>(getGetCoreOfferDownloadOffersForRegionsReportUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferDownloadOffersForRegionsReportQueryKey = () => {
    return [
    `/api/core/offer/download_offers_for_regions_report/`
    ] as const;
    }

    
export const getGetCoreOfferDownloadOffersForRegionsReportQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>, TError = GetCoreOfferDownloadOffersForRegionsReportErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferDownloadOffersForRegionsReportQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>> = ({ signal }) => getCoreOfferDownloadOffersForRegionsReport({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferDownloadOffersForRegionsReportQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>>
export type GetCoreOfferDownloadOffersForRegionsReportQueryError = GetCoreOfferDownloadOffersForRegionsReportErrorType<unknown>



export function useGetCoreOfferDownloadOffersForRegionsReport<TData = Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>, TError = GetCoreOfferDownloadOffersForRegionsReportErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferDownloadOffersForRegionsReport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferDownloadOffersForRegionsReportQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOfferReferenceValuesResponse200 = {
  data: OfferReferenceValues
  status: 200
}

export type getCoreOfferReferenceValuesResponseSuccess = (getCoreOfferReferenceValuesResponse200) & {
  headers: Headers;
};
;

export type getCoreOfferReferenceValuesResponse = (getCoreOfferReferenceValuesResponseSuccess)

export const getGetCoreOfferReferenceValuesUrl = () => {


  

  return `/api/core/offer/reference-values/`
}

export const getCoreOfferReferenceValues = async ( options?: RequestInit): Promise<getCoreOfferReferenceValuesResponse> => {
  
  return getCoreOfferReferenceValuesMutator<getCoreOfferReferenceValuesResponse>(getGetCoreOfferReferenceValuesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOfferReferenceValuesQueryKey = () => {
    return [
    `/api/core/offer/reference-values/`
    ] as const;
    }

    
export const getGetCoreOfferReferenceValuesQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOfferReferenceValues>>, TError = GetCoreOfferReferenceValuesErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferReferenceValues>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOfferReferenceValuesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOfferReferenceValues>>> = ({ signal }) => getCoreOfferReferenceValues({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferReferenceValues>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOfferReferenceValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOfferReferenceValues>>>
export type GetCoreOfferReferenceValuesQueryError = GetCoreOfferReferenceValuesErrorType<unknown>



export function useGetCoreOfferReferenceValues<TData = Awaited<ReturnType<typeof getCoreOfferReferenceValues>>, TError = GetCoreOfferReferenceValuesErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOfferReferenceValues>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOfferReferenceValuesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 * @summary Multi-serializer update handler
 */
export type patchCoreOfferUpdateIdResponse200 = {
  data: Offer
  status: 200
}

export type patchCoreOfferUpdateIdResponseSuccess = (patchCoreOfferUpdateIdResponse200) & {
  headers: Headers;
};
;

export type patchCoreOfferUpdateIdResponse = (patchCoreOfferUpdateIdResponseSuccess)

export const getPatchCoreOfferUpdateIdUrl = (id: number,) => {


  

  return `/api/core/offer/update/${id}/`
}

export const patchCoreOfferUpdateId = async (id: number,
    patchedOfferUpdateMeta: NonReadonly<PatchedOfferUpdateMeta>, options?: RequestInit): Promise<patchCoreOfferUpdateIdResponse> => {
  
  return patchCoreOfferUpdateIdMutator<patchCoreOfferUpdateIdResponse>(getPatchCoreOfferUpdateIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedOfferUpdateMeta,)
  }
);}
  



export const getPatchCoreOfferUpdateIdMutationOptions = <TError = PatchCoreOfferUpdateIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreOfferUpdateId>>, TError,{id: number;data: NonReadonly<PatchedOfferUpdateMeta>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCoreOfferUpdateId>>, TError,{id: number;data: NonReadonly<PatchedOfferUpdateMeta>}, TContext> => {

const mutationKey = ['patchCoreOfferUpdateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCoreOfferUpdateId>>, {id: number;data: NonReadonly<PatchedOfferUpdateMeta>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCoreOfferUpdateId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCoreOfferUpdateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCoreOfferUpdateId>>>
    export type PatchCoreOfferUpdateIdMutationBody = NonReadonly<PatchedOfferUpdateMeta>
    export type PatchCoreOfferUpdateIdMutationError = PatchCoreOfferUpdateIdErrorType<unknown>

    /**
 * @deprecated
 * @summary Multi-serializer update handler
 */
export const usePatchCoreOfferUpdateId = <TError = PatchCoreOfferUpdateIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreOfferUpdateId>>, TError,{id: number;data: NonReadonly<PatchedOfferUpdateMeta>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchCoreOfferUpdateId>>,
        TError,
        {id: number;data: NonReadonly<PatchedOfferUpdateMeta>},
        TContext
      > => {
      return useMutation(getPatchCoreOfferUpdateIdMutationOptions(options));
    }
    /**
 * Выгрузка списка офферов в Excel.
 * @deprecated
 */
export type getCoreOffersResponse200ApplicationJson = {
  data: OfferToExcel[]
  status: 200
}

export type getCoreOffersResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = {
  data: Blob
  status: 200
}

export type getCoreOffersResponseSuccess = (getCoreOffersResponse200ApplicationJson | getCoreOffersResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet) & {
  headers: Headers;
};
;

export type getCoreOffersResponse = (getCoreOffersResponseSuccess)

export const getGetCoreOffersUrl = (params?: GetCoreOffersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers/?${stringifiedParams}` : `/api/core/offers/`
}

export const getCoreOffers = async (params?: GetCoreOffersParams, options?: RequestInit): Promise<getCoreOffersResponse> => {
  
  return getCoreOffersMutator<getCoreOffersResponse>(getGetCoreOffersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersQueryKey = (params?: GetCoreOffersParams,) => {
    return [
    `/api/core/offers/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffers>>, TError = GetCoreOffersErrorType<unknown>>(params?: GetCoreOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffers>>> = ({ signal }) => getCoreOffers(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffers>>>
export type GetCoreOffersQueryError = GetCoreOffersErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreOffers<TData = Awaited<ReturnType<typeof getCoreOffers>>, TError = GetCoreOffersErrorType<unknown>>(
 params?: GetCoreOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOffersForExtCalcResponse200 = {
  data: DataForExternalCalculator[]
  status: 200
}

export type getCoreOffersForExtCalcResponseSuccess = (getCoreOffersForExtCalcResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersForExtCalcResponse = (getCoreOffersForExtCalcResponseSuccess)

export const getGetCoreOffersForExtCalcUrl = (params: GetCoreOffersForExtCalcParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers-for-ext-calc/?${stringifiedParams}` : `/api/core/offers-for-ext-calc/`
}

export const getCoreOffersForExtCalc = async (params: GetCoreOffersForExtCalcParams, options?: RequestInit): Promise<getCoreOffersForExtCalcResponse> => {
  
  return getCoreOffersForExtCalcMutator<getCoreOffersForExtCalcResponse>(getGetCoreOffersForExtCalcUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersForExtCalcQueryKey = (params?: GetCoreOffersForExtCalcParams,) => {
    return [
    `/api/core/offers-for-ext-calc/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersForExtCalcQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersForExtCalc>>, TError = GetCoreOffersForExtCalcErrorType<unknown>>(params: GetCoreOffersForExtCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersForExtCalcQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersForExtCalc>>> = ({ signal }) => getCoreOffersForExtCalc(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersForExtCalcQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersForExtCalc>>>
export type GetCoreOffersForExtCalcQueryError = GetCoreOffersForExtCalcErrorType<unknown>



export function useGetCoreOffersForExtCalc<TData = Awaited<ReturnType<typeof getCoreOffersForExtCalc>>, TError = GetCoreOffersForExtCalcErrorType<unknown>>(
 params: GetCoreOffersForExtCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersForExtCalcQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOffersForExtCalcIdResponse200 = {
  data: DataForExternalCalculator
  status: 200
}

export type getCoreOffersForExtCalcIdResponseSuccess = (getCoreOffersForExtCalcIdResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersForExtCalcIdResponse = (getCoreOffersForExtCalcIdResponseSuccess)

export const getGetCoreOffersForExtCalcIdUrl = (id: number,
    params?: GetCoreOffersForExtCalcIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers-for-ext-calc/${id}/?${stringifiedParams}` : `/api/core/offers-for-ext-calc/${id}/`
}

export const getCoreOffersForExtCalcId = async (id: number,
    params?: GetCoreOffersForExtCalcIdParams, options?: RequestInit): Promise<getCoreOffersForExtCalcIdResponse> => {
  
  return getCoreOffersForExtCalcIdMutator<getCoreOffersForExtCalcIdResponse>(getGetCoreOffersForExtCalcIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersForExtCalcIdQueryKey = (id: number,
    params?: GetCoreOffersForExtCalcIdParams,) => {
    return [
    `/api/core/offers-for-ext-calc/${id}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersForExtCalcIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>, TError = GetCoreOffersForExtCalcIdErrorType<unknown>>(id: number,
    params?: GetCoreOffersForExtCalcIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersForExtCalcIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>> = ({ signal }) => getCoreOffersForExtCalcId(id,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersForExtCalcIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>>
export type GetCoreOffersForExtCalcIdQueryError = GetCoreOffersForExtCalcIdErrorType<unknown>



export function useGetCoreOffersForExtCalcId<TData = Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>, TError = GetCoreOffersForExtCalcIdErrorType<unknown>>(
 id: number,
    params?: GetCoreOffersForExtCalcIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersForExtCalcId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersForExtCalcIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type getCoreOffersNewResponse200 = {
  data: PaginatedOfferNewList
  status: 200
}

export type getCoreOffersNewResponseSuccess = (getCoreOffersNewResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersNewResponse = (getCoreOffersNewResponseSuccess)

export const getGetCoreOffersNewUrl = (params?: GetCoreOffersNewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers-new/?${stringifiedParams}` : `/api/core/offers-new/`
}

export const getCoreOffersNew = async (params?: GetCoreOffersNewParams, options?: RequestInit): Promise<getCoreOffersNewResponse> => {
  
  return getCoreOffersNewMutator<getCoreOffersNewResponse>(getGetCoreOffersNewUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersNewQueryKey = (params?: GetCoreOffersNewParams,) => {
    return [
    `/api/core/offers-new/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersNewQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersNew>>, TError = GetCoreOffersNewErrorType<unknown>>(params?: GetCoreOffersNewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNew>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersNewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersNew>>> = ({ signal }) => getCoreOffersNew(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNew>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersNewQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersNew>>>
export type GetCoreOffersNewQueryError = GetCoreOffersNewErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreOffersNew<TData = Awaited<ReturnType<typeof getCoreOffersNew>>, TError = GetCoreOffersNewErrorType<unknown>>(
 params?: GetCoreOffersNewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNew>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersNewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreOffersNewFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getCoreOffersNewFiltersFilterNameResponseSuccess = (getCoreOffersNewFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersNewFiltersFilterNameResponse = (getCoreOffersNewFiltersFilterNameResponseSuccess)

export const getGetCoreOffersNewFiltersFilterNameUrl = (filterName: string,
    params?: GetCoreOffersNewFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers-new/filters/${filterName}/?${stringifiedParams}` : `/api/core/offers-new/filters/${filterName}/`
}

export const getCoreOffersNewFiltersFilterName = async (filterName: string,
    params?: GetCoreOffersNewFiltersFilterNameParams, options?: RequestInit): Promise<getCoreOffersNewFiltersFilterNameResponse> => {
  
  return getCoreOffersNewFiltersFilterNameMutator<getCoreOffersNewFiltersFilterNameResponse>(getGetCoreOffersNewFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersNewFiltersFilterNameQueryKey = (filterName: string,
    params?: GetCoreOffersNewFiltersFilterNameParams,) => {
    return [
    `/api/core/offers-new/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersNewFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>, TError = GetCoreOffersNewFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetCoreOffersNewFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersNewFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>> = ({ signal }) => getCoreOffersNewFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersNewFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>>
export type GetCoreOffersNewFiltersFilterNameQueryError = GetCoreOffersNewFiltersFilterNameErrorType<unknown>



export function useGetCoreOffersNewFiltersFilterName<TData = Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>, TError = GetCoreOffersNewFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetCoreOffersNewFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersNewFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersNewFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Выгрузка списка офферов в Excel.
Формируется файл на основе запрошенных параметров офферов, затем производится отправка отчёта пользователю
на e-mail и сохранение в s3.
 */
export type getCoreOffersExcelResponse200 = {
  data: Result[]
  status: 200
}

export type getCoreOffersExcelResponseSuccess = (getCoreOffersExcelResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersExcelResponse = (getCoreOffersExcelResponseSuccess)

export const getGetCoreOffersExcelUrl = (params?: GetCoreOffersExcelParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers/excel/?${stringifiedParams}` : `/api/core/offers/excel/`
}

export const getCoreOffersExcel = async (params?: GetCoreOffersExcelParams, options?: RequestInit): Promise<getCoreOffersExcelResponse> => {
  
  return getCoreOffersExcelMutator<getCoreOffersExcelResponse>(getGetCoreOffersExcelUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersExcelQueryKey = (params?: GetCoreOffersExcelParams,) => {
    return [
    `/api/core/offers/excel/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersExcelQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersExcel>>, TError = GetCoreOffersExcelErrorType<unknown>>(params?: GetCoreOffersExcelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExcel>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersExcelQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersExcel>>> = ({ signal }) => getCoreOffersExcel(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExcel>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersExcelQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersExcel>>>
export type GetCoreOffersExcelQueryError = GetCoreOffersExcelErrorType<unknown>



export function useGetCoreOffersExcel<TData = Awaited<ReturnType<typeof getCoreOffersExcel>>, TError = GetCoreOffersExcelErrorType<unknown>>(
 params?: GetCoreOffersExcelParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExcel>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersExcelQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Выгрузка офферов в Excel в формате для excel-калькулятора.
 */
export type getCoreOffersExportExcelCalcResponse200 = {
  data: Blob
  status: 200
}

export type getCoreOffersExportExcelCalcResponseSuccess = (getCoreOffersExportExcelCalcResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersExportExcelCalcResponse = (getCoreOffersExportExcelCalcResponseSuccess)

export const getGetCoreOffersExportExcelCalcUrl = (params?: GetCoreOffersExportExcelCalcParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/offers/export-excel-calc/?${stringifiedParams}` : `/api/core/offers/export-excel-calc/`
}

export const getCoreOffersExportExcelCalc = async (params?: GetCoreOffersExportExcelCalcParams, options?: RequestInit): Promise<getCoreOffersExportExcelCalcResponse> => {
  
  return getCoreOffersExportExcelCalcMutator<getCoreOffersExportExcelCalcResponse>(getGetCoreOffersExportExcelCalcUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersExportExcelCalcQueryKey = (params?: GetCoreOffersExportExcelCalcParams,) => {
    return [
    `/api/core/offers/export-excel-calc/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreOffersExportExcelCalcQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>, TError = GetCoreOffersExportExcelCalcErrorType<unknown>>(params?: GetCoreOffersExportExcelCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersExportExcelCalcQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>> = ({ signal }) => getCoreOffersExportExcelCalc(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersExportExcelCalcQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>>
export type GetCoreOffersExportExcelCalcQueryError = GetCoreOffersExportExcelCalcErrorType<unknown>



export function useGetCoreOffersExportExcelCalc<TData = Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>, TError = GetCoreOffersExportExcelCalcErrorType<unknown>>(
 params?: GetCoreOffersExportExcelCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersExportExcelCalc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersExportExcelCalcQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postCoreOffersStatusApproveResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusApproveResponseSuccess = (postCoreOffersStatusApproveResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusApproveResponse = (postCoreOffersStatusApproveResponseSuccess)

export const getPostCoreOffersStatusApproveUrl = () => {


  

  return `/api/core/offers/status/approve/`
}

export const postCoreOffersStatusApprove = async (offerStatusApprove: OfferStatusApprove, options?: RequestInit): Promise<postCoreOffersStatusApproveResponse> => {
  
  return postCoreOffersStatusApproveMutator<postCoreOffersStatusApproveResponse>(getPostCoreOffersStatusApproveUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusApprove,)
  }
);}
  



export const getPostCoreOffersStatusApproveMutationOptions = <TError = PostCoreOffersStatusApproveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApprove>>, TError,{data: OfferStatusApprove}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApprove>>, TError,{data: OfferStatusApprove}, TContext> => {

const mutationKey = ['postCoreOffersStatusApprove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusApprove>>, {data: OfferStatusApprove}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusApprove(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusApprove>>>
    export type PostCoreOffersStatusApproveMutationBody = OfferStatusApprove
    export type PostCoreOffersStatusApproveMutationError = PostCoreOffersStatusApproveErrorType<unknown>

    export const usePostCoreOffersStatusApprove = <TError = PostCoreOffersStatusApproveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApprove>>, TError,{data: OfferStatusApprove}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusApprove>>,
        TError,
        {data: OfferStatusApprove},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusApproveMutationOptions(options));
    }
    export type postCoreOffersStatusApproveBusiResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusApproveBusiResponseSuccess = (postCoreOffersStatusApproveBusiResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusApproveBusiResponse = (postCoreOffersStatusApproveBusiResponseSuccess)

export const getPostCoreOffersStatusApproveBusiUrl = () => {


  

  return `/api/core/offers/status/approve_busi/`
}

export const postCoreOffersStatusApproveBusi = async (offerStatusApproveBusi: OfferStatusApproveBusi, options?: RequestInit): Promise<postCoreOffersStatusApproveBusiResponse> => {
  
  return postCoreOffersStatusApproveBusiMutator<postCoreOffersStatusApproveBusiResponse>(getPostCoreOffersStatusApproveBusiUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusApproveBusi,)
  }
);}
  



export const getPostCoreOffersStatusApproveBusiMutationOptions = <TError = PostCoreOffersStatusApproveBusiErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>, TError,{data: OfferStatusApproveBusi}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>, TError,{data: OfferStatusApproveBusi}, TContext> => {

const mutationKey = ['postCoreOffersStatusApproveBusi'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>, {data: OfferStatusApproveBusi}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusApproveBusi(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusApproveBusiMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>>
    export type PostCoreOffersStatusApproveBusiMutationBody = OfferStatusApproveBusi
    export type PostCoreOffersStatusApproveBusiMutationError = PostCoreOffersStatusApproveBusiErrorType<unknown>

    export const usePostCoreOffersStatusApproveBusi = <TError = PostCoreOffersStatusApproveBusiErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>, TError,{data: OfferStatusApproveBusi}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusApproveBusi>>,
        TError,
        {data: OfferStatusApproveBusi},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusApproveBusiMutationOptions(options));
    }
    export type postCoreOffersStatusDeleteResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusDeleteResponseSuccess = (postCoreOffersStatusDeleteResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusDeleteResponse = (postCoreOffersStatusDeleteResponseSuccess)

export const getPostCoreOffersStatusDeleteUrl = () => {


  

  return `/api/core/offers/status/delete/`
}

export const postCoreOffersStatusDelete = async (offerStatusDelete: OfferStatusDelete, options?: RequestInit): Promise<postCoreOffersStatusDeleteResponse> => {
  
  return postCoreOffersStatusDeleteMutator<postCoreOffersStatusDeleteResponse>(getPostCoreOffersStatusDeleteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusDelete,)
  }
);}
  



export const getPostCoreOffersStatusDeleteMutationOptions = <TError = PostCoreOffersStatusDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusDelete>>, TError,{data: OfferStatusDelete}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusDelete>>, TError,{data: OfferStatusDelete}, TContext> => {

const mutationKey = ['postCoreOffersStatusDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusDelete>>, {data: OfferStatusDelete}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusDelete(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusDelete>>>
    export type PostCoreOffersStatusDeleteMutationBody = OfferStatusDelete
    export type PostCoreOffersStatusDeleteMutationError = PostCoreOffersStatusDeleteErrorType<unknown>

    export const usePostCoreOffersStatusDelete = <TError = PostCoreOffersStatusDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusDelete>>, TError,{data: OfferStatusDelete}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusDelete>>,
        TError,
        {data: OfferStatusDelete},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusDeleteMutationOptions(options));
    }
    export type postCoreOffersStatusRefuseResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusRefuseResponseSuccess = (postCoreOffersStatusRefuseResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusRefuseResponse = (postCoreOffersStatusRefuseResponseSuccess)

export const getPostCoreOffersStatusRefuseUrl = () => {


  

  return `/api/core/offers/status/refuse/`
}

export const postCoreOffersStatusRefuse = async (offerStatusRefuse: OfferStatusRefuse, options?: RequestInit): Promise<postCoreOffersStatusRefuseResponse> => {
  
  return postCoreOffersStatusRefuseMutator<postCoreOffersStatusRefuseResponse>(getPostCoreOffersStatusRefuseUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusRefuse,)
  }
);}
  



export const getPostCoreOffersStatusRefuseMutationOptions = <TError = PostCoreOffersStatusRefuseErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>, TError,{data: OfferStatusRefuse}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>, TError,{data: OfferStatusRefuse}, TContext> => {

const mutationKey = ['postCoreOffersStatusRefuse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>, {data: OfferStatusRefuse}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusRefuse(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusRefuseMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>>
    export type PostCoreOffersStatusRefuseMutationBody = OfferStatusRefuse
    export type PostCoreOffersStatusRefuseMutationError = PostCoreOffersStatusRefuseErrorType<unknown>

    export const usePostCoreOffersStatusRefuse = <TError = PostCoreOffersStatusRefuseErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>, TError,{data: OfferStatusRefuse}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusRefuse>>,
        TError,
        {data: OfferStatusRefuse},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusRefuseMutationOptions(options));
    }
    export type postCoreOffersStatusRefuseBusiResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusRefuseBusiResponseSuccess = (postCoreOffersStatusRefuseBusiResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusRefuseBusiResponse = (postCoreOffersStatusRefuseBusiResponseSuccess)

export const getPostCoreOffersStatusRefuseBusiUrl = () => {


  

  return `/api/core/offers/status/refuse_busi/`
}

export const postCoreOffersStatusRefuseBusi = async (offerStatusRefuseBusi: OfferStatusRefuseBusi, options?: RequestInit): Promise<postCoreOffersStatusRefuseBusiResponse> => {
  
  return postCoreOffersStatusRefuseBusiMutator<postCoreOffersStatusRefuseBusiResponse>(getPostCoreOffersStatusRefuseBusiUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusRefuseBusi,)
  }
);}
  



export const getPostCoreOffersStatusRefuseBusiMutationOptions = <TError = PostCoreOffersStatusRefuseBusiErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>, TError,{data: OfferStatusRefuseBusi}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>, TError,{data: OfferStatusRefuseBusi}, TContext> => {

const mutationKey = ['postCoreOffersStatusRefuseBusi'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>, {data: OfferStatusRefuseBusi}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusRefuseBusi(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusRefuseBusiMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>>
    export type PostCoreOffersStatusRefuseBusiMutationBody = OfferStatusRefuseBusi
    export type PostCoreOffersStatusRefuseBusiMutationError = PostCoreOffersStatusRefuseBusiErrorType<unknown>

    export const usePostCoreOffersStatusRefuseBusi = <TError = PostCoreOffersStatusRefuseBusiErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>, TError,{data: OfferStatusRefuseBusi}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusRefuseBusi>>,
        TError,
        {data: OfferStatusRefuseBusi},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusRefuseBusiMutationOptions(options));
    }
    export type postCoreOffersStatusSelectForApprovalResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusSelectForApprovalResponseSuccess = (postCoreOffersStatusSelectForApprovalResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusSelectForApprovalResponse = (postCoreOffersStatusSelectForApprovalResponseSuccess)

export const getPostCoreOffersStatusSelectForApprovalUrl = () => {


  

  return `/api/core/offers/status/select_for_approval/`
}

export const postCoreOffersStatusSelectForApproval = async (offerSendKMTS: OfferSendKMTS, options?: RequestInit): Promise<postCoreOffersStatusSelectForApprovalResponse> => {
  
  return postCoreOffersStatusSelectForApprovalMutator<postCoreOffersStatusSelectForApprovalResponse>(getPostCoreOffersStatusSelectForApprovalUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerSendKMTS,)
  }
);}
  



export const getPostCoreOffersStatusSelectForApprovalMutationOptions = <TError = PostCoreOffersStatusSelectForApprovalErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>, TError,{data: OfferSendKMTS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>, TError,{data: OfferSendKMTS}, TContext> => {

const mutationKey = ['postCoreOffersStatusSelectForApproval'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>, {data: OfferSendKMTS}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusSelectForApproval(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusSelectForApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>>
    export type PostCoreOffersStatusSelectForApprovalMutationBody = OfferSendKMTS
    export type PostCoreOffersStatusSelectForApprovalMutationError = PostCoreOffersStatusSelectForApprovalErrorType<unknown>

    export const usePostCoreOffersStatusSelectForApproval = <TError = PostCoreOffersStatusSelectForApprovalErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>, TError,{data: OfferSendKMTS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusSelectForApproval>>,
        TError,
        {data: OfferSendKMTS},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusSelectForApprovalMutationOptions(options));
    }
    export type postCoreOffersStatusTradingResponse200 = {
  data: OfferStatus[]
  status: 200
}

export type postCoreOffersStatusTradingResponseSuccess = (postCoreOffersStatusTradingResponse200) & {
  headers: Headers;
};
;

export type postCoreOffersStatusTradingResponse = (postCoreOffersStatusTradingResponseSuccess)

export const getPostCoreOffersStatusTradingUrl = () => {


  

  return `/api/core/offers/status/trading/`
}

export const postCoreOffersStatusTrading = async (offerStatusTrading: OfferStatusTrading, options?: RequestInit): Promise<postCoreOffersStatusTradingResponse> => {
  
  return postCoreOffersStatusTradingMutator<postCoreOffersStatusTradingResponse>(getPostCoreOffersStatusTradingUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerStatusTrading,)
  }
);}
  



export const getPostCoreOffersStatusTradingMutationOptions = <TError = PostCoreOffersStatusTradingErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusTrading>>, TError,{data: OfferStatusTrading}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusTrading>>, TError,{data: OfferStatusTrading}, TContext> => {

const mutationKey = ['postCoreOffersStatusTrading'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersStatusTrading>>, {data: OfferStatusTrading}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersStatusTrading(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersStatusTradingMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersStatusTrading>>>
    export type PostCoreOffersStatusTradingMutationBody = OfferStatusTrading
    export type PostCoreOffersStatusTradingMutationError = PostCoreOffersStatusTradingErrorType<unknown>

    export const usePostCoreOffersStatusTrading = <TError = PostCoreOffersStatusTradingErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersStatusTrading>>, TError,{data: OfferStatusTrading}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersStatusTrading>>,
        TError,
        {data: OfferStatusTrading},
        TContext
      > => {
      return useMutation(getPostCoreOffersStatusTradingMutationOptions(options));
    }
    export type getCoreOffersUploadExcelPricesTasksResponse200 = {
  data: LoadPricesFromExcelTaskSimple[]
  status: 200
}

export type getCoreOffersUploadExcelPricesTasksResponseSuccess = (getCoreOffersUploadExcelPricesTasksResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersUploadExcelPricesTasksResponse = (getCoreOffersUploadExcelPricesTasksResponseSuccess)

export const getGetCoreOffersUploadExcelPricesTasksUrl = () => {


  

  return `/api/core/offers/upload-excel-prices-tasks/`
}

export const getCoreOffersUploadExcelPricesTasks = async ( options?: RequestInit): Promise<getCoreOffersUploadExcelPricesTasksResponse> => {
  
  return getCoreOffersUploadExcelPricesTasksMutator<getCoreOffersUploadExcelPricesTasksResponse>(getGetCoreOffersUploadExcelPricesTasksUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersUploadExcelPricesTasksQueryKey = () => {
    return [
    `/api/core/offers/upload-excel-prices-tasks/`
    ] as const;
    }

    
export const getGetCoreOffersUploadExcelPricesTasksQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>, TError = GetCoreOffersUploadExcelPricesTasksErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersUploadExcelPricesTasksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>> = ({ signal }) => getCoreOffersUploadExcelPricesTasks({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersUploadExcelPricesTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>>
export type GetCoreOffersUploadExcelPricesTasksQueryError = GetCoreOffersUploadExcelPricesTasksErrorType<unknown>



export function useGetCoreOffersUploadExcelPricesTasks<TData = Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>, TError = GetCoreOffersUploadExcelPricesTasksErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasks>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersUploadExcelPricesTasksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postCoreOffersUploadExcelPricesTasksResponse201 = {
  data: LoadPricesFromExcelTask
  status: 201
}

export type postCoreOffersUploadExcelPricesTasksResponseSuccess = (postCoreOffersUploadExcelPricesTasksResponse201) & {
  headers: Headers;
};
;

export type postCoreOffersUploadExcelPricesTasksResponse = (postCoreOffersUploadExcelPricesTasksResponseSuccess)

export const getPostCoreOffersUploadExcelPricesTasksUrl = () => {


  

  return `/api/core/offers/upload-excel-prices-tasks/`
}

export const postCoreOffersUploadExcelPricesTasks = async (loadPricesFromExcelTask: NonReadonly<LoadPricesFromExcelTask>, options?: RequestInit): Promise<postCoreOffersUploadExcelPricesTasksResponse> => {
    const formData = new FormData();
formData.append(`data`, loadPricesFromExcelTask.data);

  return postCoreOffersUploadExcelPricesTasksMutator<postCoreOffersUploadExcelPricesTasksResponse>(getPostCoreOffersUploadExcelPricesTasksUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  



export const getPostCoreOffersUploadExcelPricesTasksMutationOptions = <TError = PostCoreOffersUploadExcelPricesTasksErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>, TError,{data: NonReadonly<LoadPricesFromExcelTask>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>, TError,{data: NonReadonly<LoadPricesFromExcelTask>}, TContext> => {

const mutationKey = ['postCoreOffersUploadExcelPricesTasks'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>, {data: NonReadonly<LoadPricesFromExcelTask>}> = (props) => {
          const {data} = props ?? {};

          return  postCoreOffersUploadExcelPricesTasks(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreOffersUploadExcelPricesTasksMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>>
    export type PostCoreOffersUploadExcelPricesTasksMutationBody = NonReadonly<LoadPricesFromExcelTask>
    export type PostCoreOffersUploadExcelPricesTasksMutationError = PostCoreOffersUploadExcelPricesTasksErrorType<unknown>

    export const usePostCoreOffersUploadExcelPricesTasks = <TError = PostCoreOffersUploadExcelPricesTasksErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>, TError,{data: NonReadonly<LoadPricesFromExcelTask>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreOffersUploadExcelPricesTasks>>,
        TError,
        {data: NonReadonly<LoadPricesFromExcelTask>},
        TContext
      > => {
      return useMutation(getPostCoreOffersUploadExcelPricesTasksMutationOptions(options));
    }
    export type getCoreOffersUploadExcelPricesTasksIdResponse200 = {
  data: LoadPricesFromExcelTask
  status: 200
}

export type getCoreOffersUploadExcelPricesTasksIdResponseSuccess = (getCoreOffersUploadExcelPricesTasksIdResponse200) & {
  headers: Headers;
};
;

export type getCoreOffersUploadExcelPricesTasksIdResponse = (getCoreOffersUploadExcelPricesTasksIdResponseSuccess)

export const getGetCoreOffersUploadExcelPricesTasksIdUrl = (id: number,) => {


  

  return `/api/core/offers/upload-excel-prices-tasks/${id}/`
}

export const getCoreOffersUploadExcelPricesTasksId = async (id: number, options?: RequestInit): Promise<getCoreOffersUploadExcelPricesTasksIdResponse> => {
  
  return getCoreOffersUploadExcelPricesTasksIdMutator<getCoreOffersUploadExcelPricesTasksIdResponse>(getGetCoreOffersUploadExcelPricesTasksIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreOffersUploadExcelPricesTasksIdQueryKey = (id: number,) => {
    return [
    `/api/core/offers/upload-excel-prices-tasks/${id}/`
    ] as const;
    }

    
export const getGetCoreOffersUploadExcelPricesTasksIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>, TError = GetCoreOffersUploadExcelPricesTasksIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreOffersUploadExcelPricesTasksIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>> = ({ signal }) => getCoreOffersUploadExcelPricesTasksId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreOffersUploadExcelPricesTasksIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>>
export type GetCoreOffersUploadExcelPricesTasksIdQueryError = GetCoreOffersUploadExcelPricesTasksIdErrorType<unknown>



export function useGetCoreOffersUploadExcelPricesTasksId<TData = Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>, TError = GetCoreOffersUploadExcelPricesTasksIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreOffersUploadExcelPricesTasksId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreOffersUploadExcelPricesTasksIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type patchCoreOffersWaitingForApprovalResponse200 = {
  data: Offer[]
  status: 200
}

export type patchCoreOffersWaitingForApprovalResponseSuccess = (patchCoreOffersWaitingForApprovalResponse200) & {
  headers: Headers;
};
;

export type patchCoreOffersWaitingForApprovalResponse = (patchCoreOffersWaitingForApprovalResponseSuccess)

export const getPatchCoreOffersWaitingForApprovalUrl = () => {


  

  return `/api/core/offers/waiting_for_approval/`
}

export const patchCoreOffersWaitingForApproval = async (patchedOfferSendKMTS: PatchedOfferSendKMTS, options?: RequestInit): Promise<patchCoreOffersWaitingForApprovalResponse> => {
  
  return patchCoreOffersWaitingForApprovalMutator<patchCoreOffersWaitingForApprovalResponse>(getPatchCoreOffersWaitingForApprovalUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedOfferSendKMTS,)
  }
);}
  



export const getPatchCoreOffersWaitingForApprovalMutationOptions = <TError = PatchCoreOffersWaitingForApprovalErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>, TError,{data: PatchedOfferSendKMTS}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>, TError,{data: PatchedOfferSendKMTS}, TContext> => {

const mutationKey = ['patchCoreOffersWaitingForApproval'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>, {data: PatchedOfferSendKMTS}> = (props) => {
          const {data} = props ?? {};

          return  patchCoreOffersWaitingForApproval(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCoreOffersWaitingForApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>>
    export type PatchCoreOffersWaitingForApprovalMutationBody = PatchedOfferSendKMTS
    export type PatchCoreOffersWaitingForApprovalMutationError = PatchCoreOffersWaitingForApprovalErrorType<unknown>

    /**
 * @deprecated
 */
export const usePatchCoreOffersWaitingForApproval = <TError = PatchCoreOffersWaitingForApprovalErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>, TError,{data: PatchedOfferSendKMTS}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchCoreOffersWaitingForApproval>>,
        TError,
        {data: PatchedOfferSendKMTS},
        TContext
      > => {
      return useMutation(getPatchCoreOffersWaitingForApprovalMutationOptions(options));
    }
    export type getCorePointToPointPricesResponse200 = {
  data: PointToPointPrice[]
  status: 200
}

export type getCorePointToPointPricesResponseSuccess = (getCorePointToPointPricesResponse200) & {
  headers: Headers;
};
;

export type getCorePointToPointPricesResponse = (getCorePointToPointPricesResponseSuccess)

export const getGetCorePointToPointPricesUrl = (params: GetCorePointToPointPricesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/point-to-point-prices/?${stringifiedParams}` : `/api/core/point-to-point-prices/`
}

export const getCorePointToPointPrices = async (params: GetCorePointToPointPricesParams, options?: RequestInit): Promise<getCorePointToPointPricesResponse> => {
  
  return getCorePointToPointPricesMutator<getCorePointToPointPricesResponse>(getGetCorePointToPointPricesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCorePointToPointPricesQueryKey = (params?: GetCorePointToPointPricesParams,) => {
    return [
    `/api/core/point-to-point-prices/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCorePointToPointPricesQueryOptions = <TData = Awaited<ReturnType<typeof getCorePointToPointPrices>>, TError = GetCorePointToPointPricesErrorType<unknown>>(params: GetCorePointToPointPricesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCorePointToPointPrices>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCorePointToPointPricesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCorePointToPointPrices>>> = ({ signal }) => getCorePointToPointPrices(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCorePointToPointPrices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCorePointToPointPricesQueryResult = NonNullable<Awaited<ReturnType<typeof getCorePointToPointPrices>>>
export type GetCorePointToPointPricesQueryError = GetCorePointToPointPricesErrorType<unknown>



export function useGetCorePointToPointPrices<TData = Awaited<ReturnType<typeof getCorePointToPointPrices>>, TError = GetCorePointToPointPricesErrorType<unknown>>(
 params: GetCorePointToPointPricesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCorePointToPointPrices>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCorePointToPointPricesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreProgramOffersResponse200 = {
  data: PaginatedProgramOfferNewList
  status: 200
}

export type getCoreProgramOffersResponseSuccess = (getCoreProgramOffersResponse200) & {
  headers: Headers;
};
;

export type getCoreProgramOffersResponse = (getCoreProgramOffersResponseSuccess)

export const getGetCoreProgramOffersUrl = (params?: GetCoreProgramOffersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/program-offers/?${stringifiedParams}` : `/api/core/program-offers/`
}

export const getCoreProgramOffers = async (params?: GetCoreProgramOffersParams, options?: RequestInit): Promise<getCoreProgramOffersResponse> => {
  
  return getCoreProgramOffersMutator<getCoreProgramOffersResponse>(getGetCoreProgramOffersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreProgramOffersQueryKey = (params?: GetCoreProgramOffersParams,) => {
    return [
    `/api/core/program-offers/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreProgramOffersQueryOptions = <TData = Awaited<ReturnType<typeof getCoreProgramOffers>>, TError = GetCoreProgramOffersErrorType<unknown>>(params?: GetCoreProgramOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreProgramOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreProgramOffers>>> = ({ signal }) => getCoreProgramOffers(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreProgramOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreProgramOffers>>>
export type GetCoreProgramOffersQueryError = GetCoreProgramOffersErrorType<unknown>



export function useGetCoreProgramOffers<TData = Awaited<ReturnType<typeof getCoreProgramOffers>>, TError = GetCoreProgramOffersErrorType<unknown>>(
 params?: GetCoreProgramOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreProgramOffersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreProgramOffersFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getCoreProgramOffersFiltersFilterNameResponseSuccess = (getCoreProgramOffersFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getCoreProgramOffersFiltersFilterNameResponse = (getCoreProgramOffersFiltersFilterNameResponseSuccess)

export const getGetCoreProgramOffersFiltersFilterNameUrl = (filterName: string,
    params?: GetCoreProgramOffersFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/program-offers/filters/${filterName}/?${stringifiedParams}` : `/api/core/program-offers/filters/${filterName}/`
}

export const getCoreProgramOffersFiltersFilterName = async (filterName: string,
    params?: GetCoreProgramOffersFiltersFilterNameParams, options?: RequestInit): Promise<getCoreProgramOffersFiltersFilterNameResponse> => {
  
  return getCoreProgramOffersFiltersFilterNameMutator<getCoreProgramOffersFiltersFilterNameResponse>(getGetCoreProgramOffersFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreProgramOffersFiltersFilterNameQueryKey = (filterName: string,
    params?: GetCoreProgramOffersFiltersFilterNameParams,) => {
    return [
    `/api/core/program-offers/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreProgramOffersFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>, TError = GetCoreProgramOffersFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetCoreProgramOffersFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreProgramOffersFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>> = ({ signal }) => getCoreProgramOffersFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreProgramOffersFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>>
export type GetCoreProgramOffersFiltersFilterNameQueryError = GetCoreProgramOffersFiltersFilterNameErrorType<unknown>



export function useGetCoreProgramOffersFiltersFilterName<TData = Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>, TError = GetCoreProgramOffersFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetCoreProgramOffersFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreProgramOffersFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreProgramOffersFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreRefValuesForExtCalcResponse200 = {
  data: ExtCalcReferenceValues
  status: 200
}

export type getCoreRefValuesForExtCalcResponseSuccess = (getCoreRefValuesForExtCalcResponse200) & {
  headers: Headers;
};
;

export type getCoreRefValuesForExtCalcResponse = (getCoreRefValuesForExtCalcResponseSuccess)

export const getGetCoreRefValuesForExtCalcUrl = () => {


  

  return `/api/core/ref-values-for-ext-calc`
}

export const getCoreRefValuesForExtCalc = async ( options?: RequestInit): Promise<getCoreRefValuesForExtCalcResponse> => {
  
  return getCoreRefValuesForExtCalcMutator<getCoreRefValuesForExtCalcResponse>(getGetCoreRefValuesForExtCalcUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreRefValuesForExtCalcQueryKey = () => {
    return [
    `/api/core/ref-values-for-ext-calc`
    ] as const;
    }

    
export const getGetCoreRefValuesForExtCalcQueryOptions = <TData = Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>, TError = GetCoreRefValuesForExtCalcErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreRefValuesForExtCalcQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>> = ({ signal }) => getCoreRefValuesForExtCalc({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreRefValuesForExtCalcQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>>
export type GetCoreRefValuesForExtCalcQueryError = GetCoreRefValuesForExtCalcErrorType<unknown>



export function useGetCoreRefValuesForExtCalc<TData = Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>, TError = GetCoreRefValuesForExtCalcErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreRefValuesForExtCalc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreRefValuesForExtCalcQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type getCoreSystemInfoResponse200 = {
  data: SystemInfo
  status: 200
}

export type getCoreSystemInfoResponseSuccess = (getCoreSystemInfoResponse200) & {
  headers: Headers;
};
;

export type getCoreSystemInfoResponse = (getCoreSystemInfoResponseSuccess)

export const getGetCoreSystemInfoUrl = () => {


  

  return `/api/core/system_info/`
}

export const getCoreSystemInfo = async ( options?: RequestInit): Promise<getCoreSystemInfoResponse> => {
  
  return getCoreSystemInfoMutator<getCoreSystemInfoResponse>(getGetCoreSystemInfoUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreSystemInfoQueryKey = () => {
    return [
    `/api/core/system_info/`
    ] as const;
    }

    
export const getGetCoreSystemInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCoreSystemInfo>>, TError = GetCoreSystemInfoErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreSystemInfo>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreSystemInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreSystemInfo>>> = ({ signal }) => getCoreSystemInfo({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreSystemInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreSystemInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreSystemInfo>>>
export type GetCoreSystemInfoQueryError = GetCoreSystemInfoErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreSystemInfo<TData = Awaited<ReturnType<typeof getCoreSystemInfo>>, TError = GetCoreSystemInfoErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreSystemInfo>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreSystemInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreTemplatesResponse200 = {
  data: OfferTemplateList[]
  status: 200
}

export type getCoreTemplatesResponseSuccess = (getCoreTemplatesResponse200) & {
  headers: Headers;
};
;

export type getCoreTemplatesResponse = (getCoreTemplatesResponseSuccess)

export const getGetCoreTemplatesUrl = (params: GetCoreTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/templates/?${stringifiedParams}` : `/api/core/templates/`
}

export const getCoreTemplates = async (params: GetCoreTemplatesParams, options?: RequestInit): Promise<getCoreTemplatesResponse> => {
  
  return getCoreTemplatesMutator<getCoreTemplatesResponse>(getGetCoreTemplatesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreTemplatesQueryKey = (params?: GetCoreTemplatesParams,) => {
    return [
    `/api/core/templates/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getCoreTemplates>>, TError = GetCoreTemplatesErrorType<unknown>>(params: GetCoreTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplates>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreTemplatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreTemplates>>> = ({ signal }) => getCoreTemplates(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreTemplates>>>
export type GetCoreTemplatesQueryError = GetCoreTemplatesErrorType<unknown>



export function useGetCoreTemplates<TData = Awaited<ReturnType<typeof getCoreTemplates>>, TError = GetCoreTemplatesErrorType<unknown>>(
 params: GetCoreTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplates>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type postCoreTemplatesResponse201 = {
  data: OfferTemplateCreate
  status: 201
}

export type postCoreTemplatesResponseSuccess = (postCoreTemplatesResponse201) & {
  headers: Headers;
};
;

export type postCoreTemplatesResponse = (postCoreTemplatesResponseSuccess)

export const getPostCoreTemplatesUrl = () => {


  

  return `/api/core/templates/`
}

export const postCoreTemplates = async (offerTemplateCreate: NonReadonly<OfferTemplateCreate>, options?: RequestInit): Promise<postCoreTemplatesResponse> => {
  
  return postCoreTemplatesMutator<postCoreTemplatesResponse>(getPostCoreTemplatesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerTemplateCreate,)
  }
);}
  



export const getPostCoreTemplatesMutationOptions = <TError = PostCoreTemplatesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreTemplates>>, TError,{data: NonReadonly<OfferTemplateCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreTemplates>>, TError,{data: NonReadonly<OfferTemplateCreate>}, TContext> => {

const mutationKey = ['postCoreTemplates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreTemplates>>, {data: NonReadonly<OfferTemplateCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postCoreTemplates(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreTemplates>>>
    export type PostCoreTemplatesMutationBody = NonReadonly<OfferTemplateCreate>
    export type PostCoreTemplatesMutationError = PostCoreTemplatesErrorType<unknown>

    /**
 * @deprecated
 */
export const usePostCoreTemplates = <TError = PostCoreTemplatesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreTemplates>>, TError,{data: NonReadonly<OfferTemplateCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreTemplates>>,
        TError,
        {data: NonReadonly<OfferTemplateCreate>},
        TContext
      > => {
      return useMutation(getPostCoreTemplatesMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type getCoreTemplatesIdResponse200 = {
  data: OfferTemplate
  status: 200
}

export type getCoreTemplatesIdResponseSuccess = (getCoreTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type getCoreTemplatesIdResponse = (getCoreTemplatesIdResponseSuccess)

export const getGetCoreTemplatesIdUrl = (id: number,) => {


  

  return `/api/core/templates/${id}/`
}

export const getCoreTemplatesId = async (id: number, options?: RequestInit): Promise<getCoreTemplatesIdResponse> => {
  
  return getCoreTemplatesIdMutator<getCoreTemplatesIdResponse>(getGetCoreTemplatesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreTemplatesIdQueryKey = (id: number,) => {
    return [
    `/api/core/templates/${id}/`
    ] as const;
    }

    
export const getGetCoreTemplatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreTemplatesId>>, TError = GetCoreTemplatesIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplatesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreTemplatesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreTemplatesId>>> = ({ signal }) => getCoreTemplatesId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplatesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreTemplatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreTemplatesId>>>
export type GetCoreTemplatesIdQueryError = GetCoreTemplatesIdErrorType<unknown>


/**
 * @deprecated
 */

export function useGetCoreTemplatesId<TData = Awaited<ReturnType<typeof getCoreTemplatesId>>, TError = GetCoreTemplatesIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreTemplatesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreTemplatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type patchCoreTemplatesIdResponse200 = {
  data: OfferTemplateUpdate
  status: 200
}

export type patchCoreTemplatesIdResponseSuccess = (patchCoreTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type patchCoreTemplatesIdResponse = (patchCoreTemplatesIdResponseSuccess)

export const getPatchCoreTemplatesIdUrl = (id: number,) => {


  

  return `/api/core/templates/${id}/`
}

export const patchCoreTemplatesId = async (id: number,
    patchedOfferTemplateUpdate: NonReadonly<PatchedOfferTemplateUpdate>, options?: RequestInit): Promise<patchCoreTemplatesIdResponse> => {
  
  return patchCoreTemplatesIdMutator<patchCoreTemplatesIdResponse>(getPatchCoreTemplatesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedOfferTemplateUpdate,)
  }
);}
  



export const getPatchCoreTemplatesIdMutationOptions = <TError = PatchCoreTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreTemplatesId>>, TError,{id: number;data: NonReadonly<PatchedOfferTemplateUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCoreTemplatesId>>, TError,{id: number;data: NonReadonly<PatchedOfferTemplateUpdate>}, TContext> => {

const mutationKey = ['patchCoreTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCoreTemplatesId>>, {id: number;data: NonReadonly<PatchedOfferTemplateUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCoreTemplatesId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCoreTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCoreTemplatesId>>>
    export type PatchCoreTemplatesIdMutationBody = NonReadonly<PatchedOfferTemplateUpdate>
    export type PatchCoreTemplatesIdMutationError = PatchCoreTemplatesIdErrorType<unknown>

    /**
 * @deprecated
 */
export const usePatchCoreTemplatesId = <TError = PatchCoreTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCoreTemplatesId>>, TError,{id: number;data: NonReadonly<PatchedOfferTemplateUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchCoreTemplatesId>>,
        TError,
        {id: number;data: NonReadonly<PatchedOfferTemplateUpdate>},
        TContext
      > => {
      return useMutation(getPatchCoreTemplatesIdMutationOptions(options));
    }
    export type deleteCoreTemplatesIdResponse204 = {
  data: void
  status: 204
}

export type deleteCoreTemplatesIdResponseSuccess = (deleteCoreTemplatesIdResponse204) & {
  headers: Headers;
};
;

export type deleteCoreTemplatesIdResponse = (deleteCoreTemplatesIdResponseSuccess)

export const getDeleteCoreTemplatesIdUrl = (id: number,) => {


  

  return `/api/core/templates/${id}/`
}

export const deleteCoreTemplatesId = async (id: number, options?: RequestInit): Promise<deleteCoreTemplatesIdResponse> => {
  
  return deleteCoreTemplatesIdMutator<deleteCoreTemplatesIdResponse>(getDeleteCoreTemplatesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteCoreTemplatesIdMutationOptions = <TError = DeleteCoreTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoreTemplatesId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoreTemplatesId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCoreTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoreTemplatesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCoreTemplatesId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCoreTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoreTemplatesId>>>
    
    export type DeleteCoreTemplatesIdMutationError = DeleteCoreTemplatesIdErrorType<unknown>

    export const useDeleteCoreTemplatesId = <TError = DeleteCoreTemplatesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoreTemplatesId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoreTemplatesId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCoreTemplatesIdMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type postCoreUploadVolumeFileResponse200 = {
  data: string
  status: 200
}

export type postCoreUploadVolumeFileResponseSuccess = (postCoreUploadVolumeFileResponse200) & {
  headers: Headers;
};
;

export type postCoreUploadVolumeFileResponse = (postCoreUploadVolumeFileResponseSuccess)

export const getPostCoreUploadVolumeFileUrl = () => {


  

  return `/api/core/upload_volume_file/`
}

export const postCoreUploadVolumeFile = async (postCoreUploadVolumeFileBody: Blob, options?: RequestInit): Promise<postCoreUploadVolumeFileResponse> => {
  
  return postCoreUploadVolumeFileMutator<postCoreUploadVolumeFileResponse>(getPostCoreUploadVolumeFileUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postCoreUploadVolumeFileBody,)
  }
);}
  



export const getPostCoreUploadVolumeFileMutationOptions = <TError = PostCoreUploadVolumeFileErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreUploadVolumeFile>>, TError,{data: Blob}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCoreUploadVolumeFile>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['postCoreUploadVolumeFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCoreUploadVolumeFile>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  postCoreUploadVolumeFile(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostCoreUploadVolumeFileMutationResult = NonNullable<Awaited<ReturnType<typeof postCoreUploadVolumeFile>>>
    export type PostCoreUploadVolumeFileMutationBody = Blob
    export type PostCoreUploadVolumeFileMutationError = PostCoreUploadVolumeFileErrorType<unknown>

    /**
 * @deprecated
 */
export const usePostCoreUploadVolumeFile = <TError = PostCoreUploadVolumeFileErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCoreUploadVolumeFile>>, TError,{data: Blob}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postCoreUploadVolumeFile>>,
        TError,
        {data: Blob},
        TContext
      > => {
      return useMutation(getPostCoreUploadVolumeFileMutationOptions(options));
    }
    export type getCoreWeekActivitiesResponse200 = {
  data: Activity[]
  status: 200
}

export type getCoreWeekActivitiesResponseSuccess = (getCoreWeekActivitiesResponse200) & {
  headers: Headers;
};
;

export type getCoreWeekActivitiesResponse = (getCoreWeekActivitiesResponseSuccess)

export const getGetCoreWeekActivitiesUrl = (params?: GetCoreWeekActivitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/core/week-activities/?${stringifiedParams}` : `/api/core/week-activities/`
}

export const getCoreWeekActivities = async (params?: GetCoreWeekActivitiesParams, options?: RequestInit): Promise<getCoreWeekActivitiesResponse> => {
  
  return getCoreWeekActivitiesMutator<getCoreWeekActivitiesResponse>(getGetCoreWeekActivitiesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreWeekActivitiesQueryKey = (params?: GetCoreWeekActivitiesParams,) => {
    return [
    `/api/core/week-activities/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetCoreWeekActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getCoreWeekActivities>>, TError = GetCoreWeekActivitiesErrorType<unknown>>(params?: GetCoreWeekActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivities>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreWeekActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreWeekActivities>>> = ({ signal }) => getCoreWeekActivities(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreWeekActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreWeekActivities>>>
export type GetCoreWeekActivitiesQueryError = GetCoreWeekActivitiesErrorType<unknown>



export function useGetCoreWeekActivities<TData = Awaited<ReturnType<typeof getCoreWeekActivities>>, TError = GetCoreWeekActivitiesErrorType<unknown>>(
 params?: GetCoreWeekActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivities>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreWeekActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getCoreWeekActivitiesIdResponse200 = {
  data: Activity
  status: 200
}

export type getCoreWeekActivitiesIdResponseSuccess = (getCoreWeekActivitiesIdResponse200) & {
  headers: Headers;
};
;

export type getCoreWeekActivitiesIdResponse = (getCoreWeekActivitiesIdResponseSuccess)

export const getGetCoreWeekActivitiesIdUrl = (id: number,) => {


  

  return `/api/core/week-activities/${id}/`
}

export const getCoreWeekActivitiesId = async (id: number, options?: RequestInit): Promise<getCoreWeekActivitiesIdResponse> => {
  
  return getCoreWeekActivitiesIdMutator<getCoreWeekActivitiesIdResponse>(getGetCoreWeekActivitiesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetCoreWeekActivitiesIdQueryKey = (id: number,) => {
    return [
    `/api/core/week-activities/${id}/`
    ] as const;
    }

    
export const getGetCoreWeekActivitiesIdQueryOptions = <TData = Awaited<ReturnType<typeof getCoreWeekActivitiesId>>, TError = GetCoreWeekActivitiesIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivitiesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoreWeekActivitiesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoreWeekActivitiesId>>> = ({ signal }) => getCoreWeekActivitiesId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivitiesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCoreWeekActivitiesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCoreWeekActivitiesId>>>
export type GetCoreWeekActivitiesIdQueryError = GetCoreWeekActivitiesIdErrorType<unknown>



export function useGetCoreWeekActivitiesId<TData = Awaited<ReturnType<typeof getCoreWeekActivitiesId>>, TError = GetCoreWeekActivitiesIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCoreWeekActivitiesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCoreWeekActivitiesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Исключительно для переопределения swagger.
 */
export type getEventsResponse200 = {
  data: PaginatedEventList
  status: 200
}

export type getEventsResponseSuccess = (getEventsResponse200) & {
  headers: Headers;
};
;

export type getEventsResponse = (getEventsResponseSuccess)

export const getGetEventsUrl = (params?: GetEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/events/?${stringifiedParams}` : `/api/events/`
}

export const getEvents = async (params?: GetEventsParams, options?: RequestInit): Promise<getEventsResponse> => {
  
  return getEventsMutator<getEventsResponse>(getGetEventsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/api/events/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEventsErrorType<unknown>>(params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = GetEventsErrorType<unknown>



export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = GetEventsErrorType<unknown>>(
 params?: GetEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getEventsFilterValuesEventTypesResponse200 = {
  data: EventFilterEventTypes
  status: 200
}

export type getEventsFilterValuesEventTypesResponseSuccess = (getEventsFilterValuesEventTypesResponse200) & {
  headers: Headers;
};
;

export type getEventsFilterValuesEventTypesResponse = (getEventsFilterValuesEventTypesResponseSuccess)

export const getGetEventsFilterValuesEventTypesUrl = () => {


  

  return `/api/events/filter-values/event_types/`
}

export const getEventsFilterValuesEventTypes = async ( options?: RequestInit): Promise<getEventsFilterValuesEventTypesResponse> => {
  
  return getEventsFilterValuesEventTypesMutator<getEventsFilterValuesEventTypesResponse>(getGetEventsFilterValuesEventTypesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetEventsFilterValuesEventTypesQueryKey = () => {
    return [
    `/api/events/filter-values/event_types/`
    ] as const;
    }

    
export const getGetEventsFilterValuesEventTypesQueryOptions = <TData = Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>, TError = GetEventsFilterValuesEventTypesErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsFilterValuesEventTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>> = ({ signal }) => getEventsFilterValuesEventTypes({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsFilterValuesEventTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>>
export type GetEventsFilterValuesEventTypesQueryError = GetEventsFilterValuesEventTypesErrorType<unknown>



export function useGetEventsFilterValuesEventTypes<TData = Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>, TError = GetEventsFilterValuesEventTypesErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesEventTypes>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsFilterValuesEventTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getEventsFilterValuesProductsResponse200 = {
  data: ProductBase[]
  status: 200
}

export type getEventsFilterValuesProductsResponseSuccess = (getEventsFilterValuesProductsResponse200) & {
  headers: Headers;
};
;

export type getEventsFilterValuesProductsResponse = (getEventsFilterValuesProductsResponseSuccess)

export const getGetEventsFilterValuesProductsUrl = () => {


  

  return `/api/events/filter-values/products/`
}

export const getEventsFilterValuesProducts = async ( options?: RequestInit): Promise<getEventsFilterValuesProductsResponse> => {
  
  return getEventsFilterValuesProductsMutator<getEventsFilterValuesProductsResponse>(getGetEventsFilterValuesProductsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetEventsFilterValuesProductsQueryKey = () => {
    return [
    `/api/events/filter-values/products/`
    ] as const;
    }

    
export const getGetEventsFilterValuesProductsQueryOptions = <TData = Awaited<ReturnType<typeof getEventsFilterValuesProducts>>, TError = GetEventsFilterValuesProductsErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesProducts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsFilterValuesProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsFilterValuesProducts>>> = ({ signal }) => getEventsFilterValuesProducts({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsFilterValuesProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsFilterValuesProducts>>>
export type GetEventsFilterValuesProductsQueryError = GetEventsFilterValuesProductsErrorType<unknown>



export function useGetEventsFilterValuesProducts<TData = Awaited<ReturnType<typeof getEventsFilterValuesProducts>>, TError = GetEventsFilterValuesProductsErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesProducts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsFilterValuesProductsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getEventsFilterValuesSuppliersResponse200 = {
  data: SupplierSimple[]
  status: 200
}

export type getEventsFilterValuesSuppliersResponseSuccess = (getEventsFilterValuesSuppliersResponse200) & {
  headers: Headers;
};
;

export type getEventsFilterValuesSuppliersResponse = (getEventsFilterValuesSuppliersResponseSuccess)

export const getGetEventsFilterValuesSuppliersUrl = () => {


  

  return `/api/events/filter-values/suppliers/`
}

export const getEventsFilterValuesSuppliers = async ( options?: RequestInit): Promise<getEventsFilterValuesSuppliersResponse> => {
  
  return getEventsFilterValuesSuppliersMutator<getEventsFilterValuesSuppliersResponse>(getGetEventsFilterValuesSuppliersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetEventsFilterValuesSuppliersQueryKey = () => {
    return [
    `/api/events/filter-values/suppliers/`
    ] as const;
    }

    
export const getGetEventsFilterValuesSuppliersQueryOptions = <TData = Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>, TError = GetEventsFilterValuesSuppliersErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsFilterValuesSuppliersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>> = ({ signal }) => getEventsFilterValuesSuppliers({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEventsFilterValuesSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>>
export type GetEventsFilterValuesSuppliersQueryError = GetEventsFilterValuesSuppliersErrorType<unknown>



export function useGetEventsFilterValuesSuppliers<TData = Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>, TError = GetEventsFilterValuesSuppliersErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterValuesSuppliers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEventsFilterValuesSuppliersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postEventsMakeAllViewedResponse200 = {
  data: EventManageResponse
  status: 200
}

export type postEventsMakeAllViewedResponseSuccess = (postEventsMakeAllViewedResponse200) & {
  headers: Headers;
};
;

export type postEventsMakeAllViewedResponse = (postEventsMakeAllViewedResponseSuccess)

export const getPostEventsMakeAllViewedUrl = () => {


  

  return `/api/events/make-all-viewed/`
}

export const postEventsMakeAllViewed = async ( options?: RequestInit): Promise<postEventsMakeAllViewedResponse> => {
  
  return postEventsMakeAllViewedMutator<postEventsMakeAllViewedResponse>(getPostEventsMakeAllViewedUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getPostEventsMakeAllViewedMutationOptions = <TError = PostEventsMakeAllViewedErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeAllViewed>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeAllViewed>>, TError,void, TContext> => {

const mutationKey = ['postEventsMakeAllViewed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventsMakeAllViewed>>, void> = () => {
          

          return  postEventsMakeAllViewed()
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsMakeAllViewedMutationResult = NonNullable<Awaited<ReturnType<typeof postEventsMakeAllViewed>>>
    
    export type PostEventsMakeAllViewedMutationError = PostEventsMakeAllViewedErrorType<unknown>

    export const usePostEventsMakeAllViewed = <TError = PostEventsMakeAllViewedErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeAllViewed>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postEventsMakeAllViewed>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostEventsMakeAllViewedMutationOptions(options));
    }
    export type postEventsMakeViewedResponse200 = {
  data: EventManageResponse
  status: 200
}

export type postEventsMakeViewedResponseSuccess = (postEventsMakeViewedResponse200) & {
  headers: Headers;
};
;

export type postEventsMakeViewedResponse = (postEventsMakeViewedResponseSuccess)

export const getPostEventsMakeViewedUrl = () => {


  

  return `/api/events/make-viewed/`
}

export const postEventsMakeViewed = async (eventManage: EventManage, options?: RequestInit): Promise<postEventsMakeViewedResponse> => {
  
  return postEventsMakeViewedMutator<postEventsMakeViewedResponse>(getPostEventsMakeViewedUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventManage,)
  }
);}
  



export const getPostEventsMakeViewedMutationOptions = <TError = PostEventsMakeViewedErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeViewed>>, TError,{data: EventManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeViewed>>, TError,{data: EventManage}, TContext> => {

const mutationKey = ['postEventsMakeViewed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventsMakeViewed>>, {data: EventManage}> = (props) => {
          const {data} = props ?? {};

          return  postEventsMakeViewed(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsMakeViewedMutationResult = NonNullable<Awaited<ReturnType<typeof postEventsMakeViewed>>>
    export type PostEventsMakeViewedMutationBody = EventManage
    export type PostEventsMakeViewedMutationError = PostEventsMakeViewedErrorType<unknown>

    export const usePostEventsMakeViewed = <TError = PostEventsMakeViewedErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsMakeViewed>>, TError,{data: EventManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postEventsMakeViewed>>,
        TError,
        {data: EventManage},
        TContext
      > => {
      return useMutation(getPostEventsMakeViewedMutationOptions(options));
    }
    export type postEventsToggleViewedAtObjectResponse200 = {
  data: EventManageResponse
  status: 200
}

export type postEventsToggleViewedAtObjectResponseSuccess = (postEventsToggleViewedAtObjectResponse200) & {
  headers: Headers;
};
;

export type postEventsToggleViewedAtObjectResponse = (postEventsToggleViewedAtObjectResponseSuccess)

export const getPostEventsToggleViewedAtObjectUrl = () => {


  

  return `/api/events/toggle-viewed-at-object/`
}

export const postEventsToggleViewedAtObject = async (eventAtObjectManage: EventAtObjectManage, options?: RequestInit): Promise<postEventsToggleViewedAtObjectResponse> => {
  
  return postEventsToggleViewedAtObjectMutator<postEventsToggleViewedAtObjectResponse>(getPostEventsToggleViewedAtObjectUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eventAtObjectManage,)
  }
);}
  



export const getPostEventsToggleViewedAtObjectMutationOptions = <TError = PostEventsToggleViewedAtObjectErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>, TError,{data: EventAtObjectManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>, TError,{data: EventAtObjectManage}, TContext> => {

const mutationKey = ['postEventsToggleViewedAtObject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>, {data: EventAtObjectManage}> = (props) => {
          const {data} = props ?? {};

          return  postEventsToggleViewedAtObject(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsToggleViewedAtObjectMutationResult = NonNullable<Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>>
    export type PostEventsToggleViewedAtObjectMutationBody = EventAtObjectManage
    export type PostEventsToggleViewedAtObjectMutationError = PostEventsToggleViewedAtObjectErrorType<unknown>

    export const usePostEventsToggleViewedAtObject = <TError = PostEventsToggleViewedAtObjectErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>, TError,{data: EventAtObjectManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postEventsToggleViewedAtObject>>,
        TError,
        {data: EventAtObjectManage},
        TContext
      > => {
      return useMutation(getPostEventsToggleViewedAtObjectMutationOptions(options));
    }
    /**
 * Получение списка регионов для выбранной страны, доступно всем ролям
 */
export type getGeoCountryCountryPkRegionsResponse200 = {
  data: Region[]
  status: 200
}

export type getGeoCountryCountryPkRegionsResponseSuccess = (getGeoCountryCountryPkRegionsResponse200) & {
  headers: Headers;
};
;

export type getGeoCountryCountryPkRegionsResponse = (getGeoCountryCountryPkRegionsResponseSuccess)

export const getGetGeoCountryCountryPkRegionsUrl = (countryPk: number,) => {


  

  return `/api/geo/country/${countryPk}/regions/`
}

export const getGeoCountryCountryPkRegions = async (countryPk: number, options?: RequestInit): Promise<getGeoCountryCountryPkRegionsResponse> => {
  
  return getGeoCountryCountryPkRegionsMutator<getGeoCountryCountryPkRegionsResponse>(getGetGeoCountryCountryPkRegionsUrl(countryPk),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetGeoCountryCountryPkRegionsQueryKey = (countryPk: number,) => {
    return [
    `/api/geo/country/${countryPk}/regions/`
    ] as const;
    }

    
export const getGetGeoCountryCountryPkRegionsQueryOptions = <TData = Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>, TError = GetGeoCountryCountryPkRegionsErrorType<unknown>>(countryPk: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeoCountryCountryPkRegionsQueryKey(countryPk);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>> = ({ signal }) => getGeoCountryCountryPkRegions(countryPk, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(countryPk), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGeoCountryCountryPkRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>>
export type GetGeoCountryCountryPkRegionsQueryError = GetGeoCountryCountryPkRegionsErrorType<unknown>



export function useGetGeoCountryCountryPkRegions<TData = Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>, TError = GetGeoCountryCountryPkRegionsErrorType<unknown>>(
 countryPk: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGeoCountryCountryPkRegions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGeoCountryCountryPkRegionsQueryOptions(countryPk,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getGuidesOfferSizesResponse200 = {
  data: OfferSizeList[]
  status: 200
}

export type getGuidesOfferSizesResponseSuccess = (getGuidesOfferSizesResponse200) & {
  headers: Headers;
};
;

export type getGuidesOfferSizesResponse = (getGuidesOfferSizesResponseSuccess)

export const getGetGuidesOfferSizesUrl = (params?: GetGuidesOfferSizesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/guides/offer_sizes/?${stringifiedParams}` : `/api/guides/offer_sizes/`
}

export const getGuidesOfferSizes = async (params?: GetGuidesOfferSizesParams, options?: RequestInit): Promise<getGuidesOfferSizesResponse> => {
  
  return getGuidesOfferSizesMutator<getGuidesOfferSizesResponse>(getGetGuidesOfferSizesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetGuidesOfferSizesQueryKey = (params?: GetGuidesOfferSizesParams,) => {
    return [
    `/api/guides/offer_sizes/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetGuidesOfferSizesQueryOptions = <TData = Awaited<ReturnType<typeof getGuidesOfferSizes>>, TError = GetGuidesOfferSizesErrorType<unknown>>(params?: GetGuidesOfferSizesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSizes>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuidesOfferSizesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuidesOfferSizes>>> = ({ signal }) => getGuidesOfferSizes(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSizes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuidesOfferSizesQueryResult = NonNullable<Awaited<ReturnType<typeof getGuidesOfferSizes>>>
export type GetGuidesOfferSizesQueryError = GetGuidesOfferSizesErrorType<unknown>



export function useGetGuidesOfferSizes<TData = Awaited<ReturnType<typeof getGuidesOfferSizes>>, TError = GetGuidesOfferSizesErrorType<unknown>>(
 params?: GetGuidesOfferSizesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSizes>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGuidesOfferSizesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getGuidesOfferSortsResponse200 = {
  data: OfferSortSizeList[]
  status: 200
}

export type getGuidesOfferSortsResponseSuccess = (getGuidesOfferSortsResponse200) & {
  headers: Headers;
};
;

export type getGuidesOfferSortsResponse = (getGuidesOfferSortsResponseSuccess)

export const getGetGuidesOfferSortsUrl = (params?: GetGuidesOfferSortsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/guides/offer_sorts/?${stringifiedParams}` : `/api/guides/offer_sorts/`
}

export const getGuidesOfferSorts = async (params?: GetGuidesOfferSortsParams, options?: RequestInit): Promise<getGuidesOfferSortsResponse> => {
  
  return getGuidesOfferSortsMutator<getGuidesOfferSortsResponse>(getGetGuidesOfferSortsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetGuidesOfferSortsQueryKey = (params?: GetGuidesOfferSortsParams,) => {
    return [
    `/api/guides/offer_sorts/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetGuidesOfferSortsQueryOptions = <TData = Awaited<ReturnType<typeof getGuidesOfferSorts>>, TError = GetGuidesOfferSortsErrorType<unknown>>(params?: GetGuidesOfferSortsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSorts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuidesOfferSortsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuidesOfferSorts>>> = ({ signal }) => getGuidesOfferSorts(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSorts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGuidesOfferSortsQueryResult = NonNullable<Awaited<ReturnType<typeof getGuidesOfferSorts>>>
export type GetGuidesOfferSortsQueryError = GetGuidesOfferSortsErrorType<unknown>



export function useGetGuidesOfferSorts<TData = Awaited<ReturnType<typeof getGuidesOfferSorts>>, TError = GetGuidesOfferSortsErrorType<unknown>>(
 params?: GetGuidesOfferSortsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGuidesOfferSorts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGuidesOfferSortsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Список миксов
 */
export type getMixResponse200 = {
  data: PaginatedMixItemList
  status: 200
}

export type getMixResponseSuccess = (getMixResponse200) & {
  headers: Headers;
};
;

export type getMixResponse = (getMixResponseSuccess)

export const getGetMixUrl = (params?: GetMixParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mix/?${stringifiedParams}` : `/api/mix/`
}

export const getMix = async (params?: GetMixParams, options?: RequestInit): Promise<getMixResponse> => {
  
  return getMixMutator<getMixResponse>(getGetMixUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetMixQueryKey = (params?: GetMixParams,) => {
    return [
    `/api/mix/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetMixQueryOptions = <TData = Awaited<ReturnType<typeof getMix>>, TError = GetMixErrorType<unknown>>(params?: GetMixParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMix>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMixQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMix>>> = ({ signal }) => getMix(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMix>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMixQueryResult = NonNullable<Awaited<ReturnType<typeof getMix>>>
export type GetMixQueryError = GetMixErrorType<unknown>



export function useGetMix<TData = Awaited<ReturnType<typeof getMix>>, TError = GetMixErrorType<unknown>>(
 params?: GetMixParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMix>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMixQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Создание микса
 */
export type postMixResponse201 = {
  data: MixCreate
  status: 201
}

export type postMixResponseSuccess = (postMixResponse201) & {
  headers: Headers;
};
;

export type postMixResponse = (postMixResponseSuccess)

export const getPostMixUrl = () => {


  

  return `/api/mix/`
}

export const postMix = async (mixCreate: NonReadonly<MixCreate>, options?: RequestInit): Promise<postMixResponse> => {
  
  return postMixMutator<postMixResponse>(getPostMixUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mixCreate,)
  }
);}
  



export const getPostMixMutationOptions = <TError = PostMixErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMix>>, TError,{data: NonReadonly<MixCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMix>>, TError,{data: NonReadonly<MixCreate>}, TContext> => {

const mutationKey = ['postMix'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMix>>, {data: NonReadonly<MixCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postMix(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostMixMutationResult = NonNullable<Awaited<ReturnType<typeof postMix>>>
    export type PostMixMutationBody = NonReadonly<MixCreate>
    export type PostMixMutationError = PostMixErrorType<unknown>

    export const usePostMix = <TError = PostMixErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMix>>, TError,{data: NonReadonly<MixCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postMix>>,
        TError,
        {data: NonReadonly<MixCreate>},
        TContext
      > => {
      return useMutation(getPostMixMutationOptions(options));
    }
    /**
 * Микс с контр-офферами
 */
export type getMixIdResponse200 = {
  data: MixDetailMeta
  status: 200
}

export type getMixIdResponseSuccess = (getMixIdResponse200) & {
  headers: Headers;
};
;

export type getMixIdResponse = (getMixIdResponseSuccess)

export const getGetMixIdUrl = (id: number,) => {


  

  return `/api/mix/${id}/`
}

export const getMixId = async (id: number, options?: RequestInit): Promise<getMixIdResponse> => {
  
  return getMixIdMutator<getMixIdResponse>(getGetMixIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetMixIdQueryKey = (id: number,) => {
    return [
    `/api/mix/${id}/`
    ] as const;
    }

    
export const getGetMixIdQueryOptions = <TData = Awaited<ReturnType<typeof getMixId>>, TError = GetMixIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMixId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMixIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMixId>>> = ({ signal }) => getMixId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMixId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMixIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMixId>>>
export type GetMixIdQueryError = GetMixIdErrorType<unknown>



export function useGetMixId<TData = Awaited<ReturnType<typeof getMixId>>, TError = GetMixIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMixId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMixIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Обновление микса для ролей RVI/RVI_Super/Supplier
 */
export type putMixIdResponse200 = {
  data: MixUpdateMeta
  status: 200
}

export type putMixIdResponseSuccess = (putMixIdResponse200) & {
  headers: Headers;
};
;

export type putMixIdResponse = (putMixIdResponseSuccess)

export const getPutMixIdUrl = (id: number,) => {


  

  return `/api/mix/${id}/`
}

export const putMixId = async (id: number,
    mixUpdateMeta: NonReadonly<MixUpdateMeta>, options?: RequestInit): Promise<putMixIdResponse> => {
  
  return putMixIdMutator<putMixIdResponse>(getPutMixIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mixUpdateMeta,)
  }
);}
  



export const getPutMixIdMutationOptions = <TError = PutMixIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMixId>>, TError,{id: number;data: NonReadonly<MixUpdateMeta>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMixId>>, TError,{id: number;data: NonReadonly<MixUpdateMeta>}, TContext> => {

const mutationKey = ['putMixId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMixId>>, {id: number;data: NonReadonly<MixUpdateMeta>}> = (props) => {
          const {id,data} = props ?? {};

          return  putMixId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutMixIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMixId>>>
    export type PutMixIdMutationBody = NonReadonly<MixUpdateMeta>
    export type PutMixIdMutationError = PutMixIdErrorType<unknown>

    export const usePutMixId = <TError = PutMixIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMixId>>, TError,{id: number;data: NonReadonly<MixUpdateMeta>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putMixId>>,
        TError,
        {id: number;data: NonReadonly<MixUpdateMeta>},
        TContext
      > => {
      return useMutation(getPutMixIdMutationOptions(options));
    }
    /**
 * Управление миксом: согласование, отклонение
 */
export type postMixIdManageResponse200 = {
  data: ManageActionResult
  status: 200
}

export type postMixIdManageResponseSuccess = (postMixIdManageResponse200) & {
  headers: Headers;
};
;

export type postMixIdManageResponse = (postMixIdManageResponseSuccess)

export const getPostMixIdManageUrl = (id: number,) => {


  

  return `/api/mix/${id}/manage/`
}

export const postMixIdManage = async (id: number,
    mixManage: MixManage, options?: RequestInit): Promise<postMixIdManageResponse> => {
  
  return postMixIdManageMutator<postMixIdManageResponse>(getPostMixIdManageUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mixManage,)
  }
);}
  



export const getPostMixIdManageMutationOptions = <TError = PostMixIdManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMixIdManage>>, TError,{id: number;data: MixManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postMixIdManage>>, TError,{id: number;data: MixManage}, TContext> => {

const mutationKey = ['postMixIdManage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMixIdManage>>, {id: number;data: MixManage}> = (props) => {
          const {id,data} = props ?? {};

          return  postMixIdManage(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostMixIdManageMutationResult = NonNullable<Awaited<ReturnType<typeof postMixIdManage>>>
    export type PostMixIdManageMutationBody = MixManage
    export type PostMixIdManageMutationError = PostMixIdManageErrorType<unknown>

    export const usePostMixIdManage = <TError = PostMixIdManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMixIdManage>>, TError,{id: number;data: MixManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postMixIdManage>>,
        TError,
        {id: number;data: MixManage},
        TContext
      > => {
      return useMutation(getPostMixIdManageMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type getOrderResponse200 = {
  data: PaginatedLogosOrderListList
  status: 200
}

export type getOrderResponseSuccess = (getOrderResponse200) & {
  headers: Headers;
};
;

export type getOrderResponse = (getOrderResponseSuccess)

export const getGetOrderUrl = (params?: GetOrderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/order/?${stringifiedParams}` : `/api/order/`
}

export const getOrder = async (params?: GetOrderParams, options?: RequestInit): Promise<getOrderResponse> => {
  
  return getOrderMutator<getOrderResponse>(getGetOrderUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetOrderQueryKey = (params?: GetOrderParams,) => {
    return [
    `/api/order/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOrder>>, TError = GetOrderErrorType<unknown>>(params?: GetOrderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({ signal }) => getOrder(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOrder>>>
export type GetOrderQueryError = GetOrderErrorType<unknown>


/**
 * @deprecated
 */

export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = GetOrderErrorType<unknown>>(
 params?: GetOrderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type putOrderIdResponse200 = {
  data: LogosOrderUpdate
  status: 200
}

export type putOrderIdResponseSuccess = (putOrderIdResponse200) & {
  headers: Headers;
};
;

export type putOrderIdResponse = (putOrderIdResponseSuccess)

export const getPutOrderIdUrl = (id: number,) => {


  

  return `/api/order/${id}/`
}

export const putOrderId = async (id: number,
    logosOrderUpdate: NonReadonly<LogosOrderUpdate>, options?: RequestInit): Promise<putOrderIdResponse> => {
  
  return putOrderIdMutator<putOrderIdResponse>(getPutOrderIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      logosOrderUpdate,)
  }
);}
  



export const getPutOrderIdMutationOptions = <TError = PutOrderIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrderId>>, TError,{id: number;data: NonReadonly<LogosOrderUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putOrderId>>, TError,{id: number;data: NonReadonly<LogosOrderUpdate>}, TContext> => {

const mutationKey = ['putOrderId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrderId>>, {id: number;data: NonReadonly<LogosOrderUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putOrderId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrderIdMutationResult = NonNullable<Awaited<ReturnType<typeof putOrderId>>>
    export type PutOrderIdMutationBody = NonReadonly<LogosOrderUpdate>
    export type PutOrderIdMutationError = PutOrderIdErrorType<unknown>

    /**
 * @deprecated
 */
export const usePutOrderId = <TError = PutOrderIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrderId>>, TError,{id: number;data: NonReadonly<LogosOrderUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putOrderId>>,
        TError,
        {id: number;data: NonReadonly<LogosOrderUpdate>},
        TContext
      > => {
      return useMutation(getPutOrderIdMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type patchOrderIdResponse200 = {
  data: LogosOrderUpdate
  status: 200
}

export type patchOrderIdResponseSuccess = (patchOrderIdResponse200) & {
  headers: Headers;
};
;

export type patchOrderIdResponse = (patchOrderIdResponseSuccess)

export const getPatchOrderIdUrl = (id: number,) => {


  

  return `/api/order/${id}/`
}

export const patchOrderId = async (id: number,
    patchedLogosOrderUpdate: NonReadonly<PatchedLogosOrderUpdate>, options?: RequestInit): Promise<patchOrderIdResponse> => {
  
  return patchOrderIdMutator<patchOrderIdResponse>(getPatchOrderIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLogosOrderUpdate,)
  }
);}
  



export const getPatchOrderIdMutationOptions = <TError = PatchOrderIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrderId>>, TError,{id: number;data: NonReadonly<PatchedLogosOrderUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchOrderId>>, TError,{id: number;data: NonReadonly<PatchedLogosOrderUpdate>}, TContext> => {

const mutationKey = ['patchOrderId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOrderId>>, {id: number;data: NonReadonly<PatchedLogosOrderUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchOrderId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchOrderIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchOrderId>>>
    export type PatchOrderIdMutationBody = NonReadonly<PatchedLogosOrderUpdate>
    export type PatchOrderIdMutationError = PatchOrderIdErrorType<unknown>

    /**
 * @deprecated
 */
export const usePatchOrderId = <TError = PatchOrderIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrderId>>, TError,{id: number;data: NonReadonly<PatchedLogosOrderUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchOrderId>>,
        TError,
        {id: number;data: NonReadonly<PatchedLogosOrderUpdate>},
        TContext
      > => {
      return useMutation(getPatchOrderIdMutationOptions(options));
    }
    export type postOrderExportToLogosResponse200 = {
  data: LogosOrdersExportResponse
  status: 200
}

export type postOrderExportToLogosResponseSuccess = (postOrderExportToLogosResponse200) & {
  headers: Headers;
};
;

export type postOrderExportToLogosResponse = (postOrderExportToLogosResponseSuccess)

export const getPostOrderExportToLogosUrl = () => {


  

  return `/api/order/export_to_logos/`
}

export const postOrderExportToLogos = async (logosOrdersBulk: LogosOrdersBulk, options?: RequestInit): Promise<postOrderExportToLogosResponse> => {
  
  return postOrderExportToLogosMutator<postOrderExportToLogosResponse>(getPostOrderExportToLogosUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      logosOrdersBulk,)
  }
);}
  



export const getPostOrderExportToLogosMutationOptions = <TError = PostOrderExportToLogosErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrderExportToLogos>>, TError,{data: LogosOrdersBulk}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postOrderExportToLogos>>, TError,{data: LogosOrdersBulk}, TContext> => {

const mutationKey = ['postOrderExportToLogos'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrderExportToLogos>>, {data: LogosOrdersBulk}> = (props) => {
          const {data} = props ?? {};

          return  postOrderExportToLogos(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostOrderExportToLogosMutationResult = NonNullable<Awaited<ReturnType<typeof postOrderExportToLogos>>>
    export type PostOrderExportToLogosMutationBody = LogosOrdersBulk
    export type PostOrderExportToLogosMutationError = PostOrderExportToLogosErrorType<unknown>

    export const usePostOrderExportToLogos = <TError = PostOrderExportToLogosErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrderExportToLogos>>, TError,{data: LogosOrdersBulk}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postOrderExportToLogos>>,
        TError,
        {data: LogosOrdersBulk},
        TContext
      > => {
      return useMutation(getPostOrderExportToLogosMutationOptions(options));
    }
    export type getOrderStatusesResponse200 = {
  data: LogosOrderStatusList[]
  status: 200
}

export type getOrderStatusesResponseSuccess = (getOrderStatusesResponse200) & {
  headers: Headers;
};
;

export type getOrderStatusesResponse = (getOrderStatusesResponseSuccess)

export const getGetOrderStatusesUrl = (params?: GetOrderStatusesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/order/statuses/?${stringifiedParams}` : `/api/order/statuses/`
}

export const getOrderStatuses = async (params?: GetOrderStatusesParams, options?: RequestInit): Promise<getOrderStatusesResponse> => {
  
  return getOrderStatusesMutator<getOrderStatusesResponse>(getGetOrderStatusesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetOrderStatusesQueryKey = (params?: GetOrderStatusesParams,) => {
    return [
    `/api/order/statuses/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetOrderStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getOrderStatuses>>, TError = GetOrderStatusesErrorType<unknown>>(params?: GetOrderStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStatuses>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderStatusesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderStatuses>>> = ({ signal }) => getOrderStatuses(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderStatuses>>>
export type GetOrderStatusesQueryError = GetOrderStatusesErrorType<unknown>



export function useGetOrderStatuses<TData = Awaited<ReturnType<typeof getOrderStatuses>>, TError = GetOrderStatusesErrorType<unknown>>(
 params?: GetOrderStatusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderStatuses>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderStatusesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type getProductsResponse200 = {
  data: ProductListAPI[]
  status: 200
}

export type getProductsResponseSuccess = (getProductsResponse200) & {
  headers: Headers;
};
;

export type getProductsResponse = (getProductsResponseSuccess)

export const getGetProductsUrl = (params?: GetProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/?${stringifiedParams}` : `/api/products/`
}

export const getProducts = async (params?: GetProductsParams, options?: RequestInit): Promise<getProductsResponse> => {
  
  return getProductsMutator<getProductsResponse>(getGetProductsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsQueryKey = (params?: GetProductsParams,) => {
    return [
    `/api/products/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = GetProductsErrorType<unknown>>(params?: GetProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = GetProductsErrorType<unknown>


/**
 * @deprecated
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = GetProductsErrorType<unknown>>(
 params?: GetProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type postProductsResponse201 = {
  data: ProductCreate
  status: 201
}

export type postProductsResponseSuccess = (postProductsResponse201) & {
  headers: Headers;
};
;

export type postProductsResponse = (postProductsResponseSuccess)

export const getPostProductsUrl = () => {


  

  return `/api/products/`
}

export const postProducts = async (productCreate: ProductCreate, options?: RequestInit): Promise<postProductsResponse> => {
  
  return postProductsMutator<postProductsResponse>(getPostProductsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productCreate,)
  }
);}
  



export const getPostProductsMutationOptions = <TError = PostProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProducts>>, TError,{data: ProductCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProducts>>, TError,{data: ProductCreate}, TContext> => {

const mutationKey = ['postProducts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProducts>>, {data: ProductCreate}> = (props) => {
          const {data} = props ?? {};

          return  postProducts(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductsMutationResult = NonNullable<Awaited<ReturnType<typeof postProducts>>>
    export type PostProductsMutationBody = ProductCreate
    export type PostProductsMutationError = PostProductsErrorType<unknown>

    /**
 * @deprecated
 */
export const usePostProducts = <TError = PostProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProducts>>, TError,{data: ProductCreate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postProducts>>,
        TError,
        {data: ProductCreate},
        TContext
      > => {
      return useMutation(getPostProductsMutationOptions(options));
    }
    /**
 * @deprecated
 */
export type getProductsIdResponse200 = {
  data: Product
  status: 200
}

export type getProductsIdResponseSuccess = (getProductsIdResponse200) & {
  headers: Headers;
};
;

export type getProductsIdResponse = (getProductsIdResponseSuccess)

export const getGetProductsIdUrl = (id: number,) => {


  

  return `/api/products/${id}/`
}

export const getProductsId = async (id: number, options?: RequestInit): Promise<getProductsIdResponse> => {
  
  return getProductsIdMutator<getProductsIdResponse>(getGetProductsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsIdQueryKey = (id: number,) => {
    return [
    `/api/products/${id}/`
    ] as const;
    }

    
export const getGetProductsIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductsId>>, TError = GetProductsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsId>>> = ({ signal }) => getProductsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsId>>>
export type GetProductsIdQueryError = GetProductsIdErrorType<unknown>


/**
 * @deprecated
 */

export function useGetProductsId<TData = Awaited<ReturnType<typeof getProductsId>>, TError = GetProductsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @deprecated
 */
export type patchProductsIdResponse200 = {
  data: ProductUpdate
  status: 200
}

export type patchProductsIdResponseSuccess = (patchProductsIdResponse200) & {
  headers: Headers;
};
;

export type patchProductsIdResponse = (patchProductsIdResponseSuccess)

export const getPatchProductsIdUrl = (id: number,) => {


  

  return `/api/products/${id}/`
}

export const patchProductsId = async (id: number,
    patchedProductUpdate: NonReadonly<PatchedProductUpdate>, options?: RequestInit): Promise<patchProductsIdResponse> => {
  
  return patchProductsIdMutator<patchProductsIdResponse>(getPatchProductsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedProductUpdate,)
  }
);}
  



export const getPatchProductsIdMutationOptions = <TError = PatchProductsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductsId>>, TError,{id: number;data: NonReadonly<PatchedProductUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductsId>>, TError,{id: number;data: NonReadonly<PatchedProductUpdate>}, TContext> => {

const mutationKey = ['patchProductsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductsId>>, {id: number;data: NonReadonly<PatchedProductUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductsId>>>
    export type PatchProductsIdMutationBody = NonReadonly<PatchedProductUpdate>
    export type PatchProductsIdMutationError = PatchProductsIdErrorType<unknown>

    /**
 * @deprecated
 */
export const usePatchProductsId = <TError = PatchProductsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductsId>>, TError,{id: number;data: NonReadonly<PatchedProductUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchProductsId>>,
        TError,
        {id: number;data: NonReadonly<PatchedProductUpdate>},
        TContext
      > => {
      return useMutation(getPatchProductsIdMutationOptions(options));
    }
    export type getProductsIdAvailableDeliveryPointsResponse200 = {
  data: DeliveryPoint[]
  status: 200
}

export type getProductsIdAvailableDeliveryPointsResponseSuccess = (getProductsIdAvailableDeliveryPointsResponse200) & {
  headers: Headers;
};
;

export type getProductsIdAvailableDeliveryPointsResponse = (getProductsIdAvailableDeliveryPointsResponseSuccess)

export const getGetProductsIdAvailableDeliveryPointsUrl = (id: number,
    params?: GetProductsIdAvailableDeliveryPointsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/${id}/available-delivery-points/?${stringifiedParams}` : `/api/products/${id}/available-delivery-points/`
}

export const getProductsIdAvailableDeliveryPoints = async (id: number,
    params?: GetProductsIdAvailableDeliveryPointsParams, options?: RequestInit): Promise<getProductsIdAvailableDeliveryPointsResponse> => {
  
  return getProductsIdAvailableDeliveryPointsMutator<getProductsIdAvailableDeliveryPointsResponse>(getGetProductsIdAvailableDeliveryPointsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsIdAvailableDeliveryPointsQueryKey = (id: number,
    params?: GetProductsIdAvailableDeliveryPointsParams,) => {
    return [
    `/api/products/${id}/available-delivery-points/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsIdAvailableDeliveryPointsQueryOptions = <TData = Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>, TError = GetProductsIdAvailableDeliveryPointsErrorType<unknown>>(id: number,
    params?: GetProductsIdAvailableDeliveryPointsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsIdAvailableDeliveryPointsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>> = ({ signal }) => getProductsIdAvailableDeliveryPoints(id,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsIdAvailableDeliveryPointsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>>
export type GetProductsIdAvailableDeliveryPointsQueryError = GetProductsIdAvailableDeliveryPointsErrorType<unknown>



export function useGetProductsIdAvailableDeliveryPoints<TData = Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>, TError = GetProductsIdAvailableDeliveryPointsErrorType<unknown>>(
 id: number,
    params?: GetProductsIdAvailableDeliveryPointsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdAvailableDeliveryPoints>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsIdAvailableDeliveryPointsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getProductsIdOffersResponse200 = {
  data: OfferForProductList[]
  status: 200
}

export type getProductsIdOffersResponseSuccess = (getProductsIdOffersResponse200) & {
  headers: Headers;
};
;

export type getProductsIdOffersResponse = (getProductsIdOffersResponseSuccess)

export const getGetProductsIdOffersUrl = (id: number,
    params?: GetProductsIdOffersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/${id}/offers/?${stringifiedParams}` : `/api/products/${id}/offers/`
}

export const getProductsIdOffers = async (id: number,
    params?: GetProductsIdOffersParams, options?: RequestInit): Promise<getProductsIdOffersResponse> => {
  
  return getProductsIdOffersMutator<getProductsIdOffersResponse>(getGetProductsIdOffersUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsIdOffersQueryKey = (id: number,
    params?: GetProductsIdOffersParams,) => {
    return [
    `/api/products/${id}/offers/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsIdOffersQueryOptions = <TData = Awaited<ReturnType<typeof getProductsIdOffers>>, TError = GetProductsIdOffersErrorType<unknown>>(id: number,
    params?: GetProductsIdOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdOffers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsIdOffersQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsIdOffers>>> = ({ signal }) => getProductsIdOffers(id,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsIdOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsIdOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsIdOffers>>>
export type GetProductsIdOffersQueryError = GetProductsIdOffersErrorType<unknown>



export function useGetProductsIdOffers<TData = Awaited<ReturnType<typeof getProductsIdOffers>>, TError = GetProductsIdOffersErrorType<unknown>>(
 id: number,
    params?: GetProductsIdOffersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdOffers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsIdOffersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getProductsIdVolumesResponse200 = {
  data: ProductVolumes[]
  status: 200
}

export type getProductsIdVolumesResponseSuccess = (getProductsIdVolumesResponse200) & {
  headers: Headers;
};
;

export type getProductsIdVolumesResponse = (getProductsIdVolumesResponseSuccess)

export const getGetProductsIdVolumesUrl = (id: number,
    params?: GetProductsIdVolumesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/${id}/volumes/?${stringifiedParams}` : `/api/products/${id}/volumes/`
}

export const getProductsIdVolumes = async (id: number,
    params?: GetProductsIdVolumesParams, options?: RequestInit): Promise<getProductsIdVolumesResponse> => {
  
  return getProductsIdVolumesMutator<getProductsIdVolumesResponse>(getGetProductsIdVolumesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsIdVolumesQueryKey = (id: number,
    params?: GetProductsIdVolumesParams,) => {
    return [
    `/api/products/${id}/volumes/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsIdVolumesQueryOptions = <TData = Awaited<ReturnType<typeof getProductsIdVolumes>>, TError = GetProductsIdVolumesErrorType<unknown>>(id: number,
    params?: GetProductsIdVolumesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdVolumes>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsIdVolumesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsIdVolumes>>> = ({ signal }) => getProductsIdVolumes(id,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsIdVolumes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsIdVolumesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsIdVolumes>>>
export type GetProductsIdVolumesQueryError = GetProductsIdVolumesErrorType<unknown>



export function useGetProductsIdVolumes<TData = Awaited<ReturnType<typeof getProductsIdVolumes>>, TError = GetProductsIdVolumesErrorType<unknown>>(
 id: number,
    params?: GetProductsIdVolumesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsIdVolumes>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsIdVolumesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Base mixin for functionality related to importing and exporting via the Admin
interface.
 * @deprecated
 */
export type getProductsCustomDutiesResponse200 = {
  data: PaginatedProductCustomDutyList
  status: 200
}

export type getProductsCustomDutiesResponseSuccess = (getProductsCustomDutiesResponse200) & {
  headers: Headers;
};
;

export type getProductsCustomDutiesResponse = (getProductsCustomDutiesResponseSuccess)

export const getGetProductsCustomDutiesUrl = (params?: GetProductsCustomDutiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/custom-duties/?${stringifiedParams}` : `/api/products/custom-duties/`
}

export const getProductsCustomDuties = async (params?: GetProductsCustomDutiesParams, options?: RequestInit): Promise<getProductsCustomDutiesResponse> => {
  
  return getProductsCustomDutiesMutator<getProductsCustomDutiesResponse>(getGetProductsCustomDutiesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsCustomDutiesQueryKey = (params?: GetProductsCustomDutiesParams,) => {
    return [
    `/api/products/custom-duties/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsCustomDutiesQueryOptions = <TData = Awaited<ReturnType<typeof getProductsCustomDuties>>, TError = GetProductsCustomDutiesErrorType<unknown>>(params?: GetProductsCustomDutiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDuties>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsCustomDutiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsCustomDuties>>> = ({ signal }) => getProductsCustomDuties(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDuties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsCustomDutiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsCustomDuties>>>
export type GetProductsCustomDutiesQueryError = GetProductsCustomDutiesErrorType<unknown>


/**
 * @deprecated
 */

export function useGetProductsCustomDuties<TData = Awaited<ReturnType<typeof getProductsCustomDuties>>, TError = GetProductsCustomDutiesErrorType<unknown>>(
 params?: GetProductsCustomDutiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDuties>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsCustomDutiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Product CustomDuty download or upload export file
 * @deprecated
 */
export type getProductsCustomDutiesExportImportResponse200ApplicationJson = {
  data: Blob
  status: 200
}

export type getProductsCustomDutiesExportImportResponse200TextCsv = {
  data: Blob
  status: 200
}

export type getProductsCustomDutiesExportImportResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = {
  data: Blob
  status: 200
}

export type getProductsCustomDutiesExportImportResponse200TextTabSeparatedValues = {
  data: Blob
  status: 200
}

export type getProductsCustomDutiesExportImportResponse200TextYaml = {
  data: Blob
  status: 200
}

export type getProductsCustomDutiesExportImportResponse404 = {
  data: ErrorDetail
  status: 404
}

export type getProductsCustomDutiesExportImportResponseSuccess = (getProductsCustomDutiesExportImportResponse200ApplicationJson | getProductsCustomDutiesExportImportResponse200TextCsv | getProductsCustomDutiesExportImportResponse200ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet | getProductsCustomDutiesExportImportResponse200TextTabSeparatedValues | getProductsCustomDutiesExportImportResponse200TextYaml) & {
  headers: Headers;
};
export type getProductsCustomDutiesExportImportResponseError = (getProductsCustomDutiesExportImportResponse404) & {
  headers: Headers;
};

export type getProductsCustomDutiesExportImportResponse = (getProductsCustomDutiesExportImportResponseSuccess | getProductsCustomDutiesExportImportResponseError)

export const getGetProductsCustomDutiesExportImportUrl = (params?: GetProductsCustomDutiesExportImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/custom-duties/export-import/?${stringifiedParams}` : `/api/products/custom-duties/export-import/`
}

export const getProductsCustomDutiesExportImport = async (params?: GetProductsCustomDutiesExportImportParams, options?: RequestInit): Promise<getProductsCustomDutiesExportImportResponse> => {
  
  return getProductsCustomDutiesExportImportMutator<getProductsCustomDutiesExportImportResponse>(getGetProductsCustomDutiesExportImportUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsCustomDutiesExportImportQueryKey = (params?: GetProductsCustomDutiesExportImportParams,) => {
    return [
    `/api/products/custom-duties/export-import/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsCustomDutiesExportImportQueryOptions = <TData = Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>, TError = GetProductsCustomDutiesExportImportErrorType<ErrorDetail>>(params?: GetProductsCustomDutiesExportImportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsCustomDutiesExportImportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>> = ({ signal }) => getProductsCustomDutiesExportImport(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsCustomDutiesExportImportQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>>
export type GetProductsCustomDutiesExportImportQueryError = GetProductsCustomDutiesExportImportErrorType<ErrorDetail>


/**
 * @deprecated
 */

export function useGetProductsCustomDutiesExportImport<TData = Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>, TError = GetProductsCustomDutiesExportImportErrorType<ErrorDetail>>(
 params?: GetProductsCustomDutiesExportImportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsCustomDutiesExportImport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsCustomDutiesExportImportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Product CustomDuty download or upload export file
 * @deprecated
 */
export type postProductsCustomDutiesExportImportResponse204 = {
  data: void
  status: 204
}

export type postProductsCustomDutiesExportImportResponse400 = {
  data: ErrorDetail
  status: 400
}

export type postProductsCustomDutiesExportImportResponseSuccess = (postProductsCustomDutiesExportImportResponse204) & {
  headers: Headers;
};
export type postProductsCustomDutiesExportImportResponseError = (postProductsCustomDutiesExportImportResponse400) & {
  headers: Headers;
};

export type postProductsCustomDutiesExportImportResponse = (postProductsCustomDutiesExportImportResponseSuccess | postProductsCustomDutiesExportImportResponseError)

export const getPostProductsCustomDutiesExportImportUrl = (params?: PostProductsCustomDutiesExportImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/custom-duties/export-import/?${stringifiedParams}` : `/api/products/custom-duties/export-import/`
}

export const postProductsCustomDutiesExportImport = async (postProductsCustomDutiesExportImportBody: Blob,
    params?: PostProductsCustomDutiesExportImportParams, options?: RequestInit): Promise<postProductsCustomDutiesExportImportResponse> => {
  
  return postProductsCustomDutiesExportImportMutator<postProductsCustomDutiesExportImportResponse>(getPostProductsCustomDutiesExportImportUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': '*/*', ...options?.headers },
    body: JSON.stringify(
      postProductsCustomDutiesExportImportBody,)
  }
);}
  



export const getPostProductsCustomDutiesExportImportMutationOptions = <TError = PostProductsCustomDutiesExportImportErrorType<ErrorDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>, TError,{data: Blob;params?: PostProductsCustomDutiesExportImportParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>, TError,{data: Blob;params?: PostProductsCustomDutiesExportImportParams}, TContext> => {

const mutationKey = ['postProductsCustomDutiesExportImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>, {data: Blob;params?: PostProductsCustomDutiesExportImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postProductsCustomDutiesExportImport(data,params,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductsCustomDutiesExportImportMutationResult = NonNullable<Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>>
    export type PostProductsCustomDutiesExportImportMutationBody = Blob
    export type PostProductsCustomDutiesExportImportMutationError = PostProductsCustomDutiesExportImportErrorType<ErrorDetail>

    /**
 * @deprecated
 */
export const usePostProductsCustomDutiesExportImport = <TError = PostProductsCustomDutiesExportImportErrorType<ErrorDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>, TError,{data: Blob;params?: PostProductsCustomDutiesExportImportParams}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postProductsCustomDutiesExportImport>>,
        TError,
        {data: Blob;params?: PostProductsCustomDutiesExportImportParams},
        TContext
      > => {
      return useMutation(getPostProductsCustomDutiesExportImportMutationOptions(options));
    }
    export type getProductsForExtCalcResponse200 = {
  data: ProductDataForExternalCalculator
  status: 200
}

export type getProductsForExtCalcResponseSuccess = (getProductsForExtCalcResponse200) & {
  headers: Headers;
};
;

export type getProductsForExtCalcResponse = (getProductsForExtCalcResponseSuccess)

export const getGetProductsForExtCalcUrl = (params: GetProductsForExtCalcParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/for-ext-calc/?${stringifiedParams}` : `/api/products/for-ext-calc/`
}

export const getProductsForExtCalc = async (params: GetProductsForExtCalcParams, options?: RequestInit): Promise<getProductsForExtCalcResponse> => {
  
  return getProductsForExtCalcMutator<getProductsForExtCalcResponse>(getGetProductsForExtCalcUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsForExtCalcQueryKey = (params?: GetProductsForExtCalcParams,) => {
    return [
    `/api/products/for-ext-calc/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsForExtCalcQueryOptions = <TData = Awaited<ReturnType<typeof getProductsForExtCalc>>, TError = GetProductsForExtCalcErrorType<unknown>>(params: GetProductsForExtCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsForExtCalc>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsForExtCalcQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsForExtCalc>>> = ({ signal }) => getProductsForExtCalc(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsForExtCalc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsForExtCalcQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsForExtCalc>>>
export type GetProductsForExtCalcQueryError = GetProductsForExtCalcErrorType<unknown>



export function useGetProductsForExtCalc<TData = Awaited<ReturnType<typeof getProductsForExtCalc>>, TError = GetProductsForExtCalcErrorType<unknown>>(
 params: GetProductsForExtCalcParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsForExtCalc>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsForExtCalcQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getProductsGroupsResponse200 = {
  data: ProductsGroup[]
  status: 200
}

export type getProductsGroupsResponseSuccess = (getProductsGroupsResponse200) & {
  headers: Headers;
};
;

export type getProductsGroupsResponse = (getProductsGroupsResponseSuccess)

export const getGetProductsGroupsUrl = (params?: GetProductsGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products/groups/?${stringifiedParams}` : `/api/products/groups/`
}

export const getProductsGroups = async (params?: GetProductsGroupsParams, options?: RequestInit): Promise<getProductsGroupsResponse> => {
  
  return getProductsGroupsMutator<getProductsGroupsResponse>(getGetProductsGroupsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProductsGroupsQueryKey = (params?: GetProductsGroupsParams,) => {
    return [
    `/api/products/groups/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProductsGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getProductsGroups>>, TError = GetProductsGroupsErrorType<unknown>>(params?: GetProductsGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsGroups>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductsGroups>>> = ({ signal }) => getProductsGroups(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductsGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductsGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductsGroups>>>
export type GetProductsGroupsQueryError = GetProductsGroupsErrorType<unknown>



export function useGetProductsGroups<TData = Awaited<ReturnType<typeof getProductsGroups>>, TError = GetProductsGroupsErrorType<unknown>>(
 params?: GetProductsGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductsGroups>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductsGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type patchProductsManageResponse200 = {
  data: ManageActionResult
  status: 200
}

export type patchProductsManageResponseSuccess = (patchProductsManageResponse200) & {
  headers: Headers;
};
;

export type patchProductsManageResponse = (patchProductsManageResponseSuccess)

export const getPatchProductsManageUrl = () => {


  

  return `/api/products/manage/`
}

export const patchProductsManage = async (patchedProductManage: PatchedProductManage, options?: RequestInit): Promise<patchProductsManageResponse> => {
  
  return patchProductsManageMutator<patchProductsManageResponse>(getPatchProductsManageUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedProductManage,)
  }
);}
  



export const getPatchProductsManageMutationOptions = <TError = PatchProductsManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductsManage>>, TError,{data: PatchedProductManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductsManage>>, TError,{data: PatchedProductManage}, TContext> => {

const mutationKey = ['patchProductsManage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductsManage>>, {data: PatchedProductManage}> = (props) => {
          const {data} = props ?? {};

          return  patchProductsManage(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductsManageMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductsManage>>>
    export type PatchProductsManageMutationBody = PatchedProductManage
    export type PatchProductsManageMutationError = PatchProductsManageErrorType<unknown>

    export const usePatchProductsManage = <TError = PatchProductsManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductsManage>>, TError,{data: PatchedProductManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchProductsManage>>,
        TError,
        {data: PatchedProductManage},
        TContext
      > => {
      return useMutation(getPatchProductsManageMutationOptions(options));
    }
    /**
 * @summary Multi-serializer list handler
 */
export type getProgramsResponse200 = {
  data: PaginatedSupplyProgramListMetaList
  status: 200
}

export type getProgramsResponseSuccess = (getProgramsResponse200) & {
  headers: Headers;
};
;

export type getProgramsResponse = (getProgramsResponseSuccess)

export const getGetProgramsUrl = (params?: GetProgramsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/programs/?${stringifiedParams}` : `/api/programs/`
}

export const getPrograms = async (params?: GetProgramsParams, options?: RequestInit): Promise<getProgramsResponse> => {
  
  return getProgramsMutator<getProgramsResponse>(getGetProgramsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProgramsQueryKey = (params?: GetProgramsParams,) => {
    return [
    `/api/programs/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProgramsQueryOptions = <TData = Awaited<ReturnType<typeof getPrograms>>, TError = GetProgramsErrorType<unknown>>(params?: GetProgramsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPrograms>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgramsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrograms>>> = ({ signal }) => getPrograms(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrograms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProgramsQueryResult = NonNullable<Awaited<ReturnType<typeof getPrograms>>>
export type GetProgramsQueryError = GetProgramsErrorType<unknown>


/**
 * @summary Multi-serializer list handler
 */

export function useGetPrograms<TData = Awaited<ReturnType<typeof getPrograms>>, TError = GetProgramsErrorType<unknown>>(
 params?: GetProgramsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPrograms>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProgramsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postProgramsResponse201 = {
  data: SupplyProgramCreateUpdate
  status: 201
}

export type postProgramsResponseSuccess = (postProgramsResponse201) & {
  headers: Headers;
};
;

export type postProgramsResponse = (postProgramsResponseSuccess)

export const getPostProgramsUrl = () => {


  

  return `/api/programs/`
}

export const postPrograms = async (supplyProgramCreateUpdate: NonReadonly<SupplyProgramCreateUpdate>, options?: RequestInit): Promise<postProgramsResponse> => {
  
  return postProgramsMutator<postProgramsResponse>(getPostProgramsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplyProgramCreateUpdate,)
  }
);}
  



export const getPostProgramsMutationOptions = <TError = PostProgramsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPrograms>>, TError,{data: NonReadonly<SupplyProgramCreateUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPrograms>>, TError,{data: NonReadonly<SupplyProgramCreateUpdate>}, TContext> => {

const mutationKey = ['postPrograms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPrograms>>, {data: NonReadonly<SupplyProgramCreateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  postPrograms(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProgramsMutationResult = NonNullable<Awaited<ReturnType<typeof postPrograms>>>
    export type PostProgramsMutationBody = NonReadonly<SupplyProgramCreateUpdate>
    export type PostProgramsMutationError = PostProgramsErrorType<unknown>

    export const usePostPrograms = <TError = PostProgramsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPrograms>>, TError,{data: NonReadonly<SupplyProgramCreateUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postPrograms>>,
        TError,
        {data: NonReadonly<SupplyProgramCreateUpdate>},
        TContext
      > => {
      return useMutation(getPostProgramsMutationOptions(options));
    }
    export type getProgramsIdResponse200 = {
  data: SupplyProgramDetailMeta
  status: 200
}

export type getProgramsIdResponseSuccess = (getProgramsIdResponse200) & {
  headers: Headers;
};
;

export type getProgramsIdResponse = (getProgramsIdResponseSuccess)

export const getGetProgramsIdUrl = (id: number,) => {


  

  return `/api/programs/${id}/`
}

export const getProgramsId = async (id: number, options?: RequestInit): Promise<getProgramsIdResponse> => {
  
  return getProgramsIdMutator<getProgramsIdResponse>(getGetProgramsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProgramsIdQueryKey = (id: number,) => {
    return [
    `/api/programs/${id}/`
    ] as const;
    }

    
export const getGetProgramsIdQueryOptions = <TData = Awaited<ReturnType<typeof getProgramsId>>, TError = GetProgramsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgramsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgramsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramsId>>> = ({ signal }) => getProgramsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProgramsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProgramsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProgramsId>>>
export type GetProgramsIdQueryError = GetProgramsIdErrorType<unknown>



export function useGetProgramsId<TData = Awaited<ReturnType<typeof getProgramsId>>, TError = GetProgramsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgramsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProgramsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putProgramsIdResponse200 = {
  data: SupplyProgramCreateUpdate
  status: 200
}

export type putProgramsIdResponseSuccess = (putProgramsIdResponse200) & {
  headers: Headers;
};
;

export type putProgramsIdResponse = (putProgramsIdResponseSuccess)

export const getPutProgramsIdUrl = (id: number,) => {


  

  return `/api/programs/${id}/`
}

export const putProgramsId = async (id: number,
    supplyProgramCreateUpdate: NonReadonly<SupplyProgramCreateUpdate>, options?: RequestInit): Promise<putProgramsIdResponse> => {
  
  return putProgramsIdMutator<putProgramsIdResponse>(getPutProgramsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplyProgramCreateUpdate,)
  }
);}
  



export const getPutProgramsIdMutationOptions = <TError = PutProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProgramsId>>, TError,{id: number;data: NonReadonly<SupplyProgramCreateUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProgramsId>>, TError,{id: number;data: NonReadonly<SupplyProgramCreateUpdate>}, TContext> => {

const mutationKey = ['putProgramsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProgramsId>>, {id: number;data: NonReadonly<SupplyProgramCreateUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putProgramsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutProgramsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProgramsId>>>
    export type PutProgramsIdMutationBody = NonReadonly<SupplyProgramCreateUpdate>
    export type PutProgramsIdMutationError = PutProgramsIdErrorType<unknown>

    export const usePutProgramsId = <TError = PutProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProgramsId>>, TError,{id: number;data: NonReadonly<SupplyProgramCreateUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putProgramsId>>,
        TError,
        {id: number;data: NonReadonly<SupplyProgramCreateUpdate>},
        TContext
      > => {
      return useMutation(getPutProgramsIdMutationOptions(options));
    }
    export type patchProgramsIdResponse200 = {
  data: SupplyProgramTableUpdate
  status: 200
}

export type patchProgramsIdResponseSuccess = (patchProgramsIdResponse200) & {
  headers: Headers;
};
;

export type patchProgramsIdResponse = (patchProgramsIdResponseSuccess)

export const getPatchProgramsIdUrl = (id: number,) => {


  

  return `/api/programs/${id}/`
}

export const patchProgramsId = async (id: number,
    patchedSupplyProgramTableUpdate: PatchedSupplyProgramTableUpdate, options?: RequestInit): Promise<patchProgramsIdResponse> => {
  
  return patchProgramsIdMutator<patchProgramsIdResponse>(getPatchProgramsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSupplyProgramTableUpdate,)
  }
);}
  



export const getPatchProgramsIdMutationOptions = <TError = PatchProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProgramsId>>, TError,{id: number;data: PatchedSupplyProgramTableUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProgramsId>>, TError,{id: number;data: PatchedSupplyProgramTableUpdate}, TContext> => {

const mutationKey = ['patchProgramsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProgramsId>>, {id: number;data: PatchedSupplyProgramTableUpdate}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProgramsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProgramsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProgramsId>>>
    export type PatchProgramsIdMutationBody = PatchedSupplyProgramTableUpdate
    export type PatchProgramsIdMutationError = PatchProgramsIdErrorType<unknown>

    export const usePatchProgramsId = <TError = PatchProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProgramsId>>, TError,{id: number;data: PatchedSupplyProgramTableUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchProgramsId>>,
        TError,
        {id: number;data: PatchedSupplyProgramTableUpdate},
        TContext
      > => {
      return useMutation(getPatchProgramsIdMutationOptions(options));
    }
    /**
 * Формирование и отправка отчёта по программе.
 */
export type postProgramsIdExportReportResponse200 = {
  data: Result
  status: 200
}

export type postProgramsIdExportReportResponseSuccess = (postProgramsIdExportReportResponse200) & {
  headers: Headers;
};
;

export type postProgramsIdExportReportResponse = (postProgramsIdExportReportResponseSuccess)

export const getPostProgramsIdExportReportUrl = (id: number,) => {


  

  return `/api/programs/${id}/export-report/`
}

export const postProgramsIdExportReport = async (id: number,
    supplyProgramDetail: NonReadonly<SupplyProgramDetail>, options?: RequestInit): Promise<postProgramsIdExportReportResponse> => {
  
  return postProgramsIdExportReportMutator<postProgramsIdExportReportResponse>(getPostProgramsIdExportReportUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplyProgramDetail,)
  }
);}
  



export const getPostProgramsIdExportReportMutationOptions = <TError = PostProgramsIdExportReportErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdExportReport>>, TError,{id: number;data: NonReadonly<SupplyProgramDetail>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdExportReport>>, TError,{id: number;data: NonReadonly<SupplyProgramDetail>}, TContext> => {

const mutationKey = ['postProgramsIdExportReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProgramsIdExportReport>>, {id: number;data: NonReadonly<SupplyProgramDetail>}> = (props) => {
          const {id,data} = props ?? {};

          return  postProgramsIdExportReport(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProgramsIdExportReportMutationResult = NonNullable<Awaited<ReturnType<typeof postProgramsIdExportReport>>>
    export type PostProgramsIdExportReportMutationBody = NonReadonly<SupplyProgramDetail>
    export type PostProgramsIdExportReportMutationError = PostProgramsIdExportReportErrorType<unknown>

    export const usePostProgramsIdExportReport = <TError = PostProgramsIdExportReportErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdExportReport>>, TError,{id: number;data: NonReadonly<SupplyProgramDetail>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postProgramsIdExportReport>>,
        TError,
        {id: number;data: NonReadonly<SupplyProgramDetail>},
        TContext
      > => {
      return useMutation(getPostProgramsIdExportReportMutationOptions(options));
    }
    /**
 * Управление программой - удаление, запуск, остановка.
 */
export type postProgramsIdManageResponse200 = {
  data: Result
  status: 200
}

export type postProgramsIdManageResponseSuccess = (postProgramsIdManageResponse200) & {
  headers: Headers;
};
;

export type postProgramsIdManageResponse = (postProgramsIdManageResponseSuccess)

export const getPostProgramsIdManageUrl = (id: number,) => {


  

  return `/api/programs/${id}/manage/`
}

export const postProgramsIdManage = async (id: number,
    supplyProgramManage: SupplyProgramManage, options?: RequestInit): Promise<postProgramsIdManageResponse> => {
  
  return postProgramsIdManageMutator<postProgramsIdManageResponse>(getPostProgramsIdManageUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplyProgramManage,)
  }
);}
  



export const getPostProgramsIdManageMutationOptions = <TError = PostProgramsIdManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdManage>>, TError,{id: number;data: SupplyProgramManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdManage>>, TError,{id: number;data: SupplyProgramManage}, TContext> => {

const mutationKey = ['postProgramsIdManage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProgramsIdManage>>, {id: number;data: SupplyProgramManage}> = (props) => {
          const {id,data} = props ?? {};

          return  postProgramsIdManage(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProgramsIdManageMutationResult = NonNullable<Awaited<ReturnType<typeof postProgramsIdManage>>>
    export type PostProgramsIdManageMutationBody = SupplyProgramManage
    export type PostProgramsIdManageMutationError = PostProgramsIdManageErrorType<unknown>

    export const usePostProgramsIdManage = <TError = PostProgramsIdManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsIdManage>>, TError,{id: number;data: SupplyProgramManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postProgramsIdManage>>,
        TError,
        {id: number;data: SupplyProgramManage},
        TContext
      > => {
      return useMutation(getPostProgramsIdManageMutationOptions(options));
    }
    export type getProgramsFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getProgramsFiltersFilterNameResponseSuccess = (getProgramsFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getProgramsFiltersFilterNameResponse = (getProgramsFiltersFilterNameResponseSuccess)

export const getGetProgramsFiltersFilterNameUrl = (filterName: string,
    params?: GetProgramsFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/programs/filters/${filterName}/?${stringifiedParams}` : `/api/programs/filters/${filterName}/`
}

export const getProgramsFiltersFilterName = async (filterName: string,
    params?: GetProgramsFiltersFilterNameParams, options?: RequestInit): Promise<getProgramsFiltersFilterNameResponse> => {
  
  return getProgramsFiltersFilterNameMutator<getProgramsFiltersFilterNameResponse>(getGetProgramsFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetProgramsFiltersFilterNameQueryKey = (filterName: string,
    params?: GetProgramsFiltersFilterNameParams,) => {
    return [
    `/api/programs/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetProgramsFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getProgramsFiltersFilterName>>, TError = GetProgramsFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetProgramsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgramsFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgramsFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgramsFiltersFilterName>>> = ({ signal }) => getProgramsFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProgramsFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProgramsFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getProgramsFiltersFilterName>>>
export type GetProgramsFiltersFilterNameQueryError = GetProgramsFiltersFilterNameErrorType<unknown>



export function useGetProgramsFiltersFilterName<TData = Awaited<ReturnType<typeof getProgramsFiltersFilterName>>, TError = GetProgramsFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetProgramsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProgramsFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProgramsFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Согласование программ со стороны КМ ТС.

Массовое действие, запрос принимает массив идентификаторов.
 */
export type postProgramsTsApproveResponse200 = {
  data: Result
  status: 200
}

export type postProgramsTsApproveResponseSuccess = (postProgramsTsApproveResponse200) & {
  headers: Headers;
};
;

export type postProgramsTsApproveResponse = (postProgramsTsApproveResponseSuccess)

export const getPostProgramsTsApproveUrl = () => {


  

  return `/api/programs/ts-approve/`
}

export const postProgramsTsApprove = async (supplyProgramTsApprove: SupplyProgramTsApprove, options?: RequestInit): Promise<postProgramsTsApproveResponse> => {
  
  return postProgramsTsApproveMutator<postProgramsTsApproveResponse>(getPostProgramsTsApproveUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplyProgramTsApprove,)
  }
);}
  



export const getPostProgramsTsApproveMutationOptions = <TError = PostProgramsTsApproveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsTsApprove>>, TError,{data: SupplyProgramTsApprove}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProgramsTsApprove>>, TError,{data: SupplyProgramTsApprove}, TContext> => {

const mutationKey = ['postProgramsTsApprove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProgramsTsApprove>>, {data: SupplyProgramTsApprove}> = (props) => {
          const {data} = props ?? {};

          return  postProgramsTsApprove(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostProgramsTsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postProgramsTsApprove>>>
    export type PostProgramsTsApproveMutationBody = SupplyProgramTsApprove
    export type PostProgramsTsApproveMutationError = PostProgramsTsApproveErrorType<unknown>

    export const usePostProgramsTsApprove = <TError = PostProgramsTsApproveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProgramsTsApprove>>, TError,{data: SupplyProgramTsApprove}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postProgramsTsApprove>>,
        TError,
        {data: SupplyProgramTsApprove},
        TContext
      > => {
      return useMutation(getPostProgramsTsApproveMutationOptions(options));
    }
    export type putQaAuctionStagesIdResponse200 = {
  data: TestingAuction
  status: 200
}

export type putQaAuctionStagesIdResponseSuccess = (putQaAuctionStagesIdResponse200) & {
  headers: Headers;
};
;

export type putQaAuctionStagesIdResponse = (putQaAuctionStagesIdResponseSuccess)

export const getPutQaAuctionStagesIdUrl = (id: number,) => {


  

  return `/api/qa/auction-stages/${id}/`
}

export const putQaAuctionStagesId = async (id: number,
    testingAuction: NonReadonly<TestingAuction>, options?: RequestInit): Promise<putQaAuctionStagesIdResponse> => {
  
  return putQaAuctionStagesIdMutator<putQaAuctionStagesIdResponse>(getPutQaAuctionStagesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingAuction,)
  }
);}
  



export const getPutQaAuctionStagesIdMutationOptions = <TError = PutQaAuctionStagesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<TestingAuction>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<TestingAuction>}, TContext> => {

const mutationKey = ['putQaAuctionStagesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQaAuctionStagesId>>, {id: number;data: NonReadonly<TestingAuction>}> = (props) => {
          const {id,data} = props ?? {};

          return  putQaAuctionStagesId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutQaAuctionStagesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putQaAuctionStagesId>>>
    export type PutQaAuctionStagesIdMutationBody = NonReadonly<TestingAuction>
    export type PutQaAuctionStagesIdMutationError = PutQaAuctionStagesIdErrorType<unknown>

    export const usePutQaAuctionStagesId = <TError = PutQaAuctionStagesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<TestingAuction>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putQaAuctionStagesId>>,
        TError,
        {id: number;data: NonReadonly<TestingAuction>},
        TContext
      > => {
      return useMutation(getPutQaAuctionStagesIdMutationOptions(options));
    }
    export type patchQaAuctionStagesIdResponse200 = {
  data: TestingAuction
  status: 200
}

export type patchQaAuctionStagesIdResponseSuccess = (patchQaAuctionStagesIdResponse200) & {
  headers: Headers;
};
;

export type patchQaAuctionStagesIdResponse = (patchQaAuctionStagesIdResponseSuccess)

export const getPatchQaAuctionStagesIdUrl = (id: number,) => {


  

  return `/api/qa/auction-stages/${id}/`
}

export const patchQaAuctionStagesId = async (id: number,
    patchedTestingAuction: NonReadonly<PatchedTestingAuction>, options?: RequestInit): Promise<patchQaAuctionStagesIdResponse> => {
  
  return patchQaAuctionStagesIdMutator<patchQaAuctionStagesIdResponse>(getPatchQaAuctionStagesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTestingAuction,)
  }
);}
  



export const getPatchQaAuctionStagesIdMutationOptions = <TError = PatchQaAuctionStagesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<PatchedTestingAuction>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<PatchedTestingAuction>}, TContext> => {

const mutationKey = ['patchQaAuctionStagesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaAuctionStagesId>>, {id: number;data: NonReadonly<PatchedTestingAuction>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchQaAuctionStagesId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaAuctionStagesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaAuctionStagesId>>>
    export type PatchQaAuctionStagesIdMutationBody = NonReadonly<PatchedTestingAuction>
    export type PatchQaAuctionStagesIdMutationError = PatchQaAuctionStagesIdErrorType<unknown>

    export const usePatchQaAuctionStagesId = <TError = PatchQaAuctionStagesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaAuctionStagesId>>, TError,{id: number;data: NonReadonly<PatchedTestingAuction>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaAuctionStagesId>>,
        TError,
        {id: number;data: NonReadonly<PatchedTestingAuction>},
        TContext
      > => {
      return useMutation(getPatchQaAuctionStagesIdMutationOptions(options));
    }
    export type deleteQaBananasIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaBananasIdResponseSuccess = (deleteQaBananasIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaBananasIdResponse = (deleteQaBananasIdResponseSuccess)

export const getDeleteQaBananasIdUrl = (id: number,) => {


  

  return `/api/qa/bananas/${id}/`
}

export const deleteQaBananasId = async (id: number, options?: RequestInit): Promise<deleteQaBananasIdResponse> => {
  
  return deleteQaBananasIdMutator<deleteQaBananasIdResponse>(getDeleteQaBananasIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaBananasIdMutationOptions = <TError = DeleteQaBananasIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaBananasId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaBananasId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaBananasId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaBananasId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaBananasId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaBananasIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaBananasId>>>
    
    export type DeleteQaBananasIdMutationError = DeleteQaBananasIdErrorType<unknown>

    export const useDeleteQaBananasId = <TError = DeleteQaBananasIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaBananasId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaBananasId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaBananasIdMutationOptions(options));
    }
    export type patchQaCustomsEntryPointsIdActualizeResponse204 = {
  data: void
  status: 204
}

export type patchQaCustomsEntryPointsIdActualizeResponseSuccess = (patchQaCustomsEntryPointsIdActualizeResponse204) & {
  headers: Headers;
};
;

export type patchQaCustomsEntryPointsIdActualizeResponse = (patchQaCustomsEntryPointsIdActualizeResponseSuccess)

export const getPatchQaCustomsEntryPointsIdActualizeUrl = (id: number,) => {


  

  return `/api/qa/customs-entry-points/${id}/actualize/`
}

export const patchQaCustomsEntryPointsIdActualize = async (id: number, options?: RequestInit): Promise<patchQaCustomsEntryPointsIdActualizeResponse> => {
  
  return patchQaCustomsEntryPointsIdActualizeMutator<patchQaCustomsEntryPointsIdActualizeResponse>(getPatchQaCustomsEntryPointsIdActualizeUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaCustomsEntryPointsIdActualizeMutationOptions = <TError = PatchQaCustomsEntryPointsIdActualizeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaCustomsEntryPointsIdActualize'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaCustomsEntryPointsIdActualize(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaCustomsEntryPointsIdActualizeMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>>
    
    export type PatchQaCustomsEntryPointsIdActualizeMutationError = PatchQaCustomsEntryPointsIdActualizeErrorType<unknown>

    export const usePatchQaCustomsEntryPointsIdActualize = <TError = PatchQaCustomsEntryPointsIdActualizeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaCustomsEntryPointsIdActualize>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaCustomsEntryPointsIdActualizeMutationOptions(options));
    }
    export type patchQaDeliveryPointsCodeActualizeResponse204 = {
  data: void
  status: 204
}

export type patchQaDeliveryPointsCodeActualizeResponseSuccess = (patchQaDeliveryPointsCodeActualizeResponse204) & {
  headers: Headers;
};
;

export type patchQaDeliveryPointsCodeActualizeResponse = (patchQaDeliveryPointsCodeActualizeResponseSuccess)

export const getPatchQaDeliveryPointsCodeActualizeUrl = (code: string,) => {


  

  return `/api/qa/delivery-points/${code}/actualize/`
}

export const patchQaDeliveryPointsCodeActualize = async (code: string, options?: RequestInit): Promise<patchQaDeliveryPointsCodeActualizeResponse> => {
  
  return patchQaDeliveryPointsCodeActualizeMutator<patchQaDeliveryPointsCodeActualizeResponse>(getPatchQaDeliveryPointsCodeActualizeUrl(code),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaDeliveryPointsCodeActualizeMutationOptions = <TError = PatchQaDeliveryPointsCodeActualizeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>, TError,{code: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>, TError,{code: string}, TContext> => {

const mutationKey = ['patchQaDeliveryPointsCodeActualize'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>, {code: string}> = (props) => {
          const {code} = props ?? {};

          return  patchQaDeliveryPointsCodeActualize(code,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaDeliveryPointsCodeActualizeMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>>
    
    export type PatchQaDeliveryPointsCodeActualizeMutationError = PatchQaDeliveryPointsCodeActualizeErrorType<unknown>

    export const usePatchQaDeliveryPointsCodeActualize = <TError = PatchQaDeliveryPointsCodeActualizeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>, TError,{code: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaDeliveryPointsCodeActualize>>,
        TError,
        {code: string},
        TContext
      > => {
      return useMutation(getPatchQaDeliveryPointsCodeActualizeMutationOptions(options));
    }
    export type patchQaOffersIdResponse200 = {
  data: TestingOfferStatus
  status: 200
}

export type patchQaOffersIdResponseSuccess = (patchQaOffersIdResponse200) & {
  headers: Headers;
};
;

export type patchQaOffersIdResponse = (patchQaOffersIdResponseSuccess)

export const getPatchQaOffersIdUrl = (id: number,) => {


  

  return `/api/qa/offers/${id}/`
}

export const patchQaOffersId = async (id: number,
    patchedTestingOfferStatus: PatchedTestingOfferStatus, options?: RequestInit): Promise<patchQaOffersIdResponse> => {
  
  return patchQaOffersIdMutator<patchQaOffersIdResponse>(getPatchQaOffersIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTestingOfferStatus,)
  }
);}
  



export const getPatchQaOffersIdMutationOptions = <TError = PatchQaOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaOffersId>>, TError,{id: number;data: PatchedTestingOfferStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaOffersId>>, TError,{id: number;data: PatchedTestingOfferStatus}, TContext> => {

const mutationKey = ['patchQaOffersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaOffersId>>, {id: number;data: PatchedTestingOfferStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchQaOffersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaOffersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaOffersId>>>
    export type PatchQaOffersIdMutationBody = PatchedTestingOfferStatus
    export type PatchQaOffersIdMutationError = PatchQaOffersIdErrorType<unknown>

    export const usePatchQaOffersId = <TError = PatchQaOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaOffersId>>, TError,{id: number;data: PatchedTestingOfferStatus}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaOffersId>>,
        TError,
        {id: number;data: PatchedTestingOfferStatus},
        TContext
      > => {
      return useMutation(getPatchQaOffersIdMutationOptions(options));
    }
    export type deleteQaOffersIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaOffersIdResponseSuccess = (deleteQaOffersIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaOffersIdResponse = (deleteQaOffersIdResponseSuccess)

export const getDeleteQaOffersIdUrl = (id: number,) => {


  

  return `/api/qa/offers/${id}/`
}

export const deleteQaOffersId = async (id: number, options?: RequestInit): Promise<deleteQaOffersIdResponse> => {
  
  return deleteQaOffersIdMutator<deleteQaOffersIdResponse>(getDeleteQaOffersIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaOffersIdMutationOptions = <TError = DeleteQaOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaOffersId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaOffersId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaOffersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaOffersId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaOffersId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaOffersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaOffersId>>>
    
    export type DeleteQaOffersIdMutationError = DeleteQaOffersIdErrorType<unknown>

    export const useDeleteQaOffersId = <TError = DeleteQaOffersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaOffersId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaOffersId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaOffersIdMutationOptions(options));
    }
    export type getQaProductsResponse200 = {
  data: PaginatedTestingProductList
  status: 200
}

export type getQaProductsResponseSuccess = (getQaProductsResponse200) & {
  headers: Headers;
};
;

export type getQaProductsResponse = (getQaProductsResponseSuccess)

export const getGetQaProductsUrl = (params?: GetQaProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/qa/products/?${stringifiedParams}` : `/api/qa/products/`
}

export const getQaProducts = async (params?: GetQaProductsParams, options?: RequestInit): Promise<getQaProductsResponse> => {
  
  return getQaProductsMutator<getQaProductsResponse>(getGetQaProductsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaProductsQueryKey = (params?: GetQaProductsParams,) => {
    return [
    `/api/qa/products/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetQaProductsQueryOptions = <TData = Awaited<ReturnType<typeof getQaProducts>>, TError = GetQaProductsErrorType<unknown>>(params?: GetQaProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaProducts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaProducts>>> = ({ signal }) => getQaProducts(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getQaProducts>>>
export type GetQaProductsQueryError = GetQaProductsErrorType<unknown>



export function useGetQaProducts<TData = Awaited<ReturnType<typeof getQaProducts>>, TError = GetQaProductsErrorType<unknown>>(
 params?: GetQaProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaProducts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getQaProductsIdResponse200 = {
  data: TestingProduct
  status: 200
}

export type getQaProductsIdResponseSuccess = (getQaProductsIdResponse200) & {
  headers: Headers;
};
;

export type getQaProductsIdResponse = (getQaProductsIdResponseSuccess)

export const getGetQaProductsIdUrl = (id: number,) => {


  

  return `/api/qa/products/${id}/`
}

export const getQaProductsId = async (id: number, options?: RequestInit): Promise<getQaProductsIdResponse> => {
  
  return getQaProductsIdMutator<getQaProductsIdResponse>(getGetQaProductsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaProductsIdQueryKey = (id: number,) => {
    return [
    `/api/qa/products/${id}/`
    ] as const;
    }

    
export const getGetQaProductsIdQueryOptions = <TData = Awaited<ReturnType<typeof getQaProductsId>>, TError = GetQaProductsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaProductsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaProductsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaProductsId>>> = ({ signal }) => getQaProductsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaProductsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaProductsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQaProductsId>>>
export type GetQaProductsIdQueryError = GetQaProductsIdErrorType<unknown>



export function useGetQaProductsId<TData = Awaited<ReturnType<typeof getQaProductsId>>, TError = GetQaProductsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaProductsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaProductsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type deleteQaProductsIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaProductsIdResponseSuccess = (deleteQaProductsIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaProductsIdResponse = (deleteQaProductsIdResponseSuccess)

export const getDeleteQaProductsIdUrl = (id: number,) => {


  

  return `/api/qa/products/${id}/`
}

export const deleteQaProductsId = async (id: number, options?: RequestInit): Promise<deleteQaProductsIdResponse> => {
  
  return deleteQaProductsIdMutator<deleteQaProductsIdResponse>(getDeleteQaProductsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaProductsIdMutationOptions = <TError = DeleteQaProductsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaProductsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaProductsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaProductsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaProductsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaProductsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaProductsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaProductsId>>>
    
    export type DeleteQaProductsIdMutationError = DeleteQaProductsIdErrorType<unknown>

    export const useDeleteQaProductsId = <TError = DeleteQaProductsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaProductsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaProductsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaProductsIdMutationOptions(options));
    }
    export type deleteQaProgramsIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaProgramsIdResponseSuccess = (deleteQaProgramsIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaProgramsIdResponse = (deleteQaProgramsIdResponseSuccess)

export const getDeleteQaProgramsIdUrl = (id: number,) => {


  

  return `/api/qa/programs/${id}/`
}

export const deleteQaProgramsId = async (id: number, options?: RequestInit): Promise<deleteQaProgramsIdResponse> => {
  
  return deleteQaProgramsIdMutator<deleteQaProgramsIdResponse>(getDeleteQaProgramsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaProgramsIdMutationOptions = <TError = DeleteQaProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaProgramsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaProgramsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaProgramsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaProgramsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaProgramsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaProgramsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaProgramsId>>>
    
    export type DeleteQaProgramsIdMutationError = DeleteQaProgramsIdErrorType<unknown>

    export const useDeleteQaProgramsId = <TError = DeleteQaProgramsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaProgramsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaProgramsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaProgramsIdMutationOptions(options));
    }
    export type deleteQaRegularDemandsIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaRegularDemandsIdResponseSuccess = (deleteQaRegularDemandsIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaRegularDemandsIdResponse = (deleteQaRegularDemandsIdResponseSuccess)

export const getDeleteQaRegularDemandsIdUrl = (id: number,) => {


  

  return `/api/qa/regular-demands/${id}/`
}

export const deleteQaRegularDemandsId = async (id: number, options?: RequestInit): Promise<deleteQaRegularDemandsIdResponse> => {
  
  return deleteQaRegularDemandsIdMutator<deleteQaRegularDemandsIdResponse>(getDeleteQaRegularDemandsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaRegularDemandsIdMutationOptions = <TError = DeleteQaRegularDemandsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaRegularDemandsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaRegularDemandsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaRegularDemandsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaRegularDemandsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaRegularDemandsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaRegularDemandsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaRegularDemandsId>>>
    
    export type DeleteQaRegularDemandsIdMutationError = DeleteQaRegularDemandsIdErrorType<unknown>

    export const useDeleteQaRegularDemandsId = <TError = DeleteQaRegularDemandsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaRegularDemandsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaRegularDemandsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaRegularDemandsIdMutationOptions(options));
    }
    export type postQaSentryCheckResponse200 = {
  data: void
  status: 200
}

export type postQaSentryCheckResponseSuccess = (postQaSentryCheckResponse200) & {
  headers: Headers;
};
;

export type postQaSentryCheckResponse = (postQaSentryCheckResponseSuccess)

export const getPostQaSentryCheckUrl = () => {


  

  return `/api/qa/sentry/check/`
}

export const postQaSentryCheck = async ( options?: RequestInit): Promise<postQaSentryCheckResponse> => {
  
  return postQaSentryCheckMutator<postQaSentryCheckResponse>(getPostQaSentryCheckUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  



export const getPostQaSentryCheckMutationOptions = <TError = PostQaSentryCheckErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSentryCheck>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSentryCheck>>, TError,void, TContext> => {

const mutationKey = ['postQaSentryCheck'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSentryCheck>>, void> = () => {
          

          return  postQaSentryCheck()
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSentryCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSentryCheck>>>
    
    export type PostQaSentryCheckMutationError = PostQaSentryCheckErrorType<unknown>

    export const usePostQaSentryCheck = <TError = PostQaSentryCheckErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSentryCheck>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSentryCheck>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostQaSentryCheckMutationOptions(options));
    }
    export type postQaSizesResponse201 = {
  data: TestingSize[]
  status: 201
}

export type postQaSizesResponseSuccess = (postQaSizesResponse201) & {
  headers: Headers;
};
;

export type postQaSizesResponse = (postQaSizesResponseSuccess)

export const getPostQaSizesUrl = () => {


  

  return `/api/qa/sizes/`
}

export const postQaSizes = async (testingSize: NonReadonly<TestingSize[]>, options?: RequestInit): Promise<postQaSizesResponse> => {
  
  return postQaSizesMutator<postQaSizesResponse>(getPostQaSizesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingSize,)
  }
);}
  



export const getPostQaSizesMutationOptions = <TError = PostQaSizesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSizes>>, TError,{data: NonReadonly<TestingSize[]>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSizes>>, TError,{data: NonReadonly<TestingSize[]>}, TContext> => {

const mutationKey = ['postQaSizes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSizes>>, {data: NonReadonly<TestingSize[]>}> = (props) => {
          const {data} = props ?? {};

          return  postQaSizes(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSizesMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSizes>>>
    export type PostQaSizesMutationBody = NonReadonly<TestingSize[]>
    export type PostQaSizesMutationError = PostQaSizesErrorType<unknown>

    export const usePostQaSizes = <TError = PostQaSizesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSizes>>, TError,{data: NonReadonly<TestingSize[]>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSizes>>,
        TError,
        {data: NonReadonly<TestingSize[]>},
        TContext
      > => {
      return useMutation(getPostQaSizesMutationOptions(options));
    }
    export type postQaSizesDeleteResponse200 = {
  data: number[]
  status: 200
}

export type postQaSizesDeleteResponseSuccess = (postQaSizesDeleteResponse200) & {
  headers: Headers;
};
;

export type postQaSizesDeleteResponse = (postQaSizesDeleteResponseSuccess)

export const getPostQaSizesDeleteUrl = () => {


  

  return `/api/qa/sizes/delete/`
}

export const postQaSizesDelete = async (postQaSizesDeleteBody: number[], options?: RequestInit): Promise<postQaSizesDeleteResponse> => {
  
  return postQaSizesDeleteMutator<postQaSizesDeleteResponse>(getPostQaSizesDeleteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQaSizesDeleteBody,)
  }
);}
  



export const getPostQaSizesDeleteMutationOptions = <TError = PostQaSizesDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSizesDelete>>, TError,{data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSizesDelete>>, TError,{data: number[]}, TContext> => {

const mutationKey = ['postQaSizesDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSizesDelete>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postQaSizesDelete(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSizesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSizesDelete>>>
    export type PostQaSizesDeleteMutationBody = number[]
    export type PostQaSizesDeleteMutationError = PostQaSizesDeleteErrorType<unknown>

    export const usePostQaSizesDelete = <TError = PostQaSizesDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSizesDelete>>, TError,{data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSizesDelete>>,
        TError,
        {data: number[]},
        TContext
      > => {
      return useMutation(getPostQaSizesDeleteMutationOptions(options));
    }
    export type postQaSortsResponse201 = {
  data: TestingSort[]
  status: 201
}

export type postQaSortsResponseSuccess = (postQaSortsResponse201) & {
  headers: Headers;
};
;

export type postQaSortsResponse = (postQaSortsResponseSuccess)

export const getPostQaSortsUrl = () => {


  

  return `/api/qa/sorts/`
}

export const postQaSorts = async (testingSort: NonReadonly<TestingSort[]>, options?: RequestInit): Promise<postQaSortsResponse> => {
  
  return postQaSortsMutator<postQaSortsResponse>(getPostQaSortsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingSort,)
  }
);}
  



export const getPostQaSortsMutationOptions = <TError = PostQaSortsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSorts>>, TError,{data: NonReadonly<TestingSort[]>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSorts>>, TError,{data: NonReadonly<TestingSort[]>}, TContext> => {

const mutationKey = ['postQaSorts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSorts>>, {data: NonReadonly<TestingSort[]>}> = (props) => {
          const {data} = props ?? {};

          return  postQaSorts(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSortsMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSorts>>>
    export type PostQaSortsMutationBody = NonReadonly<TestingSort[]>
    export type PostQaSortsMutationError = PostQaSortsErrorType<unknown>

    export const usePostQaSorts = <TError = PostQaSortsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSorts>>, TError,{data: NonReadonly<TestingSort[]>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSorts>>,
        TError,
        {data: NonReadonly<TestingSort[]>},
        TContext
      > => {
      return useMutation(getPostQaSortsMutationOptions(options));
    }
    export type postQaSortsDeleteResponse200 = {
  data: number[]
  status: 200
}

export type postQaSortsDeleteResponseSuccess = (postQaSortsDeleteResponse200) & {
  headers: Headers;
};
;

export type postQaSortsDeleteResponse = (postQaSortsDeleteResponseSuccess)

export const getPostQaSortsDeleteUrl = () => {


  

  return `/api/qa/sorts/delete/`
}

export const postQaSortsDelete = async (postQaSortsDeleteBody: number[], options?: RequestInit): Promise<postQaSortsDeleteResponse> => {
  
  return postQaSortsDeleteMutator<postQaSortsDeleteResponse>(getPostQaSortsDeleteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQaSortsDeleteBody,)
  }
);}
  



export const getPostQaSortsDeleteMutationOptions = <TError = PostQaSortsDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSortsDelete>>, TError,{data: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSortsDelete>>, TError,{data: number[]}, TContext> => {

const mutationKey = ['postQaSortsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSortsDelete>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postQaSortsDelete(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSortsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSortsDelete>>>
    export type PostQaSortsDeleteMutationBody = number[]
    export type PostQaSortsDeleteMutationError = PostQaSortsDeleteErrorType<unknown>

    export const usePostQaSortsDelete = <TError = PostQaSortsDeleteErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSortsDelete>>, TError,{data: number[]}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSortsDelete>>,
        TError,
        {data: number[]},
        TContext
      > => {
      return useMutation(getPostQaSortsDeleteMutationOptions(options));
    }
    export type getQaSuppliersResponse200 = {
  data: TestingSupplier[]
  status: 200
}

export type getQaSuppliersResponseSuccess = (getQaSuppliersResponse200) & {
  headers: Headers;
};
;

export type getQaSuppliersResponse = (getQaSuppliersResponseSuccess)

export const getGetQaSuppliersUrl = (params?: GetQaSuppliersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/qa/suppliers/?${stringifiedParams}` : `/api/qa/suppliers/`
}

export const getQaSuppliers = async (params?: GetQaSuppliersParams, options?: RequestInit): Promise<getQaSuppliersResponse> => {
  
  return getQaSuppliersMutator<getQaSuppliersResponse>(getGetQaSuppliersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaSuppliersQueryKey = (params?: GetQaSuppliersParams,) => {
    return [
    `/api/qa/suppliers/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetQaSuppliersQueryOptions = <TData = Awaited<ReturnType<typeof getQaSuppliers>>, TError = GetQaSuppliersErrorType<unknown>>(params?: GetQaSuppliersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaSuppliers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaSuppliersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaSuppliers>>> = ({ signal }) => getQaSuppliers(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaSuppliers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaSuppliersQueryResult = NonNullable<Awaited<ReturnType<typeof getQaSuppliers>>>
export type GetQaSuppliersQueryError = GetQaSuppliersErrorType<unknown>



export function useGetQaSuppliers<TData = Awaited<ReturnType<typeof getQaSuppliers>>, TError = GetQaSuppliersErrorType<unknown>>(
 params?: GetQaSuppliersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaSuppliers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaSuppliersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postQaSuppliersResponse201 = {
  data: TestingSupplier
  status: 201
}

export type postQaSuppliersResponseSuccess = (postQaSuppliersResponse201) & {
  headers: Headers;
};
;

export type postQaSuppliersResponse = (postQaSuppliersResponseSuccess)

export const getPostQaSuppliersUrl = () => {


  

  return `/api/qa/suppliers/`
}

export const postQaSuppliers = async (testingSupplier: NonReadonly<TestingSupplier>, options?: RequestInit): Promise<postQaSuppliersResponse> => {
  
  return postQaSuppliersMutator<postQaSuppliersResponse>(getPostQaSuppliersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingSupplier,)
  }
);}
  



export const getPostQaSuppliersMutationOptions = <TError = PostQaSuppliersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSuppliers>>, TError,{data: NonReadonly<TestingSupplier>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaSuppliers>>, TError,{data: NonReadonly<TestingSupplier>}, TContext> => {

const mutationKey = ['postQaSuppliers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaSuppliers>>, {data: NonReadonly<TestingSupplier>}> = (props) => {
          const {data} = props ?? {};

          return  postQaSuppliers(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaSuppliersMutationResult = NonNullable<Awaited<ReturnType<typeof postQaSuppliers>>>
    export type PostQaSuppliersMutationBody = NonReadonly<TestingSupplier>
    export type PostQaSuppliersMutationError = PostQaSuppliersErrorType<unknown>

    export const usePostQaSuppliers = <TError = PostQaSuppliersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaSuppliers>>, TError,{data: NonReadonly<TestingSupplier>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaSuppliers>>,
        TError,
        {data: NonReadonly<TestingSupplier>},
        TContext
      > => {
      return useMutation(getPostQaSuppliersMutationOptions(options));
    }
    export type deleteQaSuppliersIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaSuppliersIdResponseSuccess = (deleteQaSuppliersIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaSuppliersIdResponse = (deleteQaSuppliersIdResponseSuccess)

export const getDeleteQaSuppliersIdUrl = (id: number,) => {


  

  return `/api/qa/suppliers/${id}/`
}

export const deleteQaSuppliersId = async (id: number, options?: RequestInit): Promise<deleteQaSuppliersIdResponse> => {
  
  return deleteQaSuppliersIdMutator<deleteQaSuppliersIdResponse>(getDeleteQaSuppliersIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaSuppliersIdMutationOptions = <TError = DeleteQaSuppliersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaSuppliersId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaSuppliersId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaSuppliersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaSuppliersId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaSuppliersId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaSuppliersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaSuppliersId>>>
    
    export type DeleteQaSuppliersIdMutationError = DeleteQaSuppliersIdErrorType<unknown>

    export const useDeleteQaSuppliersId = <TError = DeleteQaSuppliersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaSuppliersId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaSuppliersId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaSuppliersIdMutationOptions(options));
    }
    export type patchQaSuppliersIdActivateResponse204 = {
  data: void
  status: 204
}

export type patchQaSuppliersIdActivateResponseSuccess = (patchQaSuppliersIdActivateResponse204) & {
  headers: Headers;
};
;

export type patchQaSuppliersIdActivateResponse = (patchQaSuppliersIdActivateResponseSuccess)

export const getPatchQaSuppliersIdActivateUrl = (id: number,) => {


  

  return `/api/qa/suppliers/${id}/activate/`
}

export const patchQaSuppliersIdActivate = async (id: number, options?: RequestInit): Promise<patchQaSuppliersIdActivateResponse> => {
  
  return patchQaSuppliersIdActivateMutator<patchQaSuppliersIdActivateResponse>(getPatchQaSuppliersIdActivateUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaSuppliersIdActivateMutationOptions = <TError = PatchQaSuppliersIdActivateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaSuppliersIdActivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaSuppliersIdActivate(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaSuppliersIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>>
    
    export type PatchQaSuppliersIdActivateMutationError = PatchQaSuppliersIdActivateErrorType<unknown>

    export const usePatchQaSuppliersIdActivate = <TError = PatchQaSuppliersIdActivateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaSuppliersIdActivate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaSuppliersIdActivateMutationOptions(options));
    }
    export type patchQaSuppliersIdArchiveResponse204 = {
  data: void
  status: 204
}

export type patchQaSuppliersIdArchiveResponseSuccess = (patchQaSuppliersIdArchiveResponse204) & {
  headers: Headers;
};
;

export type patchQaSuppliersIdArchiveResponse = (patchQaSuppliersIdArchiveResponseSuccess)

export const getPatchQaSuppliersIdArchiveUrl = (id: number,) => {


  

  return `/api/qa/suppliers/${id}/archive/`
}

export const patchQaSuppliersIdArchive = async (id: number, options?: RequestInit): Promise<patchQaSuppliersIdArchiveResponse> => {
  
  return patchQaSuppliersIdArchiveMutator<patchQaSuppliersIdArchiveResponse>(getPatchQaSuppliersIdArchiveUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaSuppliersIdArchiveMutationOptions = <TError = PatchQaSuppliersIdArchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaSuppliersIdArchive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaSuppliersIdArchive(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaSuppliersIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>>
    
    export type PatchQaSuppliersIdArchiveMutationError = PatchQaSuppliersIdArchiveErrorType<unknown>

    export const usePatchQaSuppliersIdArchive = <TError = PatchQaSuppliersIdArchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaSuppliersIdArchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaSuppliersIdArchiveMutationOptions(options));
    }
    export type patchQaSuppliersIdDeactivateResponse204 = {
  data: void
  status: 204
}

export type patchQaSuppliersIdDeactivateResponseSuccess = (patchQaSuppliersIdDeactivateResponse204) & {
  headers: Headers;
};
;

export type patchQaSuppliersIdDeactivateResponse = (patchQaSuppliersIdDeactivateResponseSuccess)

export const getPatchQaSuppliersIdDeactivateUrl = (id: number,) => {


  

  return `/api/qa/suppliers/${id}/deactivate/`
}

export const patchQaSuppliersIdDeactivate = async (id: number, options?: RequestInit): Promise<patchQaSuppliersIdDeactivateResponse> => {
  
  return patchQaSuppliersIdDeactivateMutator<patchQaSuppliersIdDeactivateResponse>(getPatchQaSuppliersIdDeactivateUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaSuppliersIdDeactivateMutationOptions = <TError = PatchQaSuppliersIdDeactivateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaSuppliersIdDeactivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaSuppliersIdDeactivate(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaSuppliersIdDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>>
    
    export type PatchQaSuppliersIdDeactivateMutationError = PatchQaSuppliersIdDeactivateErrorType<unknown>

    export const usePatchQaSuppliersIdDeactivate = <TError = PatchQaSuppliersIdDeactivateErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaSuppliersIdDeactivate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaSuppliersIdDeactivateMutationOptions(options));
    }
    export type patchQaSuppliersIdUnarchiveResponse204 = {
  data: void
  status: 204
}

export type patchQaSuppliersIdUnarchiveResponseSuccess = (patchQaSuppliersIdUnarchiveResponse204) & {
  headers: Headers;
};
;

export type patchQaSuppliersIdUnarchiveResponse = (patchQaSuppliersIdUnarchiveResponseSuccess)

export const getPatchQaSuppliersIdUnarchiveUrl = (id: number,) => {


  

  return `/api/qa/suppliers/${id}/unarchive/`
}

export const patchQaSuppliersIdUnarchive = async (id: number, options?: RequestInit): Promise<patchQaSuppliersIdUnarchiveResponse> => {
  
  return patchQaSuppliersIdUnarchiveMutator<patchQaSuppliersIdUnarchiveResponse>(getPatchQaSuppliersIdUnarchiveUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaSuppliersIdUnarchiveMutationOptions = <TError = PatchQaSuppliersIdUnarchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaSuppliersIdUnarchive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaSuppliersIdUnarchive(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaSuppliersIdUnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>>
    
    export type PatchQaSuppliersIdUnarchiveMutationError = PatchQaSuppliersIdUnarchiveErrorType<unknown>

    export const usePatchQaSuppliersIdUnarchive = <TError = PatchQaSuppliersIdUnarchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaSuppliersIdUnarchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaSuppliersIdUnarchiveMutationOptions(options));
    }
    export type getQaUsersResponse200 = {
  data: TestingUser[]
  status: 200
}

export type getQaUsersResponseSuccess = (getQaUsersResponse200) & {
  headers: Headers;
};
;

export type getQaUsersResponse = (getQaUsersResponseSuccess)

export const getGetQaUsersUrl = (params?: GetQaUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/qa/users/?${stringifiedParams}` : `/api/qa/users/`
}

export const getQaUsers = async (params?: GetQaUsersParams, options?: RequestInit): Promise<getQaUsersResponse> => {
  
  return getQaUsersMutator<getQaUsersResponse>(getGetQaUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaUsersQueryKey = (params?: GetQaUsersParams,) => {
    return [
    `/api/qa/users/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetQaUsersQueryOptions = <TData = Awaited<ReturnType<typeof getQaUsers>>, TError = GetQaUsersErrorType<unknown>>(params?: GetQaUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaUsers>>> = ({ signal }) => getQaUsers(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getQaUsers>>>
export type GetQaUsersQueryError = GetQaUsersErrorType<unknown>



export function useGetQaUsers<TData = Awaited<ReturnType<typeof getQaUsers>>, TError = GetQaUsersErrorType<unknown>>(
 params?: GetQaUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postQaUsersResponse201 = {
  data: TestingUser
  status: 201
}

export type postQaUsersResponseSuccess = (postQaUsersResponse201) & {
  headers: Headers;
};
;

export type postQaUsersResponse = (postQaUsersResponseSuccess)

export const getPostQaUsersUrl = () => {


  

  return `/api/qa/users/`
}

export const postQaUsers = async (testingUser: NonReadonly<TestingUser>, options?: RequestInit): Promise<postQaUsersResponse> => {
  
  return postQaUsersMutator<postQaUsersResponse>(getPostQaUsersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingUser,)
  }
);}
  



export const getPostQaUsersMutationOptions = <TError = PostQaUsersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaUsers>>, TError,{data: NonReadonly<TestingUser>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postQaUsers>>, TError,{data: NonReadonly<TestingUser>}, TContext> => {

const mutationKey = ['postQaUsers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQaUsers>>, {data: NonReadonly<TestingUser>}> = (props) => {
          const {data} = props ?? {};

          return  postQaUsers(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostQaUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postQaUsers>>>
    export type PostQaUsersMutationBody = NonReadonly<TestingUser>
    export type PostQaUsersMutationError = PostQaUsersErrorType<unknown>

    export const usePostQaUsers = <TError = PostQaUsersErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQaUsers>>, TError,{data: NonReadonly<TestingUser>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postQaUsers>>,
        TError,
        {data: NonReadonly<TestingUser>},
        TContext
      > => {
      return useMutation(getPostQaUsersMutationOptions(options));
    }
    export type getQaUsersIdResponse200 = {
  data: TestingUserUpdate
  status: 200
}

export type getQaUsersIdResponseSuccess = (getQaUsersIdResponse200) & {
  headers: Headers;
};
;

export type getQaUsersIdResponse = (getQaUsersIdResponseSuccess)

export const getGetQaUsersIdUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/`
}

export const getQaUsersId = async (id: number, options?: RequestInit): Promise<getQaUsersIdResponse> => {
  
  return getQaUsersIdMutator<getQaUsersIdResponse>(getGetQaUsersIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaUsersIdQueryKey = (id: number,) => {
    return [
    `/api/qa/users/${id}/`
    ] as const;
    }

    
export const getGetQaUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getQaUsersId>>, TError = GetQaUsersIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsersId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaUsersId>>> = ({ signal }) => getQaUsersId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaUsersId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQaUsersId>>>
export type GetQaUsersIdQueryError = GetQaUsersIdErrorType<unknown>



export function useGetQaUsersId<TData = Awaited<ReturnType<typeof getQaUsersId>>, TError = GetQaUsersIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsersId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putQaUsersIdResponse200 = {
  data: TestingUserUpdate
  status: 200
}

export type putQaUsersIdResponseSuccess = (putQaUsersIdResponse200) & {
  headers: Headers;
};
;

export type putQaUsersIdResponse = (putQaUsersIdResponseSuccess)

export const getPutQaUsersIdUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/`
}

export const putQaUsersId = async (id: number,
    testingUserUpdate: NonReadonly<TestingUserUpdate>, options?: RequestInit): Promise<putQaUsersIdResponse> => {
  
  return putQaUsersIdMutator<putQaUsersIdResponse>(getPutQaUsersIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testingUserUpdate,)
  }
);}
  



export const getPutQaUsersIdMutationOptions = <TError = PutQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQaUsersId>>, TError,{id: number;data: NonReadonly<TestingUserUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putQaUsersId>>, TError,{id: number;data: NonReadonly<TestingUserUpdate>}, TContext> => {

const mutationKey = ['putQaUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQaUsersId>>, {id: number;data: NonReadonly<TestingUserUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putQaUsersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutQaUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putQaUsersId>>>
    export type PutQaUsersIdMutationBody = NonReadonly<TestingUserUpdate>
    export type PutQaUsersIdMutationError = PutQaUsersIdErrorType<unknown>

    export const usePutQaUsersId = <TError = PutQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQaUsersId>>, TError,{id: number;data: NonReadonly<TestingUserUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putQaUsersId>>,
        TError,
        {id: number;data: NonReadonly<TestingUserUpdate>},
        TContext
      > => {
      return useMutation(getPutQaUsersIdMutationOptions(options));
    }
    export type patchQaUsersIdResponse200 = {
  data: TestingUserUpdate
  status: 200
}

export type patchQaUsersIdResponseSuccess = (patchQaUsersIdResponse200) & {
  headers: Headers;
};
;

export type patchQaUsersIdResponse = (patchQaUsersIdResponseSuccess)

export const getPatchQaUsersIdUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/`
}

export const patchQaUsersId = async (id: number,
    patchedTestingUserUpdate: NonReadonly<PatchedTestingUserUpdate>, options?: RequestInit): Promise<patchQaUsersIdResponse> => {
  
  return patchQaUsersIdMutator<patchQaUsersIdResponse>(getPatchQaUsersIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTestingUserUpdate,)
  }
);}
  



export const getPatchQaUsersIdMutationOptions = <TError = PatchQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersId>>, TError,{id: number;data: NonReadonly<PatchedTestingUserUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersId>>, TError,{id: number;data: NonReadonly<PatchedTestingUserUpdate>}, TContext> => {

const mutationKey = ['patchQaUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaUsersId>>, {id: number;data: NonReadonly<PatchedTestingUserUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchQaUsersId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaUsersId>>>
    export type PatchQaUsersIdMutationBody = NonReadonly<PatchedTestingUserUpdate>
    export type PatchQaUsersIdMutationError = PatchQaUsersIdErrorType<unknown>

    export const usePatchQaUsersId = <TError = PatchQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersId>>, TError,{id: number;data: NonReadonly<PatchedTestingUserUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaUsersId>>,
        TError,
        {id: number;data: NonReadonly<PatchedTestingUserUpdate>},
        TContext
      > => {
      return useMutation(getPatchQaUsersIdMutationOptions(options));
    }
    export type deleteQaUsersIdResponse204 = {
  data: void
  status: 204
}

export type deleteQaUsersIdResponseSuccess = (deleteQaUsersIdResponse204) & {
  headers: Headers;
};
;

export type deleteQaUsersIdResponse = (deleteQaUsersIdResponseSuccess)

export const getDeleteQaUsersIdUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/`
}

export const deleteQaUsersId = async (id: number, options?: RequestInit): Promise<deleteQaUsersIdResponse> => {
  
  return deleteQaUsersIdMutator<deleteQaUsersIdResponse>(getDeleteQaUsersIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteQaUsersIdMutationOptions = <TError = DeleteQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaUsersId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteQaUsersId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteQaUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteQaUsersId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteQaUsersId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQaUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteQaUsersId>>>
    
    export type DeleteQaUsersIdMutationError = DeleteQaUsersIdErrorType<unknown>

    export const useDeleteQaUsersId = <TError = DeleteQaUsersIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteQaUsersId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteQaUsersId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteQaUsersIdMutationOptions(options));
    }
    export type patchQaUsersIdArchiveResponse204 = {
  data: void
  status: 204
}

export type patchQaUsersIdArchiveResponseSuccess = (patchQaUsersIdArchiveResponse204) & {
  headers: Headers;
};
;

export type patchQaUsersIdArchiveResponse = (patchQaUsersIdArchiveResponseSuccess)

export const getPatchQaUsersIdArchiveUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/archive/`
}

export const patchQaUsersIdArchive = async (id: number, options?: RequestInit): Promise<patchQaUsersIdArchiveResponse> => {
  
  return patchQaUsersIdArchiveMutator<patchQaUsersIdArchiveResponse>(getPatchQaUsersIdArchiveUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaUsersIdArchiveMutationOptions = <TError = PatchQaUsersIdArchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdArchive>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdArchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaUsersIdArchive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaUsersIdArchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaUsersIdArchive(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaUsersIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaUsersIdArchive>>>
    
    export type PatchQaUsersIdArchiveMutationError = PatchQaUsersIdArchiveErrorType<unknown>

    export const usePatchQaUsersIdArchive = <TError = PatchQaUsersIdArchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdArchive>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaUsersIdArchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaUsersIdArchiveMutationOptions(options));
    }
    export type getQaUsersIdPasswordTokenResponse200 = {
  data: TestingUserToken
  status: 200
}

export type getQaUsersIdPasswordTokenResponseSuccess = (getQaUsersIdPasswordTokenResponse200) & {
  headers: Headers;
};
;

export type getQaUsersIdPasswordTokenResponse = (getQaUsersIdPasswordTokenResponseSuccess)

export const getGetQaUsersIdPasswordTokenUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/password-token/`
}

export const getQaUsersIdPasswordToken = async (id: number, options?: RequestInit): Promise<getQaUsersIdPasswordTokenResponse> => {
  
  return getQaUsersIdPasswordTokenMutator<getQaUsersIdPasswordTokenResponse>(getGetQaUsersIdPasswordTokenUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetQaUsersIdPasswordTokenQueryKey = (id: number,) => {
    return [
    `/api/qa/users/${id}/password-token/`
    ] as const;
    }

    
export const getGetQaUsersIdPasswordTokenQueryOptions = <TData = Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>, TError = GetQaUsersIdPasswordTokenErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQaUsersIdPasswordTokenQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>> = ({ signal }) => getQaUsersIdPasswordToken(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQaUsersIdPasswordTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>>
export type GetQaUsersIdPasswordTokenQueryError = GetQaUsersIdPasswordTokenErrorType<unknown>



export function useGetQaUsersIdPasswordToken<TData = Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>, TError = GetQaUsersIdPasswordTokenErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQaUsersIdPasswordToken>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetQaUsersIdPasswordTokenQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type patchQaUsersIdSetProductsResponse204 = {
  data: void
  status: 204
}

export type patchQaUsersIdSetProductsResponseSuccess = (patchQaUsersIdSetProductsResponse204) & {
  headers: Headers;
};
;

export type patchQaUsersIdSetProductsResponse = (patchQaUsersIdSetProductsResponseSuccess)

export const getPatchQaUsersIdSetProductsUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/set_products/`
}

export const patchQaUsersIdSetProducts = async (id: number,
    patchedTestingUserProducts: PatchedTestingUserProducts, options?: RequestInit): Promise<patchQaUsersIdSetProductsResponse> => {
  
  return patchQaUsersIdSetProductsMutator<patchQaUsersIdSetProductsResponse>(getPatchQaUsersIdSetProductsUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTestingUserProducts,)
  }
);}
  



export const getPatchQaUsersIdSetProductsMutationOptions = <TError = PatchQaUsersIdSetProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>, TError,{id: number;data: PatchedTestingUserProducts}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>, TError,{id: number;data: PatchedTestingUserProducts}, TContext> => {

const mutationKey = ['patchQaUsersIdSetProducts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>, {id: number;data: PatchedTestingUserProducts}> = (props) => {
          const {id,data} = props ?? {};

          return  patchQaUsersIdSetProducts(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaUsersIdSetProductsMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>>
    export type PatchQaUsersIdSetProductsMutationBody = PatchedTestingUserProducts
    export type PatchQaUsersIdSetProductsMutationError = PatchQaUsersIdSetProductsErrorType<unknown>

    export const usePatchQaUsersIdSetProducts = <TError = PatchQaUsersIdSetProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>, TError,{id: number;data: PatchedTestingUserProducts}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaUsersIdSetProducts>>,
        TError,
        {id: number;data: PatchedTestingUserProducts},
        TContext
      > => {
      return useMutation(getPatchQaUsersIdSetProductsMutationOptions(options));
    }
    export type patchQaUsersIdUnarchiveResponse204 = {
  data: void
  status: 204
}

export type patchQaUsersIdUnarchiveResponseSuccess = (patchQaUsersIdUnarchiveResponse204) & {
  headers: Headers;
};
;

export type patchQaUsersIdUnarchiveResponse = (patchQaUsersIdUnarchiveResponseSuccess)

export const getPatchQaUsersIdUnarchiveUrl = (id: number,) => {


  

  return `/api/qa/users/${id}/unarchive/`
}

export const patchQaUsersIdUnarchive = async (id: number, options?: RequestInit): Promise<patchQaUsersIdUnarchiveResponse> => {
  
  return patchQaUsersIdUnarchiveMutator<patchQaUsersIdUnarchiveResponse>(getPatchQaUsersIdUnarchiveUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}
  



export const getPatchQaUsersIdUnarchiveMutationOptions = <TError = PatchQaUsersIdUnarchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['patchQaUsersIdUnarchive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchQaUsersIdUnarchive(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQaUsersIdUnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>>
    
    export type PatchQaUsersIdUnarchiveMutationError = PatchQaUsersIdUnarchiveErrorType<unknown>

    export const usePatchQaUsersIdUnarchive = <TError = PatchQaUsersIdUnarchiveErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchQaUsersIdUnarchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPatchQaUsersIdUnarchiveMutationOptions(options));
    }
    export type getRegularDemandsResponse200 = {
  data: PaginatedRegularDemandList
  status: 200
}

export type getRegularDemandsResponseSuccess = (getRegularDemandsResponse200) & {
  headers: Headers;
};
;

export type getRegularDemandsResponse = (getRegularDemandsResponseSuccess)

export const getGetRegularDemandsUrl = (params?: GetRegularDemandsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/regular-demands/?${stringifiedParams}` : `/api/regular-demands/`
}

export const getRegularDemands = async (params?: GetRegularDemandsParams, options?: RequestInit): Promise<getRegularDemandsResponse> => {
  
  return getRegularDemandsMutator<getRegularDemandsResponse>(getGetRegularDemandsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetRegularDemandsQueryKey = (params?: GetRegularDemandsParams,) => {
    return [
    `/api/regular-demands/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetRegularDemandsQueryOptions = <TData = Awaited<ReturnType<typeof getRegularDemands>>, TError = GetRegularDemandsErrorType<unknown>>(params?: GetRegularDemandsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegularDemands>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegularDemandsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegularDemands>>> = ({ signal }) => getRegularDemands(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegularDemands>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegularDemandsQueryResult = NonNullable<Awaited<ReturnType<typeof getRegularDemands>>>
export type GetRegularDemandsQueryError = GetRegularDemandsErrorType<unknown>



export function useGetRegularDemands<TData = Awaited<ReturnType<typeof getRegularDemands>>, TError = GetRegularDemandsErrorType<unknown>>(
 params?: GetRegularDemandsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegularDemands>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRegularDemandsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getRegularDemandsFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getRegularDemandsFiltersFilterNameResponseSuccess = (getRegularDemandsFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getRegularDemandsFiltersFilterNameResponse = (getRegularDemandsFiltersFilterNameResponseSuccess)

export const getGetRegularDemandsFiltersFilterNameUrl = (filterName: string,
    params?: GetRegularDemandsFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/regular-demands/filters/${filterName}/?${stringifiedParams}` : `/api/regular-demands/filters/${filterName}/`
}

export const getRegularDemandsFiltersFilterName = async (filterName: string,
    params?: GetRegularDemandsFiltersFilterNameParams, options?: RequestInit): Promise<getRegularDemandsFiltersFilterNameResponse> => {
  
  return getRegularDemandsFiltersFilterNameMutator<getRegularDemandsFiltersFilterNameResponse>(getGetRegularDemandsFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetRegularDemandsFiltersFilterNameQueryKey = (filterName: string,
    params?: GetRegularDemandsFiltersFilterNameParams,) => {
    return [
    `/api/regular-demands/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetRegularDemandsFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>, TError = GetRegularDemandsFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetRegularDemandsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegularDemandsFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>> = ({ signal }) => getRegularDemandsFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegularDemandsFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>>
export type GetRegularDemandsFiltersFilterNameQueryError = GetRegularDemandsFiltersFilterNameErrorType<unknown>



export function useGetRegularDemandsFiltersFilterName<TData = Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>, TError = GetRegularDemandsFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetRegularDemandsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegularDemandsFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRegularDemandsFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postRegularDemandsUploadResponse200 = {
  data: ManageActionResult
  status: 200
}

export type postRegularDemandsUploadResponse400 = {
  data: ManageActionResult
  status: 400
}

export type postRegularDemandsUploadResponseSuccess = (postRegularDemandsUploadResponse200) & {
  headers: Headers;
};
export type postRegularDemandsUploadResponseError = (postRegularDemandsUploadResponse400) & {
  headers: Headers;
};

export type postRegularDemandsUploadResponse = (postRegularDemandsUploadResponseSuccess | postRegularDemandsUploadResponseError)

export const getPostRegularDemandsUploadUrl = () => {


  

  return `/api/regular-demands/upload/`
}

export const postRegularDemandsUpload = async (regularDemandUpload: RegularDemandUpload, options?: RequestInit): Promise<postRegularDemandsUploadResponse> => {
  
  return postRegularDemandsUploadMutator<postRegularDemandsUploadResponse>(getPostRegularDemandsUploadUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      regularDemandUpload,)
  }
);}
  



export const getPostRegularDemandsUploadMutationOptions = <TError = PostRegularDemandsUploadErrorType<ManageActionResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegularDemandsUpload>>, TError,{data: RegularDemandUpload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postRegularDemandsUpload>>, TError,{data: RegularDemandUpload}, TContext> => {

const mutationKey = ['postRegularDemandsUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegularDemandsUpload>>, {data: RegularDemandUpload}> = (props) => {
          const {data} = props ?? {};

          return  postRegularDemandsUpload(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostRegularDemandsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postRegularDemandsUpload>>>
    export type PostRegularDemandsUploadMutationBody = RegularDemandUpload
    export type PostRegularDemandsUploadMutationError = PostRegularDemandsUploadErrorType<ManageActionResult>

    export const usePostRegularDemandsUpload = <TError = PostRegularDemandsUploadErrorType<ManageActionResult>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegularDemandsUpload>>, TError,{data: RegularDemandUpload}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postRegularDemandsUpload>>,
        TError,
        {data: RegularDemandUpload},
        TContext
      > => {
      return useMutation(getPostRegularDemandsUploadMutationOptions(options));
    }
    /**
 * Получение списка отчётов пользователя.
 */
export type getReportsResponse200 = {
  data: PaginatedReportList
  status: 200
}

export type getReportsResponseSuccess = (getReportsResponse200) & {
  headers: Headers;
};
;

export type getReportsResponse = (getReportsResponseSuccess)

export const getGetReportsUrl = (params?: GetReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/?${stringifiedParams}` : `/api/reports/`
}

export const getReports = async (params?: GetReportsParams, options?: RequestInit): Promise<getReportsResponse> => {
  
  return getReportsMutator<getReportsResponse>(getGetReportsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetReportsQueryKey = (params?: GetReportsParams,) => {
    return [
    `/api/reports/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetReportsQueryOptions = <TData = Awaited<ReturnType<typeof getReports>>, TError = GetReportsErrorType<unknown>>(params?: GetReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReports>>> = ({ signal }) => getReports(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getReports>>>
export type GetReportsQueryError = GetReportsErrorType<unknown>



export function useGetReports<TData = Awaited<ReturnType<typeof getReports>>, TError = GetReportsErrorType<unknown>>(
 params?: GetReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Запрос файла пользователем из S3 через django прокси.
 */
export type getReportsIdResponse200 = {
  data: Blob
  status: 200
}

export type getReportsIdResponseSuccess = (getReportsIdResponse200) & {
  headers: Headers;
};
;

export type getReportsIdResponse = (getReportsIdResponseSuccess)

export const getGetReportsIdUrl = (id: number,) => {


  

  return `/api/reports/${id}/`
}

export const getReportsId = async (id: number, options?: RequestInit): Promise<getReportsIdResponse> => {
  
  return getReportsIdMutator<getReportsIdResponse>(getGetReportsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetReportsIdQueryKey = (id: number,) => {
    return [
    `/api/reports/${id}/`
    ] as const;
    }

    
export const getGetReportsIdQueryOptions = <TData = Awaited<ReturnType<typeof getReportsId>>, TError = GetReportsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsId>>> = ({ signal }) => getReportsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsId>>>
export type GetReportsIdQueryError = GetReportsIdErrorType<unknown>



export function useGetReportsId<TData = Awaited<ReturnType<typeof getReportsId>>, TError = GetReportsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReportsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Удаление файла пользователем из S3 через django прокси.
 */
export type deleteReportsIdResponse204 = {
  data: void
  status: 204
}

export type deleteReportsIdResponseSuccess = (deleteReportsIdResponse204) & {
  headers: Headers;
};
;

export type deleteReportsIdResponse = (deleteReportsIdResponseSuccess)

export const getDeleteReportsIdUrl = (id: number,) => {


  

  return `/api/reports/${id}/`
}

export const deleteReportsId = async (id: number, options?: RequestInit): Promise<deleteReportsIdResponse> => {
  
  return deleteReportsIdMutator<deleteReportsIdResponse>(getDeleteReportsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteReportsIdMutationOptions = <TError = DeleteReportsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReportsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteReportsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteReportsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReportsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteReportsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReportsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReportsId>>>
    
    export type DeleteReportsIdMutationError = DeleteReportsIdErrorType<unknown>

    export const useDeleteReportsId = <TError = DeleteReportsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReportsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteReportsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteReportsIdMutationOptions(options));
    }
    export type getSupplierResponse200 = {
  data: SupplierList[]
  status: 200
}

export type getSupplierResponseSuccess = (getSupplierResponse200) & {
  headers: Headers;
};
;

export type getSupplierResponse = (getSupplierResponseSuccess)

export const getGetSupplierUrl = (params?: GetSupplierParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/supplier/?${stringifiedParams}` : `/api/supplier/`
}

export const getSupplier = async (params?: GetSupplierParams, options?: RequestInit): Promise<getSupplierResponse> => {
  
  return getSupplierMutator<getSupplierResponse>(getGetSupplierUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSupplierQueryKey = (params?: GetSupplierParams,) => {
    return [
    `/api/supplier/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSupplierQueryOptions = <TData = Awaited<ReturnType<typeof getSupplier>>, TError = GetSupplierErrorType<unknown>>(params?: GetSupplierParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({ signal }) => getSupplier(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplier>>>
export type GetSupplierQueryError = GetSupplierErrorType<unknown>



export function useGetSupplier<TData = Awaited<ReturnType<typeof getSupplier>>, TError = GetSupplierErrorType<unknown>>(
 params?: GetSupplierParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplier>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postSupplierResponse201 = {
  data: SupplierCreateUpdate
  status: 201
}

export type postSupplierResponseSuccess = (postSupplierResponse201) & {
  headers: Headers;
};
;

export type postSupplierResponse = (postSupplierResponseSuccess)

export const getPostSupplierUrl = () => {


  

  return `/api/supplier/`
}

export const postSupplier = async (supplierCreateUpdate: SupplierCreateUpdate, options?: RequestInit): Promise<postSupplierResponse> => {
  
  return postSupplierMutator<postSupplierResponse>(getPostSupplierUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplierCreateUpdate,)
  }
);}
  



export const getPostSupplierMutationOptions = <TError = PostSupplierErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupplier>>, TError,{data: SupplierCreateUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSupplier>>, TError,{data: SupplierCreateUpdate}, TContext> => {

const mutationKey = ['postSupplier'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupplier>>, {data: SupplierCreateUpdate}> = (props) => {
          const {data} = props ?? {};

          return  postSupplier(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof postSupplier>>>
    export type PostSupplierMutationBody = SupplierCreateUpdate
    export type PostSupplierMutationError = PostSupplierErrorType<unknown>

    export const usePostSupplier = <TError = PostSupplierErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupplier>>, TError,{data: SupplierCreateUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postSupplier>>,
        TError,
        {data: SupplierCreateUpdate},
        TContext
      > => {
      return useMutation(getPostSupplierMutationOptions(options));
    }
    export type getSupplierIdResponse200 = {
  data: Supplier
  status: 200
}

export type getSupplierIdResponseSuccess = (getSupplierIdResponse200) & {
  headers: Headers;
};
;

export type getSupplierIdResponse = (getSupplierIdResponseSuccess)

export const getGetSupplierIdUrl = (id: number,) => {


  

  return `/api/supplier/${id}/`
}

export const getSupplierId = async (id: number, options?: RequestInit): Promise<getSupplierIdResponse> => {
  
  return getSupplierIdMutator<getSupplierIdResponse>(getGetSupplierIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSupplierIdQueryKey = (id: number,) => {
    return [
    `/api/supplier/${id}/`
    ] as const;
    }

    
export const getGetSupplierIdQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierId>>, TError = GetSupplierIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierId>>> = ({ signal }) => getSupplierId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierId>>>
export type GetSupplierIdQueryError = GetSupplierIdErrorType<unknown>



export function useGetSupplierId<TData = Awaited<ReturnType<typeof getSupplierId>>, TError = GetSupplierIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putSupplierIdResponse200 = {
  data: SupplierCreateUpdate
  status: 200
}

export type putSupplierIdResponseSuccess = (putSupplierIdResponse200) & {
  headers: Headers;
};
;

export type putSupplierIdResponse = (putSupplierIdResponseSuccess)

export const getPutSupplierIdUrl = (id: number,) => {


  

  return `/api/supplier/${id}/`
}

export const putSupplierId = async (id: number,
    supplierCreateUpdate: SupplierCreateUpdate, options?: RequestInit): Promise<putSupplierIdResponse> => {
  
  return putSupplierIdMutator<putSupplierIdResponse>(getPutSupplierIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplierCreateUpdate,)
  }
);}
  



export const getPutSupplierIdMutationOptions = <TError = PutSupplierIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupplierId>>, TError,{id: number;data: SupplierCreateUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putSupplierId>>, TError,{id: number;data: SupplierCreateUpdate}, TContext> => {

const mutationKey = ['putSupplierId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupplierId>>, {id: number;data: SupplierCreateUpdate}> = (props) => {
          const {id,data} = props ?? {};

          return  putSupplierId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutSupplierIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSupplierId>>>
    export type PutSupplierIdMutationBody = SupplierCreateUpdate
    export type PutSupplierIdMutationError = PutSupplierIdErrorType<unknown>

    export const usePutSupplierId = <TError = PutSupplierIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupplierId>>, TError,{id: number;data: SupplierCreateUpdate}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putSupplierId>>,
        TError,
        {id: number;data: SupplierCreateUpdate},
        TContext
      > => {
      return useMutation(getPutSupplierIdMutationOptions(options));
    }
    export type getSupplierIdAvailableProductsResponse200 = {
  data: SupplierProductsList[]
  status: 200
}

export type getSupplierIdAvailableProductsResponseSuccess = (getSupplierIdAvailableProductsResponse200) & {
  headers: Headers;
};
;

export type getSupplierIdAvailableProductsResponse = (getSupplierIdAvailableProductsResponseSuccess)

export const getGetSupplierIdAvailableProductsUrl = (id: number,
    params?: GetSupplierIdAvailableProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/supplier/${id}/available-products/?${stringifiedParams}` : `/api/supplier/${id}/available-products/`
}

export const getSupplierIdAvailableProducts = async (id: number,
    params?: GetSupplierIdAvailableProductsParams, options?: RequestInit): Promise<getSupplierIdAvailableProductsResponse> => {
  
  return getSupplierIdAvailableProductsMutator<getSupplierIdAvailableProductsResponse>(getGetSupplierIdAvailableProductsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSupplierIdAvailableProductsQueryKey = (id: number,
    params?: GetSupplierIdAvailableProductsParams,) => {
    return [
    `/api/supplier/${id}/available-products/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSupplierIdAvailableProductsQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>, TError = GetSupplierIdAvailableProductsErrorType<unknown>>(id: number,
    params?: GetSupplierIdAvailableProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierIdAvailableProductsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>> = ({ signal }) => getSupplierIdAvailableProducts(id,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierIdAvailableProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>>
export type GetSupplierIdAvailableProductsQueryError = GetSupplierIdAvailableProductsErrorType<unknown>



export function useGetSupplierIdAvailableProducts<TData = Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>, TError = GetSupplierIdAvailableProductsErrorType<unknown>>(
 id: number,
    params?: GetSupplierIdAvailableProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierIdAvailableProducts>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierIdAvailableProductsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putSupplierIdUpdateUsersProductsResponse200 = {
  data: SupplierUpdateUsersProducts
  status: 200
}

export type putSupplierIdUpdateUsersProductsResponseSuccess = (putSupplierIdUpdateUsersProductsResponse200) & {
  headers: Headers;
};
;

export type putSupplierIdUpdateUsersProductsResponse = (putSupplierIdUpdateUsersProductsResponseSuccess)

export const getPutSupplierIdUpdateUsersProductsUrl = (id: number,) => {


  

  return `/api/supplier/${id}/update-users-products/`
}

export const putSupplierIdUpdateUsersProducts = async (id: number,
    supplierUpdateUsersProducts: SupplierUpdateUsersProducts, options?: RequestInit): Promise<putSupplierIdUpdateUsersProductsResponse> => {
  
  return putSupplierIdUpdateUsersProductsMutator<putSupplierIdUpdateUsersProductsResponse>(getPutSupplierIdUpdateUsersProductsUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplierUpdateUsersProducts,)
  }
);}
  



export const getPutSupplierIdUpdateUsersProductsMutationOptions = <TError = PutSupplierIdUpdateUsersProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>, TError,{id: number;data: SupplierUpdateUsersProducts}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>, TError,{id: number;data: SupplierUpdateUsersProducts}, TContext> => {

const mutationKey = ['putSupplierIdUpdateUsersProducts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>, {id: number;data: SupplierUpdateUsersProducts}> = (props) => {
          const {id,data} = props ?? {};

          return  putSupplierIdUpdateUsersProducts(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutSupplierIdUpdateUsersProductsMutationResult = NonNullable<Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>>
    export type PutSupplierIdUpdateUsersProductsMutationBody = SupplierUpdateUsersProducts
    export type PutSupplierIdUpdateUsersProductsMutationError = PutSupplierIdUpdateUsersProductsErrorType<unknown>

    export const usePutSupplierIdUpdateUsersProducts = <TError = PutSupplierIdUpdateUsersProductsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>, TError,{id: number;data: SupplierUpdateUsersProducts}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putSupplierIdUpdateUsersProducts>>,
        TError,
        {id: number;data: SupplierUpdateUsersProducts},
        TContext
      > => {
      return useMutation(getPutSupplierIdUpdateUsersProductsMutationOptions(options));
    }
    export type getSupplierFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getSupplierFiltersFilterNameResponseSuccess = (getSupplierFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getSupplierFiltersFilterNameResponse = (getSupplierFiltersFilterNameResponseSuccess)

export const getGetSupplierFiltersFilterNameUrl = (filterName: string,
    params?: GetSupplierFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/supplier/filters/${filterName}/?${stringifiedParams}` : `/api/supplier/filters/${filterName}/`
}

export const getSupplierFiltersFilterName = async (filterName: string,
    params?: GetSupplierFiltersFilterNameParams, options?: RequestInit): Promise<getSupplierFiltersFilterNameResponse> => {
  
  return getSupplierFiltersFilterNameMutator<getSupplierFiltersFilterNameResponse>(getGetSupplierFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSupplierFiltersFilterNameQueryKey = (filterName: string,
    params?: GetSupplierFiltersFilterNameParams,) => {
    return [
    `/api/supplier/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSupplierFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierFiltersFilterName>>, TError = GetSupplierFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetSupplierFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierFiltersFilterName>>> = ({ signal }) => getSupplierFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierFiltersFilterName>>>
export type GetSupplierFiltersFilterNameQueryError = GetSupplierFiltersFilterNameErrorType<unknown>



export function useGetSupplierFiltersFilterName<TData = Awaited<ReturnType<typeof getSupplierFiltersFilterName>>, TError = GetSupplierFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetSupplierFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postSupplierManageResponse200 = {
  data: ManageActionResult
  status: 200
}

export type postSupplierManageResponseSuccess = (postSupplierManageResponse200) & {
  headers: Headers;
};
;

export type postSupplierManageResponse = (postSupplierManageResponseSuccess)

export const getPostSupplierManageUrl = () => {


  

  return `/api/supplier/manage/`
}

export const postSupplierManage = async (supplierManage: SupplierManage, options?: RequestInit): Promise<postSupplierManageResponse> => {
  
  return postSupplierManageMutator<postSupplierManageResponse>(getPostSupplierManageUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      supplierManage,)
  }
);}
  



export const getPostSupplierManageMutationOptions = <TError = PostSupplierManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupplierManage>>, TError,{data: SupplierManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSupplierManage>>, TError,{data: SupplierManage}, TContext> => {

const mutationKey = ['postSupplierManage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupplierManage>>, {data: SupplierManage}> = (props) => {
          const {data} = props ?? {};

          return  postSupplierManage(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostSupplierManageMutationResult = NonNullable<Awaited<ReturnType<typeof postSupplierManage>>>
    export type PostSupplierManageMutationBody = SupplierManage
    export type PostSupplierManageMutationError = PostSupplierManageErrorType<unknown>

    export const usePostSupplierManage = <TError = PostSupplierManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupplierManage>>, TError,{data: SupplierManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postSupplierManage>>,
        TError,
        {data: SupplierManage},
        TContext
      > => {
      return useMutation(getPostSupplierManageMutationOptions(options));
    }
    export type getSupplierPaginatedResponse200 = {
  data: PaginatedSupplierPaginatedListList
  status: 200
}

export type getSupplierPaginatedResponseSuccess = (getSupplierPaginatedResponse200) & {
  headers: Headers;
};
;

export type getSupplierPaginatedResponse = (getSupplierPaginatedResponseSuccess)

export const getGetSupplierPaginatedUrl = (params?: GetSupplierPaginatedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/supplier/paginated/?${stringifiedParams}` : `/api/supplier/paginated/`
}

export const getSupplierPaginated = async (params?: GetSupplierPaginatedParams, options?: RequestInit): Promise<getSupplierPaginatedResponse> => {
  
  return getSupplierPaginatedMutator<getSupplierPaginatedResponse>(getGetSupplierPaginatedUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetSupplierPaginatedQueryKey = (params?: GetSupplierPaginatedParams,) => {
    return [
    `/api/supplier/paginated/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetSupplierPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getSupplierPaginated>>, TError = GetSupplierPaginatedErrorType<unknown>>(params?: GetSupplierPaginatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierPaginated>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupplierPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplierPaginated>>> = ({ signal }) => getSupplierPaginated(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupplierPaginated>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupplierPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getSupplierPaginated>>>
export type GetSupplierPaginatedQueryError = GetSupplierPaginatedErrorType<unknown>



export function useGetSupplierPaginated<TData = Awaited<ReturnType<typeof getSupplierPaginated>>, TError = GetSupplierPaginatedErrorType<unknown>>(
 params?: GetSupplierPaginatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupplierPaginated>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSupplierPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getTradingWeeksCurrentResponse200 = {
  data: TradingRange
  status: 200
}

export type getTradingWeeksCurrentResponseSuccess = (getTradingWeeksCurrentResponse200) & {
  headers: Headers;
};
;

export type getTradingWeeksCurrentResponse = (getTradingWeeksCurrentResponseSuccess)

export const getGetTradingWeeksCurrentUrl = () => {


  

  return `/api/trading-weeks/current/`
}

export const getTradingWeeksCurrent = async ( options?: RequestInit): Promise<getTradingWeeksCurrentResponse> => {
  
  return getTradingWeeksCurrentMutator<getTradingWeeksCurrentResponse>(getGetTradingWeeksCurrentUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetTradingWeeksCurrentQueryKey = () => {
    return [
    `/api/trading-weeks/current/`
    ] as const;
    }

    
export const getGetTradingWeeksCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getTradingWeeksCurrent>>, TError = GetTradingWeeksCurrentErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksCurrent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingWeeksCurrentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingWeeksCurrent>>> = ({ signal }) => getTradingWeeksCurrent({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksCurrent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTradingWeeksCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingWeeksCurrent>>>
export type GetTradingWeeksCurrentQueryError = GetTradingWeeksCurrentErrorType<unknown>



export function useGetTradingWeeksCurrent<TData = Awaited<ReturnType<typeof getTradingWeeksCurrent>>, TError = GetTradingWeeksCurrentErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksCurrent>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTradingWeeksCurrentQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getTradingWeeksNextResponse200 = {
  data: TradingRange
  status: 200
}

export type getTradingWeeksNextResponseSuccess = (getTradingWeeksNextResponse200) & {
  headers: Headers;
};
;

export type getTradingWeeksNextResponse = (getTradingWeeksNextResponseSuccess)

export const getGetTradingWeeksNextUrl = () => {


  

  return `/api/trading-weeks/next/`
}

export const getTradingWeeksNext = async ( options?: RequestInit): Promise<getTradingWeeksNextResponse> => {
  
  return getTradingWeeksNextMutator<getTradingWeeksNextResponse>(getGetTradingWeeksNextUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetTradingWeeksNextQueryKey = () => {
    return [
    `/api/trading-weeks/next/`
    ] as const;
    }

    
export const getGetTradingWeeksNextQueryOptions = <TData = Awaited<ReturnType<typeof getTradingWeeksNext>>, TError = GetTradingWeeksNextErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksNext>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradingWeeksNextQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradingWeeksNext>>> = ({ signal }) => getTradingWeeksNext({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksNext>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTradingWeeksNextQueryResult = NonNullable<Awaited<ReturnType<typeof getTradingWeeksNext>>>
export type GetTradingWeeksNextQueryError = GetTradingWeeksNextErrorType<unknown>



export function useGetTradingWeeksNext<TData = Awaited<ReturnType<typeof getTradingWeeksNext>>, TError = GetTradingWeeksNextErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTradingWeeksNext>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTradingWeeksNextQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getUserResponse200 = {
  data: User
  status: 200
}

export type getUserResponseSuccess = (getUserResponse200) & {
  headers: Headers;
};
;

export type getUserResponse = (getUserResponseSuccess)

export const getGetUserUrl = () => {


  

  return `/api/user/`
}

export const getUser = async ( options?: RequestInit): Promise<getUserResponse> => {
  
  return getUserMutator<getUserResponse>(getGetUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserQueryKey = () => {
    return [
    `/api/user/`
    ] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = GetUserErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = GetUserErrorType<unknown>



export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = GetUserErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postUserResponse201 = {
  data: User
  status: 201
}

export type postUserResponseSuccess = (postUserResponse201) & {
  headers: Headers;
};
;

export type postUserResponse = (postUserResponseSuccess)

export const getPostUserUrl = () => {


  

  return `/api/user/`
}

export const postUser = async (user: NonReadonly<User>, options?: RequestInit): Promise<postUserResponse> => {
  
  return postUserMutator<postUserResponse>(getPostUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      user,)
  }
);}
  



export const getPostUserMutationOptions = <TError = PostUserErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: NonReadonly<User>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: NonReadonly<User>}, TContext> => {

const mutationKey = ['postUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUser>>, {data: NonReadonly<User>}> = (props) => {
          const {data} = props ?? {};

          return  postUser(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserMutationResult = NonNullable<Awaited<ReturnType<typeof postUser>>>
    export type PostUserMutationBody = NonReadonly<User>
    export type PostUserMutationError = PostUserErrorType<unknown>

    export const usePostUser = <TError = PostUserErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: NonReadonly<User>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUser>>,
        TError,
        {data: NonReadonly<User>},
        TContext
      > => {
      return useMutation(getPostUserMutationOptions(options));
    }
    export type patchUserResponse200 = {
  data: User
  status: 200
}

export type patchUserResponseSuccess = (patchUserResponse200) & {
  headers: Headers;
};
;

export type patchUserResponse = (patchUserResponseSuccess)

export const getPatchUserUrl = () => {


  

  return `/api/user/`
}

export const patchUser = async (patchedUser: NonReadonly<PatchedUser>, options?: RequestInit): Promise<patchUserResponse> => {
  
  return patchUserMutator<patchUserResponse>(getPatchUserUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedUser,)
  }
);}
  



export const getPatchUserMutationOptions = <TError = PatchUserErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{data: NonReadonly<PatchedUser>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{data: NonReadonly<PatchedUser>}, TContext> => {

const mutationKey = ['patchUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUser>>, {data: NonReadonly<PatchedUser>}> = (props) => {
          const {data} = props ?? {};

          return  patchUser(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserMutationResult = NonNullable<Awaited<ReturnType<typeof patchUser>>>
    export type PatchUserMutationBody = NonReadonly<PatchedUser>
    export type PatchUserMutationError = PatchUserErrorType<unknown>

    export const usePatchUser = <TError = PatchUserErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{data: NonReadonly<PatchedUser>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchUser>>,
        TError,
        {data: NonReadonly<PatchedUser>},
        TContext
      > => {
      return useMutation(getPatchUserMutationOptions(options));
    }
    export type getUserContractorsResponse200 = {
  data: ContractorList[]
  status: 200
}

export type getUserContractorsResponseSuccess = (getUserContractorsResponse200) & {
  headers: Headers;
};
;

export type getUserContractorsResponse = (getUserContractorsResponseSuccess)

export const getGetUserContractorsUrl = (params?: GetUserContractorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/contractors/?${stringifiedParams}` : `/api/user/contractors/`
}

export const getUserContractors = async (params?: GetUserContractorsParams, options?: RequestInit): Promise<getUserContractorsResponse> => {
  
  return getUserContractorsMutator<getUserContractorsResponse>(getGetUserContractorsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserContractorsQueryKey = (params?: GetUserContractorsParams,) => {
    return [
    `/api/user/contractors/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetUserContractorsQueryOptions = <TData = Awaited<ReturnType<typeof getUserContractors>>, TError = GetUserContractorsErrorType<unknown>>(params?: GetUserContractorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractors>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractorsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContractors>>> = ({ signal }) => getUserContractors(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContractors>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserContractorsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContractors>>>
export type GetUserContractorsQueryError = GetUserContractorsErrorType<unknown>



export function useGetUserContractors<TData = Awaited<ReturnType<typeof getUserContractors>>, TError = GetUserContractorsErrorType<unknown>>(
 params?: GetUserContractorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractors>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserContractorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postUserContractorsResponse201 = {
  data: ContractorCreate
  status: 201
}

export type postUserContractorsResponseSuccess = (postUserContractorsResponse201) & {
  headers: Headers;
};
;

export type postUserContractorsResponse = (postUserContractorsResponseSuccess)

export const getPostUserContractorsUrl = () => {


  

  return `/api/user/contractors/`
}

export const postUserContractors = async (contractorCreate: NonReadonly<ContractorCreate>, options?: RequestInit): Promise<postUserContractorsResponse> => {
  
  return postUserContractorsMutator<postUserContractorsResponse>(getPostUserContractorsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractorCreate,)
  }
);}
  



export const getPostUserContractorsMutationOptions = <TError = PostUserContractorsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContractors>>, TError,{data: NonReadonly<ContractorCreate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserContractors>>, TError,{data: NonReadonly<ContractorCreate>}, TContext> => {

const mutationKey = ['postUserContractors'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserContractors>>, {data: NonReadonly<ContractorCreate>}> = (props) => {
          const {data} = props ?? {};

          return  postUserContractors(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserContractorsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserContractors>>>
    export type PostUserContractorsMutationBody = NonReadonly<ContractorCreate>
    export type PostUserContractorsMutationError = PostUserContractorsErrorType<unknown>

    export const usePostUserContractors = <TError = PostUserContractorsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContractors>>, TError,{data: NonReadonly<ContractorCreate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserContractors>>,
        TError,
        {data: NonReadonly<ContractorCreate>},
        TContext
      > => {
      return useMutation(getPostUserContractorsMutationOptions(options));
    }
    export type getUserContractorsIdResponse200 = {
  data: ContractorUpdate
  status: 200
}

export type getUserContractorsIdResponseSuccess = (getUserContractorsIdResponse200) & {
  headers: Headers;
};
;

export type getUserContractorsIdResponse = (getUserContractorsIdResponseSuccess)

export const getGetUserContractorsIdUrl = (id: number,) => {


  

  return `/api/user/contractors/${id}/`
}

export const getUserContractorsId = async (id: number, options?: RequestInit): Promise<getUserContractorsIdResponse> => {
  
  return getUserContractorsIdMutator<getUserContractorsIdResponse>(getGetUserContractorsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserContractorsIdQueryKey = (id: number,) => {
    return [
    `/api/user/contractors/${id}/`
    ] as const;
    }

    
export const getGetUserContractorsIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserContractorsId>>, TError = GetUserContractorsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractorsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContractorsId>>> = ({ signal }) => getUserContractorsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserContractorsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContractorsId>>>
export type GetUserContractorsIdQueryError = GetUserContractorsIdErrorType<unknown>



export function useGetUserContractorsId<TData = Awaited<ReturnType<typeof getUserContractorsId>>, TError = GetUserContractorsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserContractorsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putUserContractorsIdResponse200 = {
  data: ContractorUpdate
  status: 200
}

export type putUserContractorsIdResponseSuccess = (putUserContractorsIdResponse200) & {
  headers: Headers;
};
;

export type putUserContractorsIdResponse = (putUserContractorsIdResponseSuccess)

export const getPutUserContractorsIdUrl = (id: number,) => {


  

  return `/api/user/contractors/${id}/`
}

export const putUserContractorsId = async (id: number,
    contractorUpdate: NonReadonly<ContractorUpdate>, options?: RequestInit): Promise<putUserContractorsIdResponse> => {
  
  return putUserContractorsIdMutator<putUserContractorsIdResponse>(getPutUserContractorsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractorUpdate,)
  }
);}
  



export const getPutUserContractorsIdMutationOptions = <TError = PutUserContractorsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserContractorsId>>, TError,{id: number;data: NonReadonly<ContractorUpdate>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserContractorsId>>, TError,{id: number;data: NonReadonly<ContractorUpdate>}, TContext> => {

const mutationKey = ['putUserContractorsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserContractorsId>>, {id: number;data: NonReadonly<ContractorUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserContractorsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserContractorsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserContractorsId>>>
    export type PutUserContractorsIdMutationBody = NonReadonly<ContractorUpdate>
    export type PutUserContractorsIdMutationError = PutUserContractorsIdErrorType<unknown>

    export const usePutUserContractorsId = <TError = PutUserContractorsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserContractorsId>>, TError,{id: number;data: NonReadonly<ContractorUpdate>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putUserContractorsId>>,
        TError,
        {id: number;data: NonReadonly<ContractorUpdate>},
        TContext
      > => {
      return useMutation(getPutUserContractorsIdMutationOptions(options));
    }
    export type getUserContractorsFiltersFilterNameResponse200 = {
  data: FilterValues[]
  status: 200
}

export type getUserContractorsFiltersFilterNameResponseSuccess = (getUserContractorsFiltersFilterNameResponse200) & {
  headers: Headers;
};
;

export type getUserContractorsFiltersFilterNameResponse = (getUserContractorsFiltersFilterNameResponseSuccess)

export const getGetUserContractorsFiltersFilterNameUrl = (filterName: string,
    params?: GetUserContractorsFiltersFilterNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/contractors/filters/${filterName}/?${stringifiedParams}` : `/api/user/contractors/filters/${filterName}/`
}

export const getUserContractorsFiltersFilterName = async (filterName: string,
    params?: GetUserContractorsFiltersFilterNameParams, options?: RequestInit): Promise<getUserContractorsFiltersFilterNameResponse> => {
  
  return getUserContractorsFiltersFilterNameMutator<getUserContractorsFiltersFilterNameResponse>(getGetUserContractorsFiltersFilterNameUrl(filterName,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserContractorsFiltersFilterNameQueryKey = (filterName: string,
    params?: GetUserContractorsFiltersFilterNameParams,) => {
    return [
    `/api/user/contractors/filters/${filterName}/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetUserContractorsFiltersFilterNameQueryOptions = <TData = Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>, TError = GetUserContractorsFiltersFilterNameErrorType<unknown>>(filterName: string,
    params?: GetUserContractorsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractorsFiltersFilterNameQueryKey(filterName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>> = ({ signal }) => getUserContractorsFiltersFilterName(filterName,params, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(filterName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserContractorsFiltersFilterNameQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>>
export type GetUserContractorsFiltersFilterNameQueryError = GetUserContractorsFiltersFilterNameErrorType<unknown>



export function useGetUserContractorsFiltersFilterName<TData = Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>, TError = GetUserContractorsFiltersFilterNameErrorType<unknown>>(
 filterName: string,
    params?: GetUserContractorsFiltersFilterNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsFiltersFilterName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserContractorsFiltersFilterNameQueryOptions(filterName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postUserContractorsManageResponse200 = {
  data: Result
  status: 200
}

export type postUserContractorsManageResponseSuccess = (postUserContractorsManageResponse200) & {
  headers: Headers;
};
;

export type postUserContractorsManageResponse = (postUserContractorsManageResponseSuccess)

export const getPostUserContractorsManageUrl = () => {


  

  return `/api/user/contractors/manage/`
}

export const postUserContractorsManage = async (contractorManage: ContractorManage, options?: RequestInit): Promise<postUserContractorsManageResponse> => {
  
  return postUserContractorsManageMutator<postUserContractorsManageResponse>(getPostUserContractorsManageUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractorManage,)
  }
);}
  



export const getPostUserContractorsManageMutationOptions = <TError = PostUserContractorsManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContractorsManage>>, TError,{data: ContractorManage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserContractorsManage>>, TError,{data: ContractorManage}, TContext> => {

const mutationKey = ['postUserContractorsManage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserContractorsManage>>, {data: ContractorManage}> = (props) => {
          const {data} = props ?? {};

          return  postUserContractorsManage(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserContractorsManageMutationResult = NonNullable<Awaited<ReturnType<typeof postUserContractorsManage>>>
    export type PostUserContractorsManageMutationBody = ContractorManage
    export type PostUserContractorsManageMutationError = PostUserContractorsManageErrorType<unknown>

    export const usePostUserContractorsManage = <TError = PostUserContractorsManageErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContractorsManage>>, TError,{data: ContractorManage}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserContractorsManage>>,
        TError,
        {data: ContractorManage},
        TContext
      > => {
      return useMutation(getPostUserContractorsManageMutationOptions(options));
    }
    export type getUserContractorsPaginatedResponse200 = {
  data: PaginatedContractorListList
  status: 200
}

export type getUserContractorsPaginatedResponseSuccess = (getUserContractorsPaginatedResponse200) & {
  headers: Headers;
};
;

export type getUserContractorsPaginatedResponse = (getUserContractorsPaginatedResponseSuccess)

export const getGetUserContractorsPaginatedUrl = (params?: GetUserContractorsPaginatedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/contractors/paginated/?${stringifiedParams}` : `/api/user/contractors/paginated/`
}

export const getUserContractorsPaginated = async (params?: GetUserContractorsPaginatedParams, options?: RequestInit): Promise<getUserContractorsPaginatedResponse> => {
  
  return getUserContractorsPaginatedMutator<getUserContractorsPaginatedResponse>(getGetUserContractorsPaginatedUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserContractorsPaginatedQueryKey = (params?: GetUserContractorsPaginatedParams,) => {
    return [
    `/api/user/contractors/paginated/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetUserContractorsPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getUserContractorsPaginated>>, TError = GetUserContractorsPaginatedErrorType<unknown>>(params?: GetUserContractorsPaginatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsPaginated>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractorsPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContractorsPaginated>>> = ({ signal }) => getUserContractorsPaginated(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsPaginated>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserContractorsPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContractorsPaginated>>>
export type GetUserContractorsPaginatedQueryError = GetUserContractorsPaginatedErrorType<unknown>



export function useGetUserContractorsPaginated<TData = Awaited<ReturnType<typeof getUserContractorsPaginated>>, TError = GetUserContractorsPaginatedErrorType<unknown>>(
 params?: GetUserContractorsPaginatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserContractorsPaginated>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserContractorsPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Проверяем наличие query-параметров отмеченных обязательными в фильтре.

Обязательность параметров/полей в фильтрах (required=True) оказалась не
такой уж обязательной. Очень не хочется распутывать цепочку ошибок на
фильтрациях таблиц в будущем, когда на бекенд придут фильтры не поддерживаемые
конкретной таблицей. Поэтому, получить просто список всех фильтров без
указания принадлежности к таблице - решено запретить.
 */
export type getUserFilterPresetsResponse200 = {
  data: UserFilterPreset[]
  status: 200
}

export type getUserFilterPresetsResponseSuccess = (getUserFilterPresetsResponse200) & {
  headers: Headers;
};
;

export type getUserFilterPresetsResponse = (getUserFilterPresetsResponseSuccess)

export const getGetUserFilterPresetsUrl = (params: GetUserFilterPresetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/user/filter-presets/?${stringifiedParams}` : `/api/user/filter-presets/`
}

export const getUserFilterPresets = async (params: GetUserFilterPresetsParams, options?: RequestInit): Promise<getUserFilterPresetsResponse> => {
  
  return getUserFilterPresetsMutator<getUserFilterPresetsResponse>(getGetUserFilterPresetsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserFilterPresetsQueryKey = (params?: GetUserFilterPresetsParams,) => {
    return [
    `/api/user/filter-presets/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetUserFilterPresetsQueryOptions = <TData = Awaited<ReturnType<typeof getUserFilterPresets>>, TError = GetUserFilterPresetsErrorType<unknown>>(params: GetUserFilterPresetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresets>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFilterPresetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFilterPresets>>> = ({ signal }) => getUserFilterPresets(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserFilterPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFilterPresets>>>
export type GetUserFilterPresetsQueryError = GetUserFilterPresetsErrorType<unknown>



export function useGetUserFilterPresets<TData = Awaited<ReturnType<typeof getUserFilterPresets>>, TError = GetUserFilterPresetsErrorType<unknown>>(
 params: GetUserFilterPresetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresets>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserFilterPresetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postUserFilterPresetsResponse201 = {
  data: UserFilterPreset
  status: 201
}

export type postUserFilterPresetsResponseSuccess = (postUserFilterPresetsResponse201) & {
  headers: Headers;
};
;

export type postUserFilterPresetsResponse = (postUserFilterPresetsResponseSuccess)

export const getPostUserFilterPresetsUrl = () => {


  

  return `/api/user/filter-presets/`
}

export const postUserFilterPresets = async (userFilterPreset: NonReadonly<UserFilterPreset>, options?: RequestInit): Promise<postUserFilterPresetsResponse> => {
  
  return postUserFilterPresetsMutator<postUserFilterPresetsResponse>(getPostUserFilterPresetsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userFilterPreset,)
  }
);}
  



export const getPostUserFilterPresetsMutationOptions = <TError = PostUserFilterPresetsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFilterPresets>>, TError,{data: NonReadonly<UserFilterPreset>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserFilterPresets>>, TError,{data: NonReadonly<UserFilterPreset>}, TContext> => {

const mutationKey = ['postUserFilterPresets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFilterPresets>>, {data: NonReadonly<UserFilterPreset>}> = (props) => {
          const {data} = props ?? {};

          return  postUserFilterPresets(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserFilterPresetsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFilterPresets>>>
    export type PostUserFilterPresetsMutationBody = NonReadonly<UserFilterPreset>
    export type PostUserFilterPresetsMutationError = PostUserFilterPresetsErrorType<unknown>

    export const usePostUserFilterPresets = <TError = PostUserFilterPresetsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFilterPresets>>, TError,{data: NonReadonly<UserFilterPreset>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserFilterPresets>>,
        TError,
        {data: NonReadonly<UserFilterPreset>},
        TContext
      > => {
      return useMutation(getPostUserFilterPresetsMutationOptions(options));
    }
    export type getUserFilterPresetsIdResponse200 = {
  data: UserFilterPreset
  status: 200
}

export type getUserFilterPresetsIdResponseSuccess = (getUserFilterPresetsIdResponse200) & {
  headers: Headers;
};
;

export type getUserFilterPresetsIdResponse = (getUserFilterPresetsIdResponseSuccess)

export const getGetUserFilterPresetsIdUrl = (id: number,) => {


  

  return `/api/user/filter-presets/${id}/`
}

export const getUserFilterPresetsId = async (id: number, options?: RequestInit): Promise<getUserFilterPresetsIdResponse> => {
  
  return getUserFilterPresetsIdMutator<getUserFilterPresetsIdResponse>(getGetUserFilterPresetsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserFilterPresetsIdQueryKey = (id: number,) => {
    return [
    `/api/user/filter-presets/${id}/`
    ] as const;
    }

    
export const getGetUserFilterPresetsIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserFilterPresetsId>>, TError = GetUserFilterPresetsIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresetsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFilterPresetsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFilterPresetsId>>> = ({ signal }) => getUserFilterPresetsId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresetsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserFilterPresetsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFilterPresetsId>>>
export type GetUserFilterPresetsIdQueryError = GetUserFilterPresetsIdErrorType<unknown>



export function useGetUserFilterPresetsId<TData = Awaited<ReturnType<typeof getUserFilterPresetsId>>, TError = GetUserFilterPresetsIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFilterPresetsId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserFilterPresetsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type patchUserFilterPresetsIdResponse200 = {
  data: UserFilterPreset
  status: 200
}

export type patchUserFilterPresetsIdResponseSuccess = (patchUserFilterPresetsIdResponse200) & {
  headers: Headers;
};
;

export type patchUserFilterPresetsIdResponse = (patchUserFilterPresetsIdResponseSuccess)

export const getPatchUserFilterPresetsIdUrl = (id: number,) => {


  

  return `/api/user/filter-presets/${id}/`
}

export const patchUserFilterPresetsId = async (id: number,
    patchedUserFilterPreset: NonReadonly<PatchedUserFilterPreset>, options?: RequestInit): Promise<patchUserFilterPresetsIdResponse> => {
  
  return patchUserFilterPresetsIdMutator<patchUserFilterPresetsIdResponse>(getPatchUserFilterPresetsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedUserFilterPreset,)
  }
);}
  



export const getPatchUserFilterPresetsIdMutationOptions = <TError = PatchUserFilterPresetsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserFilterPresetsId>>, TError,{id: number;data: NonReadonly<PatchedUserFilterPreset>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserFilterPresetsId>>, TError,{id: number;data: NonReadonly<PatchedUserFilterPreset>}, TContext> => {

const mutationKey = ['patchUserFilterPresetsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserFilterPresetsId>>, {id: number;data: NonReadonly<PatchedUserFilterPreset>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserFilterPresetsId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserFilterPresetsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserFilterPresetsId>>>
    export type PatchUserFilterPresetsIdMutationBody = NonReadonly<PatchedUserFilterPreset>
    export type PatchUserFilterPresetsIdMutationError = PatchUserFilterPresetsIdErrorType<unknown>

    export const usePatchUserFilterPresetsId = <TError = PatchUserFilterPresetsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserFilterPresetsId>>, TError,{id: number;data: NonReadonly<PatchedUserFilterPreset>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchUserFilterPresetsId>>,
        TError,
        {id: number;data: NonReadonly<PatchedUserFilterPreset>},
        TContext
      > => {
      return useMutation(getPatchUserFilterPresetsIdMutationOptions(options));
    }
    export type deleteUserFilterPresetsIdResponse204 = {
  data: void
  status: 204
}

export type deleteUserFilterPresetsIdResponseSuccess = (deleteUserFilterPresetsIdResponse204) & {
  headers: Headers;
};
;

export type deleteUserFilterPresetsIdResponse = (deleteUserFilterPresetsIdResponseSuccess)

export const getDeleteUserFilterPresetsIdUrl = (id: number,) => {


  

  return `/api/user/filter-presets/${id}/`
}

export const deleteUserFilterPresetsId = async (id: number, options?: RequestInit): Promise<deleteUserFilterPresetsIdResponse> => {
  
  return deleteUserFilterPresetsIdMutator<deleteUserFilterPresetsIdResponse>(getDeleteUserFilterPresetsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteUserFilterPresetsIdMutationOptions = <TError = DeleteUserFilterPresetsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFilterPresetsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserFilterPresetsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteUserFilterPresetsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserFilterPresetsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserFilterPresetsId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFilterPresetsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserFilterPresetsId>>>
    
    export type DeleteUserFilterPresetsIdMutationError = DeleteUserFilterPresetsIdErrorType<unknown>

    export const useDeleteUserFilterPresetsId = <TError = DeleteUserFilterPresetsIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserFilterPresetsId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserFilterPresetsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteUserFilterPresetsIdMutationOptions(options));
    }
    /**
 * Takes a set of user credentials and returns an access and refresh JSON web
token pair to prove the authentication of those credentials.
 */
export type postUserLoginResponse200 = {
  data: UserLoginResponse
  status: 200
}

export type postUserLoginResponseSuccess = (postUserLoginResponse200) & {
  headers: Headers;
};
;

export type postUserLoginResponse = (postUserLoginResponseSuccess)

export const getPostUserLoginUrl = () => {


  

  return `/api/user/login`
}

export const postUserLogin = async (userLogin: UserLogin, options?: RequestInit): Promise<postUserLoginResponse> => {
  
  return postUserLoginMutator<postUserLoginResponse>(getPostUserLoginUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userLogin,)
  }
);}
  



export const getPostUserLoginMutationOptions = <TError = PostUserLoginErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: UserLogin}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: UserLogin}, TContext> => {

const mutationKey = ['postUserLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserLogin>>, {data: UserLogin}> = (props) => {
          const {data} = props ?? {};

          return  postUserLogin(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postUserLogin>>>
    export type PostUserLoginMutationBody = UserLogin
    export type PostUserLoginMutationError = PostUserLoginErrorType<unknown>

    export const usePostUserLogin = <TError = PostUserLoginErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: UserLogin}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserLogin>>,
        TError,
        {data: UserLogin},
        TContext
      > => {
      return useMutation(getPostUserLoginMutationOptions(options));
    }
    export type postUserOtpVerifyResponse200 = {
  data: UserLoginResponse
  status: 200
}

export type postUserOtpVerifyResponseSuccess = (postUserOtpVerifyResponse200) & {
  headers: Headers;
};
;

export type postUserOtpVerifyResponse = (postUserOtpVerifyResponseSuccess)

export const getPostUserOtpVerifyUrl = () => {


  

  return `/api/user/otp/verify/`
}

export const postUserOtpVerify = async (oTPVerify: OTPVerify, options?: RequestInit): Promise<postUserOtpVerifyResponse> => {
  
  return postUserOtpVerifyMutator<postUserOtpVerifyResponse>(getPostUserOtpVerifyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oTPVerify,)
  }
);}
  



export const getPostUserOtpVerifyMutationOptions = <TError = PostUserOtpVerifyErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserOtpVerify>>, TError,{data: OTPVerify}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserOtpVerify>>, TError,{data: OTPVerify}, TContext> => {

const mutationKey = ['postUserOtpVerify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserOtpVerify>>, {data: OTPVerify}> = (props) => {
          const {data} = props ?? {};

          return  postUserOtpVerify(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserOtpVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postUserOtpVerify>>>
    export type PostUserOtpVerifyMutationBody = OTPVerify
    export type PostUserOtpVerifyMutationError = PostUserOtpVerifyErrorType<unknown>

    export const usePostUserOtpVerify = <TError = PostUserOtpVerifyErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserOtpVerify>>, TError,{data: OTPVerify}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserOtpVerify>>,
        TError,
        {data: OTPVerify},
        TContext
      > => {
      return useMutation(getPostUserOtpVerifyMutationOptions(options));
    }
    export type postUserPasswordResetCheckTokenResponse204 = {
  data: void
  status: 204
}

export type postUserPasswordResetCheckTokenResponseSuccess = (postUserPasswordResetCheckTokenResponse204) & {
  headers: Headers;
};
;

export type postUserPasswordResetCheckTokenResponse = (postUserPasswordResetCheckTokenResponseSuccess)

export const getPostUserPasswordResetCheckTokenUrl = () => {


  

  return `/api/user/password_reset/check_token/`
}

export const postUserPasswordResetCheckToken = async (passwordResetToken: PasswordResetToken, options?: RequestInit): Promise<postUserPasswordResetCheckTokenResponse> => {
  
  return postUserPasswordResetCheckTokenMutator<postUserPasswordResetCheckTokenResponse>(getPostUserPasswordResetCheckTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      passwordResetToken,)
  }
);}
  



export const getPostUserPasswordResetCheckTokenMutationOptions = <TError = PostUserPasswordResetCheckTokenErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>, TError,{data: PasswordResetToken}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>, TError,{data: PasswordResetToken}, TContext> => {

const mutationKey = ['postUserPasswordResetCheckToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>, {data: PasswordResetToken}> = (props) => {
          const {data} = props ?? {};

          return  postUserPasswordResetCheckToken(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserPasswordResetCheckTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>>
    export type PostUserPasswordResetCheckTokenMutationBody = PasswordResetToken
    export type PostUserPasswordResetCheckTokenMutationError = PostUserPasswordResetCheckTokenErrorType<unknown>

    export const usePostUserPasswordResetCheckToken = <TError = PostUserPasswordResetCheckTokenErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>, TError,{data: PasswordResetToken}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserPasswordResetCheckToken>>,
        TError,
        {data: PasswordResetToken},
        TContext
      > => {
      return useMutation(getPostUserPasswordResetCheckTokenMutationOptions(options));
    }
    export type postUserPasswordResetRequestTokenResponse204 = {
  data: void
  status: 204
}

export type postUserPasswordResetRequestTokenResponseSuccess = (postUserPasswordResetRequestTokenResponse204) & {
  headers: Headers;
};
;

export type postUserPasswordResetRequestTokenResponse = (postUserPasswordResetRequestTokenResponseSuccess)

export const getPostUserPasswordResetRequestTokenUrl = () => {


  

  return `/api/user/password_reset/request_token/`
}

export const postUserPasswordResetRequestToken = async (passwordResetUsername: PasswordResetUsername, options?: RequestInit): Promise<postUserPasswordResetRequestTokenResponse> => {
  
  return postUserPasswordResetRequestTokenMutator<postUserPasswordResetRequestTokenResponse>(getPostUserPasswordResetRequestTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      passwordResetUsername,)
  }
);}
  



export const getPostUserPasswordResetRequestTokenMutationOptions = <TError = PostUserPasswordResetRequestTokenErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>, TError,{data: PasswordResetUsername}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>, TError,{data: PasswordResetUsername}, TContext> => {

const mutationKey = ['postUserPasswordResetRequestToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>, {data: PasswordResetUsername}> = (props) => {
          const {data} = props ?? {};

          return  postUserPasswordResetRequestToken(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserPasswordResetRequestTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>>
    export type PostUserPasswordResetRequestTokenMutationBody = PasswordResetUsername
    export type PostUserPasswordResetRequestTokenMutationError = PostUserPasswordResetRequestTokenErrorType<unknown>

    export const usePostUserPasswordResetRequestToken = <TError = PostUserPasswordResetRequestTokenErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>, TError,{data: PasswordResetUsername}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserPasswordResetRequestToken>>,
        TError,
        {data: PasswordResetUsername},
        TContext
      > => {
      return useMutation(getPostUserPasswordResetRequestTokenMutationOptions(options));
    }
    export type postUserPasswordResetSetPasswordResponse204 = {
  data: void
  status: 204
}

export type postUserPasswordResetSetPasswordResponseSuccess = (postUserPasswordResetSetPasswordResponse204) & {
  headers: Headers;
};
;

export type postUserPasswordResetSetPasswordResponse = (postUserPasswordResetSetPasswordResponseSuccess)

export const getPostUserPasswordResetSetPasswordUrl = () => {


  

  return `/api/user/password_reset/set_password/`
}

export const postUserPasswordResetSetPassword = async (passwordReset: PasswordReset, options?: RequestInit): Promise<postUserPasswordResetSetPasswordResponse> => {
  
  return postUserPasswordResetSetPasswordMutator<postUserPasswordResetSetPasswordResponse>(getPostUserPasswordResetSetPasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      passwordReset,)
  }
);}
  



export const getPostUserPasswordResetSetPasswordMutationOptions = <TError = PostUserPasswordResetSetPasswordErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>, TError,{data: PasswordReset}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>, TError,{data: PasswordReset}, TContext> => {

const mutationKey = ['postUserPasswordResetSetPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>, {data: PasswordReset}> = (props) => {
          const {data} = props ?? {};

          return  postUserPasswordResetSetPassword(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserPasswordResetSetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>>
    export type PostUserPasswordResetSetPasswordMutationBody = PasswordReset
    export type PostUserPasswordResetSetPasswordMutationError = PostUserPasswordResetSetPasswordErrorType<unknown>

    export const usePostUserPasswordResetSetPassword = <TError = PostUserPasswordResetSetPasswordErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>, TError,{data: PasswordReset}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postUserPasswordResetSetPassword>>,
        TError,
        {data: PasswordReset},
        TContext
      > => {
      return useMutation(getPostUserPasswordResetSetPasswordMutationOptions(options));
    }
    /**
 * Получение списка менеджеров с ролью rvi, is_active=True, is_archived=False.
 */
export type getUserRviResponse200 = {
  data: UserBase[]
  status: 200
}

export type getUserRviResponseSuccess = (getUserRviResponse200) & {
  headers: Headers;
};
;

export type getUserRviResponse = (getUserRviResponseSuccess)

export const getGetUserRviUrl = () => {


  

  return `/api/user/rvi/`
}

export const getUserRvi = async ( options?: RequestInit): Promise<getUserRviResponse> => {
  
  return getUserRviMutator<getUserRviResponse>(getGetUserRviUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetUserRviQueryKey = () => {
    return [
    `/api/user/rvi/`
    ] as const;
    }

    
export const getGetUserRviQueryOptions = <TData = Awaited<ReturnType<typeof getUserRvi>>, TError = GetUserRviErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRvi>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRviQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRvi>>> = ({ signal }) => getUserRvi({ signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRvi>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRviQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRvi>>>
export type GetUserRviQueryError = GetUserRviErrorType<unknown>



export function useGetUserRvi<TData = Awaited<ReturnType<typeof getUserRvi>>, TError = GetUserRviErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRvi>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserRviQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type getVolumesResponse200 = {
  data: ProductVolume[]
  status: 200
}

export type getVolumesResponseSuccess = (getVolumesResponse200) & {
  headers: Headers;
};
;

export type getVolumesResponse = (getVolumesResponseSuccess)

export const getGetVolumesUrl = (params?: GetVolumesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/volumes/?${stringifiedParams}` : `/api/volumes/`
}

export const getVolumes = async (params?: GetVolumesParams, options?: RequestInit): Promise<getVolumesResponse> => {
  
  return getVolumesMutator<getVolumesResponse>(getGetVolumesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetVolumesQueryKey = (params?: GetVolumesParams,) => {
    return [
    `/api/volumes/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetVolumesQueryOptions = <TData = Awaited<ReturnType<typeof getVolumes>>, TError = GetVolumesErrorType<unknown>>(params?: GetVolumesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVolumes>>> = ({ signal }) => getVolumes(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVolumesQueryResult = NonNullable<Awaited<ReturnType<typeof getVolumes>>>
export type GetVolumesQueryError = GetVolumesErrorType<unknown>



export function useGetVolumes<TData = Awaited<ReturnType<typeof getVolumes>>, TError = GetVolumesErrorType<unknown>>(
 params?: GetVolumesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVolumesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postVolumesResponse201 = {
  data: ProductVolume
  status: 201
}

export type postVolumesResponseSuccess = (postVolumesResponse201) & {
  headers: Headers;
};
;

export type postVolumesResponse = (postVolumesResponseSuccess)

export const getPostVolumesUrl = () => {


  

  return `/api/volumes/`
}

export const postVolumes = async (productVolume: NonReadonly<ProductVolume>, options?: RequestInit): Promise<postVolumesResponse> => {
  
  return postVolumesMutator<postVolumesResponse>(getPostVolumesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productVolume,)
  }
);}
  



export const getPostVolumesMutationOptions = <TError = PostVolumesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumes>>, TError,{data: NonReadonly<ProductVolume>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postVolumes>>, TError,{data: NonReadonly<ProductVolume>}, TContext> => {

const mutationKey = ['postVolumes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVolumes>>, {data: NonReadonly<ProductVolume>}> = (props) => {
          const {data} = props ?? {};

          return  postVolumes(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostVolumesMutationResult = NonNullable<Awaited<ReturnType<typeof postVolumes>>>
    export type PostVolumesMutationBody = NonReadonly<ProductVolume>
    export type PostVolumesMutationError = PostVolumesErrorType<unknown>

    export const usePostVolumes = <TError = PostVolumesErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumes>>, TError,{data: NonReadonly<ProductVolume>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVolumes>>,
        TError,
        {data: NonReadonly<ProductVolume>},
        TContext
      > => {
      return useMutation(getPostVolumesMutationOptions(options));
    }
    export type getVolumesIdResponse200 = {
  data: ProductVolume
  status: 200
}

export type getVolumesIdResponseSuccess = (getVolumesIdResponse200) & {
  headers: Headers;
};
;

export type getVolumesIdResponse = (getVolumesIdResponseSuccess)

export const getGetVolumesIdUrl = (id: number,) => {


  

  return `/api/volumes/${id}/`
}

export const getVolumesId = async (id: number, options?: RequestInit): Promise<getVolumesIdResponse> => {
  
  return getVolumesIdMutator<getVolumesIdResponse>(getGetVolumesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetVolumesIdQueryKey = (id: number,) => {
    return [
    `/api/volumes/${id}/`
    ] as const;
    }

    
export const getGetVolumesIdQueryOptions = <TData = Awaited<ReturnType<typeof getVolumesId>>, TError = GetVolumesIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVolumesId>>> = ({ signal }) => getVolumesId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVolumesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVolumesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVolumesId>>>
export type GetVolumesIdQueryError = GetVolumesIdErrorType<unknown>



export function useGetVolumesId<TData = Awaited<ReturnType<typeof getVolumesId>>, TError = GetVolumesIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVolumesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putVolumesIdResponse200 = {
  data: ProductVolume
  status: 200
}

export type putVolumesIdResponseSuccess = (putVolumesIdResponse200) & {
  headers: Headers;
};
;

export type putVolumesIdResponse = (putVolumesIdResponseSuccess)

export const getPutVolumesIdUrl = (id: number,) => {


  

  return `/api/volumes/${id}/`
}

export const putVolumesId = async (id: number,
    productVolume: NonReadonly<ProductVolume>, options?: RequestInit): Promise<putVolumesIdResponse> => {
  
  return putVolumesIdMutator<putVolumesIdResponse>(getPutVolumesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      productVolume,)
  }
);}
  



export const getPutVolumesIdMutationOptions = <TError = PutVolumesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesId>>, TError,{id: number;data: NonReadonly<ProductVolume>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVolumesId>>, TError,{id: number;data: NonReadonly<ProductVolume>}, TContext> => {

const mutationKey = ['putVolumesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVolumesId>>, {id: number;data: NonReadonly<ProductVolume>}> = (props) => {
          const {id,data} = props ?? {};

          return  putVolumesId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutVolumesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putVolumesId>>>
    export type PutVolumesIdMutationBody = NonReadonly<ProductVolume>
    export type PutVolumesIdMutationError = PutVolumesIdErrorType<unknown>

    export const usePutVolumesId = <TError = PutVolumesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesId>>, TError,{id: number;data: NonReadonly<ProductVolume>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putVolumesId>>,
        TError,
        {id: number;data: NonReadonly<ProductVolume>},
        TContext
      > => {
      return useMutation(getPutVolumesIdMutationOptions(options));
    }
    export type deleteVolumesIdResponse204 = {
  data: void
  status: 204
}

export type deleteVolumesIdResponseSuccess = (deleteVolumesIdResponse204) & {
  headers: Headers;
};
;

export type deleteVolumesIdResponse = (deleteVolumesIdResponseSuccess)

export const getDeleteVolumesIdUrl = (id: number,) => {


  

  return `/api/volumes/${id}/`
}

export const deleteVolumesId = async (id: number, options?: RequestInit): Promise<deleteVolumesIdResponse> => {
  
  return deleteVolumesIdMutator<deleteVolumesIdResponse>(getDeleteVolumesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteVolumesIdMutationOptions = <TError = DeleteVolumesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVolumesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVolumesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVolumesId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVolumesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVolumesId>>>
    
    export type DeleteVolumesIdMutationError = DeleteVolumesIdErrorType<unknown>

    export const useDeleteVolumesId = <TError = DeleteVolumesIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVolumesId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVolumesIdMutationOptions(options));
    }
    /**
 * Получение списка потребностей на ХАБ/РЦ
 */
export type getVolumesDeliveryPointVolumeResponse200 = {
  data: DeliveryPointVolume[]
  status: 200
}

export type getVolumesDeliveryPointVolumeResponseSuccess = (getVolumesDeliveryPointVolumeResponse200) & {
  headers: Headers;
};
;

export type getVolumesDeliveryPointVolumeResponse = (getVolumesDeliveryPointVolumeResponseSuccess)

export const getGetVolumesDeliveryPointVolumeUrl = (params?: GetVolumesDeliveryPointVolumeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/volumes/delivery_point_volume/?${stringifiedParams}` : `/api/volumes/delivery_point_volume/`
}

export const getVolumesDeliveryPointVolume = async (params?: GetVolumesDeliveryPointVolumeParams, options?: RequestInit): Promise<getVolumesDeliveryPointVolumeResponse> => {
  
  return getVolumesDeliveryPointVolumeMutator<getVolumesDeliveryPointVolumeResponse>(getGetVolumesDeliveryPointVolumeUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetVolumesDeliveryPointVolumeQueryKey = (params?: GetVolumesDeliveryPointVolumeParams,) => {
    return [
    `/api/volumes/delivery_point_volume/`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetVolumesDeliveryPointVolumeQueryOptions = <TData = Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>, TError = GetVolumesDeliveryPointVolumeErrorType<unknown>>(params?: GetVolumesDeliveryPointVolumeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumesDeliveryPointVolumeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>> = ({ signal }) => getVolumesDeliveryPointVolume(params, { signal });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVolumesDeliveryPointVolumeQueryResult = NonNullable<Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>>
export type GetVolumesDeliveryPointVolumeQueryError = GetVolumesDeliveryPointVolumeErrorType<unknown>



export function useGetVolumesDeliveryPointVolume<TData = Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>, TError = GetVolumesDeliveryPointVolumeErrorType<unknown>>(
 params?: GetVolumesDeliveryPointVolumeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolume>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVolumesDeliveryPointVolumeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type postVolumesDeliveryPointVolumeResponse201 = {
  data: DeliveryPointVolume
  status: 201
}

export type postVolumesDeliveryPointVolumeResponseSuccess = (postVolumesDeliveryPointVolumeResponse201) & {
  headers: Headers;
};
;

export type postVolumesDeliveryPointVolumeResponse = (postVolumesDeliveryPointVolumeResponseSuccess)

export const getPostVolumesDeliveryPointVolumeUrl = () => {


  

  return `/api/volumes/delivery_point_volume/`
}

export const postVolumesDeliveryPointVolume = async (deliveryPointVolume: NonReadonly<DeliveryPointVolume>, options?: RequestInit): Promise<postVolumesDeliveryPointVolumeResponse> => {
  
  return postVolumesDeliveryPointVolumeMutator<postVolumesDeliveryPointVolumeResponse>(getPostVolumesDeliveryPointVolumeUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deliveryPointVolume,)
  }
);}
  



export const getPostVolumesDeliveryPointVolumeMutationOptions = <TError = PostVolumesDeliveryPointVolumeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>, TError,{data: NonReadonly<DeliveryPointVolume>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>, TError,{data: NonReadonly<DeliveryPointVolume>}, TContext> => {

const mutationKey = ['postVolumesDeliveryPointVolume'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>, {data: NonReadonly<DeliveryPointVolume>}> = (props) => {
          const {data} = props ?? {};

          return  postVolumesDeliveryPointVolume(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostVolumesDeliveryPointVolumeMutationResult = NonNullable<Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>>
    export type PostVolumesDeliveryPointVolumeMutationBody = NonReadonly<DeliveryPointVolume>
    export type PostVolumesDeliveryPointVolumeMutationError = PostVolumesDeliveryPointVolumeErrorType<unknown>

    export const usePostVolumesDeliveryPointVolume = <TError = PostVolumesDeliveryPointVolumeErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>, TError,{data: NonReadonly<DeliveryPointVolume>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVolumesDeliveryPointVolume>>,
        TError,
        {data: NonReadonly<DeliveryPointVolume>},
        TContext
      > => {
      return useMutation(getPostVolumesDeliveryPointVolumeMutationOptions(options));
    }
    /**
 * Получение потребности на ХАБ/РЦ по идентификатору
 */
export type getVolumesDeliveryPointVolumeIdResponse200 = {
  data: DeliveryPointVolume
  status: 200
}

export type getVolumesDeliveryPointVolumeIdResponseSuccess = (getVolumesDeliveryPointVolumeIdResponse200) & {
  headers: Headers;
};
;

export type getVolumesDeliveryPointVolumeIdResponse = (getVolumesDeliveryPointVolumeIdResponseSuccess)

export const getGetVolumesDeliveryPointVolumeIdUrl = (id: number,) => {


  

  return `/api/volumes/delivery_point_volume/${id}/`
}

export const getVolumesDeliveryPointVolumeId = async (id: number, options?: RequestInit): Promise<getVolumesDeliveryPointVolumeIdResponse> => {
  
  return getVolumesDeliveryPointVolumeIdMutator<getVolumesDeliveryPointVolumeIdResponse>(getGetVolumesDeliveryPointVolumeIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getGetVolumesDeliveryPointVolumeIdQueryKey = (id: number,) => {
    return [
    `/api/volumes/delivery_point_volume/${id}/`
    ] as const;
    }

    
export const getGetVolumesDeliveryPointVolumeIdQueryOptions = <TData = Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>, TError = GetVolumesDeliveryPointVolumeIdErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumesDeliveryPointVolumeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>> = ({ signal }) => getVolumesDeliveryPointVolumeId(id, { signal });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVolumesDeliveryPointVolumeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>>
export type GetVolumesDeliveryPointVolumeIdQueryError = GetVolumesDeliveryPointVolumeIdErrorType<unknown>



export function useGetVolumesDeliveryPointVolumeId<TData = Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>, TError = GetVolumesDeliveryPointVolumeIdErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVolumesDeliveryPointVolumeId>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVolumesDeliveryPointVolumeIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




export type putVolumesDeliveryPointVolumeIdResponse200 = {
  data: DeliveryPointVolume
  status: 200
}

export type putVolumesDeliveryPointVolumeIdResponseSuccess = (putVolumesDeliveryPointVolumeIdResponse200) & {
  headers: Headers;
};
;

export type putVolumesDeliveryPointVolumeIdResponse = (putVolumesDeliveryPointVolumeIdResponseSuccess)

export const getPutVolumesDeliveryPointVolumeIdUrl = (id: number,) => {


  

  return `/api/volumes/delivery_point_volume/${id}/`
}

export const putVolumesDeliveryPointVolumeId = async (id: number,
    deliveryPointVolume: NonReadonly<DeliveryPointVolume>, options?: RequestInit): Promise<putVolumesDeliveryPointVolumeIdResponse> => {
  
  return putVolumesDeliveryPointVolumeIdMutator<putVolumesDeliveryPointVolumeIdResponse>(getPutVolumesDeliveryPointVolumeIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deliveryPointVolume,)
  }
);}
  



export const getPutVolumesDeliveryPointVolumeIdMutationOptions = <TError = PutVolumesDeliveryPointVolumeIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>, TError,{id: number;data: NonReadonly<DeliveryPointVolume>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>, TError,{id: number;data: NonReadonly<DeliveryPointVolume>}, TContext> => {

const mutationKey = ['putVolumesDeliveryPointVolumeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>, {id: number;data: NonReadonly<DeliveryPointVolume>}> = (props) => {
          const {id,data} = props ?? {};

          return  putVolumesDeliveryPointVolumeId(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutVolumesDeliveryPointVolumeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>>
    export type PutVolumesDeliveryPointVolumeIdMutationBody = NonReadonly<DeliveryPointVolume>
    export type PutVolumesDeliveryPointVolumeIdMutationError = PutVolumesDeliveryPointVolumeIdErrorType<unknown>

    export const usePutVolumesDeliveryPointVolumeId = <TError = PutVolumesDeliveryPointVolumeIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>, TError,{id: number;data: NonReadonly<DeliveryPointVolume>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeId>>,
        TError,
        {id: number;data: NonReadonly<DeliveryPointVolume>},
        TContext
      > => {
      return useMutation(getPutVolumesDeliveryPointVolumeIdMutationOptions(options));
    }
    export type deleteVolumesDeliveryPointVolumeIdResponse204 = {
  data: void
  status: 204
}

export type deleteVolumesDeliveryPointVolumeIdResponseSuccess = (deleteVolumesDeliveryPointVolumeIdResponse204) & {
  headers: Headers;
};
;

export type deleteVolumesDeliveryPointVolumeIdResponse = (deleteVolumesDeliveryPointVolumeIdResponseSuccess)

export const getDeleteVolumesDeliveryPointVolumeIdUrl = (id: number,) => {


  

  return `/api/volumes/delivery_point_volume/${id}/`
}

export const deleteVolumesDeliveryPointVolumeId = async (id: number, options?: RequestInit): Promise<deleteVolumesDeliveryPointVolumeIdResponse> => {
  
  return deleteVolumesDeliveryPointVolumeIdMutator<deleteVolumesDeliveryPointVolumeIdResponse>(getDeleteVolumesDeliveryPointVolumeIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getDeleteVolumesDeliveryPointVolumeIdMutationOptions = <TError = DeleteVolumesDeliveryPointVolumeIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteVolumesDeliveryPointVolumeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteVolumesDeliveryPointVolumeId(id,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVolumesDeliveryPointVolumeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>>
    
    export type DeleteVolumesDeliveryPointVolumeIdMutationError = DeleteVolumesDeliveryPointVolumeIdErrorType<unknown>

    export const useDeleteVolumesDeliveryPointVolumeId = <TError = DeleteVolumesDeliveryPointVolumeIdErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>, TError,{id: number}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVolumesDeliveryPointVolumeId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteVolumesDeliveryPointVolumeIdMutationOptions(options));
    }
    export type putVolumesDeliveryPointVolumeIdKmtsResponse200 = {
  data: DeliveryPointVolumeKMTS
  status: 200
}

export type putVolumesDeliveryPointVolumeIdKmtsResponseSuccess = (putVolumesDeliveryPointVolumeIdKmtsResponse200) & {
  headers: Headers;
};
;

export type putVolumesDeliveryPointVolumeIdKmtsResponse = (putVolumesDeliveryPointVolumeIdKmtsResponseSuccess)

export const getPutVolumesDeliveryPointVolumeIdKmtsUrl = (id: number,) => {


  

  return `/api/volumes/delivery_point_volume/${id}/kmts/`
}

export const putVolumesDeliveryPointVolumeIdKmts = async (id: number,
    deliveryPointVolumeKMTS: NonReadonly<DeliveryPointVolumeKMTS>, options?: RequestInit): Promise<putVolumesDeliveryPointVolumeIdKmtsResponse> => {
  
  return putVolumesDeliveryPointVolumeIdKmtsMutator<putVolumesDeliveryPointVolumeIdKmtsResponse>(getPutVolumesDeliveryPointVolumeIdKmtsUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deliveryPointVolumeKMTS,)
  }
);}
  



export const getPutVolumesDeliveryPointVolumeIdKmtsMutationOptions = <TError = PutVolumesDeliveryPointVolumeIdKmtsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>, TError,{id: number;data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>, TError,{id: number;data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext> => {

const mutationKey = ['putVolumesDeliveryPointVolumeIdKmts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>, {id: number;data: NonReadonly<DeliveryPointVolumeKMTS>}> = (props) => {
          const {id,data} = props ?? {};

          return  putVolumesDeliveryPointVolumeIdKmts(id,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutVolumesDeliveryPointVolumeIdKmtsMutationResult = NonNullable<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>>
    export type PutVolumesDeliveryPointVolumeIdKmtsMutationBody = NonReadonly<DeliveryPointVolumeKMTS>
    export type PutVolumesDeliveryPointVolumeIdKmtsMutationError = PutVolumesDeliveryPointVolumeIdKmtsErrorType<unknown>

    export const usePutVolumesDeliveryPointVolumeIdKmts = <TError = PutVolumesDeliveryPointVolumeIdKmtsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>, TError,{id: number;data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof putVolumesDeliveryPointVolumeIdKmts>>,
        TError,
        {id: number;data: NonReadonly<DeliveryPointVolumeKMTS>},
        TContext
      > => {
      return useMutation(getPutVolumesDeliveryPointVolumeIdKmtsMutationOptions(options));
    }
    export type postVolumesDeliveryPointVolumeKmtsResponse200 = {
  data: DeliveryPointVolumeKMTS
  status: 200
}

export type postVolumesDeliveryPointVolumeKmtsResponseSuccess = (postVolumesDeliveryPointVolumeKmtsResponse200) & {
  headers: Headers;
};
;

export type postVolumesDeliveryPointVolumeKmtsResponse = (postVolumesDeliveryPointVolumeKmtsResponseSuccess)

export const getPostVolumesDeliveryPointVolumeKmtsUrl = () => {


  

  return `/api/volumes/delivery_point_volume/kmts/`
}

export const postVolumesDeliveryPointVolumeKmts = async (deliveryPointVolumeKMTS: NonReadonly<DeliveryPointVolumeKMTS>, options?: RequestInit): Promise<postVolumesDeliveryPointVolumeKmtsResponse> => {
  
  return postVolumesDeliveryPointVolumeKmtsMutator<postVolumesDeliveryPointVolumeKmtsResponse>(getPostVolumesDeliveryPointVolumeKmtsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deliveryPointVolumeKMTS,)
  }
);}
  



export const getPostVolumesDeliveryPointVolumeKmtsMutationOptions = <TError = PostVolumesDeliveryPointVolumeKmtsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>, TError,{data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>, TError,{data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext> => {

const mutationKey = ['postVolumesDeliveryPointVolumeKmts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>, {data: NonReadonly<DeliveryPointVolumeKMTS>}> = (props) => {
          const {data} = props ?? {};

          return  postVolumesDeliveryPointVolumeKmts(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostVolumesDeliveryPointVolumeKmtsMutationResult = NonNullable<Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>>
    export type PostVolumesDeliveryPointVolumeKmtsMutationBody = NonReadonly<DeliveryPointVolumeKMTS>
    export type PostVolumesDeliveryPointVolumeKmtsMutationError = PostVolumesDeliveryPointVolumeKmtsErrorType<unknown>

    export const usePostVolumesDeliveryPointVolumeKmts = <TError = PostVolumesDeliveryPointVolumeKmtsErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>, TError,{data: NonReadonly<DeliveryPointVolumeKMTS>}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postVolumesDeliveryPointVolumeKmts>>,
        TError,
        {data: NonReadonly<DeliveryPointVolumeKMTS>},
        TContext
      > => {
      return useMutation(getPostVolumesDeliveryPointVolumeKmtsMutationOptions(options));
    }
    